import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import MainLayout from "../layout/MainLayout";

import { useLocation } from "react-router-dom";
import { API_BASE } from "../config/orbisConfig";




const TIPOS_PROYECTO = [
    "estrategico",
    "operativo",
    "tecnologico",
    "comercial",
    "institucional",
    "transformacion_digital",
    "infraestructura",
    "innovacion",
    "capacitacion",
    "cumplimiento",
    "mejora_interna",
    "otro",
];

const ETAPAS_PROYECTO = [
    "inicio",
    "planeacion",
    "ejecucion",
    "monitoreo",
    "cierre",
    "cancelado",
];

const ESTATUS_PROYECTO = [
    "activo",
    "pausado",
    "terminado",
    "cancelado",
];
const TASK_DEPENDENCY_TYPES = [
    {
        value: "FS",
        label: "Fin a Inicio (FS) — la anterior termina y esta inicia",
        short: "La tarea anterior debe terminar para que esta pueda iniciar.",
        example: "Ejemplo: terminar diseño antes de iniciar desarrollo.",
    },
    {
        value: "SS",
        label: "Inicio a Inicio (SS) — ambas pueden iniciar juntas",
        short: "Esta tarea puede iniciar cuando la tarea anterior también inicia.",
        example: "Ejemplo: iniciar supervisión al mismo tiempo que inicia ejecución.",
    },
    {
        value: "FF",
        label: "Fin a Fin (FF) — ambas deben terminar relacionadas",
        short: "Esta tarea solo puede terminar cuando la tarea anterior termina.",
        example: "Ejemplo: cerrar validación cuando termina la implementación.",
    },
    {
        value: "SF",
        label: "Inicio a Fin (SF) — poco común",
        short: "Esta tarea termina cuando la tarea anterior inicia. Es poco común.",
        example: "Ejemplo: cerrar turno anterior cuando inicia el nuevo turno.",
    },
];
function getDependencyTypeInfo(value) {
    return (
        TASK_DEPENDENCY_TYPES.find((item) => item.value === value) ||
        TASK_DEPENDENCY_TYPES[0]
    );
}
const SALUD_PROYECTO = [
    "verde",
    "amarillo",
    "rojo",
];

const PRIORIDADES = [
    "baja",
    "media",
    "alta",
    "critica",
];

const RIESGO_PROYECTO = [
    "bajo",
    "medio",
    "alto",
];

const ESTATUS_TAREA = [
    "pendiente",
    "en_proceso",
    "bloqueada",
    "terminada",
    "cancelada",
];

const ESTATUS_RIESGO = [
    "abierto",
    "en_monitoreo",
    "mitigado",
    "cerrado",
];

const PROBABILIDAD_RIESGO = [
    "baja",
    "media",
    "alta",
    "critica",
];

const IMPACTO_RIESGO = [
    "bajo",
    "medio",
    "alto",
    "critico",
];

const ESTRATEGIAS_RIESGO = [
    "Evitar",
    "Mitigar",
    "Transferir",
    "Aceptar",
    "Escalar",
    "Monitorear",
];

const ESTATUS_ENTREGABLE = [
    "pendiente",
    "en_progreso",
    "enviado",
    "aprobado",
    "rechazado",
];

const TIPOS_ENTREGABLE = [
    "documento",
    "acta",
    "reporte",
    "analisis",
    "cronograma",
    "presupuesto",
    "propuesta",
    "evidencia",
    "presentacion",
    "entregable_tecnico",
    "entregable_funcional",
    "aprobacion",
    "capacitacion",
    "cierre",
    "otro",
];

const ESTATUS_AVANCE = [
    "activo",
    "pausado",
    "terminado",
    "cancelado",
];


const FICHA360_GUIDE = {
    overview: { label: "Resumen", question: "¿Dónde mirar primero?", tooltip: "Lectura rápida del estado, presión, avance, riesgos y señales principales del proyecto.", perm: "can_view_project" },
    project: { label: "Proyecto", question: "¿De qué trata y quién lo gobierna?", tooltip: "Datos generales, responsables, sponsor, etapa, estado y contexto ejecutivo del proyecto.", perm: "can_view_project" },
    scope: { label: "Alcance", question: "¿Qué vamos a lograr o entregar?", tooltip: "Define qué incluye el proyecto, sus entregables, criterios de aceptación y exclusiones.", perm: "can_view_scope" },
    budget: { label: "Presupuesto", question: "¿Cuánto cuesta o cuánto invertimos?", tooltip: "Resume presupuesto planeado, actual, valor contractual, justificación y notas financieras.", perm: "can_view_project" },
    time: { label: "Tiempo", question: "¿Cuándo debe lograrse?", tooltip: "Muestra fechas planeadas, fechas reales, vencimientos y presión de calendario.", perm: "can_view_project" },
    value: { label: "Valor esperado", question: "¿Qué beneficio genera al terminar?", tooltip: "Explica el valor económico, operativo, social, estratégico o de cumplimiento esperado.", perm: "can_view_project" },
    updates: { label: "Avances", question: "¿Qué se ha reportado y con qué evidencia?", tooltip: "Actualizaciones, comentarios, progreso registrado y soporte documental del avance.", perm: "can_view_updates" },
    milestones: { label: "Milestones", question: "¿Cuáles son los puntos clave de control?", tooltip: "Hitos, fechas críticas, gates de decisión y compromisos ejecutivos del proyecto.", perm: "can_view_tasks" },
    tasks: { label: "Tareas WBS", question: "¿Cómo se descompone el trabajo?", tooltip: "Tareas, responsables, dependencias, revisión, evidencia y avance operativo.", perm: "can_view_tasks" },
    risks: { label: "Riesgos", question: "¿Qué puede impedir el éxito?", tooltip: "Amenazas, probabilidad, impacto, nivel de riesgo, responsables y mitigación.", perm: "can_view_risks" },
    deliverables: { label: "Entregables", question: "¿Qué productos deben quedar completos?", tooltip: "Productos, resultados comprometidos, fechas, responsables y evidencia de cumplimiento.", perm: "can_view_deliverables" },
    areas: { label: "Áreas", question: "¿Qué frentes de trabajo participan?", tooltip: "Áreas, disciplinas o workstreams para ordenar responsabilidades y seguimiento.", perm: "can_view_project" },
    stakeholders: { label: "Stakeholders", question: "¿Quiénes influyen o son impactados?", tooltip: "Personas, instituciones o grupos clave, influencia, interés y estrategia de gestión.", perm: "can_view_stakeholders" },
    documents: { label: "Documentos", question: "¿Dónde está la evidencia formal?", tooltip: "Archivos, reportes, evidencias, actas, imágenes, contratos y documentos del proyecto.", perm: "can_view_documents" },
    access: { label: "Accesos", question: "¿Quién puede ver o intervenir?", tooltip: "Permisos, usuarios con acceso, consulta, intervención o seguimiento del proyecto.", perm: "can_view_project" },
    closure: { label: "Cierre", question: "¿Cómo confirmamos que terminó correctamente?", tooltip: "Aceptación, resultados finales, cierre administrativo, lecciones aprendidas y valor logrado.", perm: "can_view_project" },
};

const FICHA360_NAV_ORDER = [
    "overview",
    "project",
    "scope",
    "budget",
    "time",
    "value",
    "updates",
    "milestones",
    "tasks",
    "risks",
    "deliverables",
    "areas",
    "stakeholders",
    "documents",
    "access",
    "closure",
];

function getTabGuide(key) {
    return FICHA360_GUIDE[key] || { label: key, question: "", tooltip: "", perm: "can_view_project" };
}

const emptyProjectForm = {
    id: "",
    account_id: "",
    opportunity_id: "",
    name: "",
    code: "",
    description: "",
    project_type: "estrategico",
    priority: "media",
    project_manager_user_id: "",
    sponsor_user_id: "",
    created_by_user_id: "",
    stage: "inicio",
    status: "activo",
    health_status: "verde",
    progress_percent: 0,
    planned_start_date: "",
    planned_end_date: "",
    actual_start_date: "",
    actual_end_date: "",
    start_date: "",
    end_date: "",
    strategic_impact: "",
    esg_focus: "",
    success_criteria: "",
    risk_level: "medio",
    notes: "",
};

const emptyBudgetForm = {
    id: "",
    account_id: "",
    opportunity_id: "",
    contract_value: "",
    budget_planned: "",
    budget_actual: "",
    currency: "MXN",
    ebitda_impact_est: "",
    budget_description: "",
    budget_justification: "",
    budget_notes: "",
};

const emptyUpdateForm = {
    id: "",
    project_id: "",
    update_date: "",
    title: "",
    summary: "",
    description: "",
    progress_percent: "",
    status: "activo",
    status_note: "",
    created_by: "",
};

const emptyTaskForm = {
    id: "",
    project_id: "",
    parent_task_id: "",
    depends_on_task_id: "",
    dependency_type: "FS",
    lag_days: 0,

    wbs_code: "",
    name: "",
    description: "",

    status: "pendiente",
    priority: "media",
    start_date: "",
    due_date: "",
    end_date: "",
    progress_percent: 0,

    owner_user_id: "",
    reviewer_user_id: "",

    requires_review: 1,
    review_status: "borrador",

    evidence_required: 0,
    geo_evidence_required: 0,
    reviewer_evidence_required: 0,
    reviewer_geo_evidence_required: 0,

    area_id: "",
};

const emptyRiskForm = {
    id: "",
    project_id: "",
    risk_title: "",
    description: "",
    probability: "media",
    impact: "medio",
    risk_level: "medio",
    mitigation_plan: "",
    status: "abierto",
    response_strategy: "",
    owner_user_id: "",
    owner_name: "",
};

const emptyMilestoneForm = {
    id: "",
    project_id: "",
    title: "",
    description: "",
    milestone_type: "control",
    status: "pendiente",
    health_status: "verde",
    target_date: "",
    actual_date: "",
    related_task_id: "",
    related_deliverable_id: "",
    owner_user_id: "",
    decision_gate: 0,
    success_criteria: "",
    executive_impact: "",
    notes: "",
};

const emptyDeliverableForm = {
    id: "",
    project_id: "",
    name: "",
    description: "",
    deliverable_type: "documento",
    planned_date: "",
    actual_date: "",
    status: "pendiente",
    owner_user_id: "",
};

const DOCUMENT_SECTION_OPTIONS = [
    { value: "project", label: "Proyecto" },
    { value: "update", label: "Avances" },
    { value: "task", label: "Tareas" },
    { value: "risk", label: "Riesgos" },
    { value: "deliverable", label: "Entregables" },
    { value: "stakeholder", label: "Stakeholders" },
    { value: "area", label: "Áreas" },
    { value: "scope", label: "Alcance" },
];

const DOCUMENT_CATEGORY_OPTIONS = [
    "documento",
    "imagen",
    "evidencia",
    "acta",
    "reporte",
    "análisis",
    "cronograma",
    "presupuesto",
    "propuesta",
    "otro",
];

const emptyDocumentForm = {
    id: "",
    project_id: "",
    section_type: "project",
    section_id: "",
    document_category: "documento",
    title: "",
    description: "",
    file_name: "",
    file_type: "",
    file_path: "",
    file_url: "",
    uploaded_by_user_id: "",
};

const emptyScopeForm = {
    project_id: "",
    project_objective: "",
    product_scope: "",
    deliverables: "",
    acceptance_criteria: "",
    exclusions: "",
    created_by_user_id: "",
};


const STAKEHOLDER_TYPES = [
    "interno",
    "externo",
    "cliente",
    "proveedor",
    "gobierno",
    "usuario",
];

const AREA_LEVELS = [
    "nivel_1",
    "nivel_2",
    "nivel_3",
];

const AREA_PRIORITIES = [
    "baja",
    "media",
    "alta",
    "critica",
];

const emptyAreaForm = {
    id: "",
    project_id: "",
    parent_area_id: "",
    name: "",
    description: "",
    level: "nivel_1",
    priority: "media",
    owner_user_id: "",
    health_status: "verde",
    progress_percent: 0,
    notes: "",
};


const emptyStakeholderForm = {
    id: "",
    project_id: "",
    user_id: "",
    name: "",
    role: "",
    stakeholder_type: "interno",
    company: "",
    email: "",
    phone: "",
    whatsapp: "",
    influence_level: "media",
    interest_level: "medio",
    is_primary_contact: false,
    photo_url: "",
    notes: "",
};



function getLogTitle(log) {
    const action = (log.action_type || "").toLowerCase();

    switch (action) {
        case "actualizacion_avance":
            return "Avance actualizado";
        case "enviado_revision":
            return "Enviado a revisión";
        case "aprobado":
            return "Avance aprobado";
        case "rechazado":
            return "Avance rechazado";
        case "solicitud_cambios":
        case "con_cambios":
            return "Cambios solicitados";
        case "comentario":
            return "Comentario";
        default:
            return log.action_label || log.action_type || "Movimiento";
    }
}

function getLogDotColor(log) {
    const action = (log.action_type || "").toLowerCase();
    const review = (log.review_status || "").toLowerCase();

    if (action === "aprobado" || review === "aprobado") return "#10b981";
    if (action === "rechazado" || review === "rechazado") return "#ef4444";
    if (action === "solicitud_cambios" || review === "con_cambios") return "#f97316";
    if (action === "enviado_revision" || review === "pendiente_revision") return "#f59e0b";
    if (action === "actualizacion_avance") return "#2563eb";

    return "#9ca3af";
}

function getLogSummary(log) {
    const oldP = log.old_progress_percent;
    const newP = log.new_progress_percent;
    const oldS = log.old_status;
    const newS = log.new_status;

    const parts = [];

    if (oldP !== null && oldP !== undefined && newP !== null && newP !== undefined && String(oldP) !== String(newP)) {
        parts.push(`Avance ${oldP}% → ${newP}%`);
    }

    if (oldS && newS && oldS !== newS) {
        parts.push(`Estatus ${oldS} → ${newS}`);
    }

    return parts.join(" · ");
}

function getLogComment(log) {
    const action = (log.action_type || "").toLowerCase();
    const comment = (log.comment || "").trim();

    if (comment) return comment;

    switch (action) {
        case "actualizacion_avance":
            return "Se registró avance en la tarea.";
        case "enviado_revision":
            return "La tarea fue enviada a revisión.";
        case "aprobado":
            return "La revisión fue aprobada.";
        case "rechazado":
            return "La revisión fue rechazada.";
        case "solicitud_cambios":
        case "con_cambios":
            return "Se solicitaron cambios.";
        default:
            return "Sin comentario";
    }
}

function HealthBadge({ health, label }) {
    const value = String(health || "").toLowerCase();
    const map = {
        verde: { bg: "rgba(16,185,129,.16)", color: "#bbf7d0", border: "rgba(16,185,129,.38)", dot: "#22c55e", text: "En control" },
        amarillo: { bg: "rgba(244,185,27,.18)", color: "#fde68a", border: "rgba(244,185,27,.42)", dot: "#f59e0b", text: "En atención" },
        rojo: { bg: "rgba(239,68,68,.16)", color: "#fecaca", border: "rgba(239,68,68,.42)", dot: "#ef4444", text: "Crítico" },
        activo: { bg: "rgba(14,165,233,.14)", color: "#7dd3fc", border: "rgba(125,211,252,.28)", dot: "#38bdf8", text: "Activo" },
        abierta: { bg: "rgba(14,165,233,.14)", color: "#7dd3fc", border: "rgba(125,211,252,.28)", dot: "#38bdf8", text: "Abierta" },
        abierto: { bg: "rgba(14,165,233,.14)", color: "#7dd3fc", border: "rgba(125,211,252,.28)", dot: "#38bdf8", text: "Abierto" },
        pendiente: { bg: "rgba(244,185,27,.18)", color: "#fde68a", border: "rgba(244,185,27,.42)", dot: "#f59e0b", text: "Pendiente" },
        en_proceso: { bg: "rgba(14,165,233,.14)", color: "#7dd3fc", border: "rgba(125,211,252,.28)", dot: "#38bdf8", text: "En proceso" },
        aprobado: { bg: "rgba(16,185,129,.16)", color: "#bbf7d0", border: "rgba(16,185,129,.38)", dot: "#22c55e", text: "Aprobado" },
        terminada: { bg: "rgba(16,185,129,.16)", color: "#bbf7d0", border: "rgba(16,185,129,.38)", dot: "#22c55e", text: "Terminada" },
        terminado: { bg: "rgba(16,185,129,.16)", color: "#bbf7d0", border: "rgba(16,185,129,.38)", dot: "#22c55e", text: "Terminado" },
        cancelada: { bg: "rgba(148,163,184,.13)", color: "#cbd5e1", border: "rgba(148,163,184,.26)", dot: "#94a3b8", text: "Cancelada" },
        cancelado: { bg: "rgba(148,163,184,.13)", color: "#cbd5e1", border: "rgba(148,163,184,.26)", dot: "#94a3b8", text: "Cancelado" },
    };
    const cfg = map[value] || {
        bg: "rgba(14,165,233,.14)",
        color: "#7dd3fc",
        border: "rgba(125,211,252,.28)",
        dot: "#38bdf8",
        text: normalizeLabel(label || health || "—"),
    };

    return (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 7,
                padding: "6px 11px",
                borderRadius: 999,
                background: cfg.bg,
                color: cfg.color,
                border: `1px solid ${cfg.border}`,
                fontSize: 12,
                fontWeight: 900,
                lineHeight: 1,
                whiteSpace: "nowrap",
            }}
        >
            <span
                style={{
                    width: 7,
                    height: 7,
                    borderRadius: "50%",
                    background: cfg.dot,
                    display: "inline-block",
                }}
            />
            {label || cfg.text}
        </span>
    );
}

function parseDateSafe(value) {
    if (!value || value === "0000-00-00" || value === "0000-00-00 00:00:00") return null;

    const raw = String(value).trim();

    // MySQL DATE llega como YYYY-MM-DD.
    // new Date("2026-05-30") se interpreta en UTC y puede mostrarse como 29 may en México.
    const dateOnly = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnly) {
        const [, y, m, d] = dateOnly;
        return new Date(Number(y), Number(m) - 1, Number(d), 12, 0, 0);
    }

    const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
    const parsed = new Date(normalized);

    return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function formatHumanDate(value, fallback = "—") {
    const d = parseDateSafe(value);
    if (!d) return fallback;

    return d.toLocaleDateString("es-MX", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    }).replace(".", "");
}

function formatHumanDateTime(value, fallback = "—") {
    const d = parseDateSafe(value);
    if (!d) return fallback;

    return d.toLocaleString("es-MX", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    }).replace(".", "");
}

function formatMonthYear(value) {
    const d = value instanceof Date ? value : parseDateSafe(value);
    if (!d) return "—";

    return d.toLocaleDateString("es-MX", {
        month: "short",
        year: "numeric",
    }).replace(".", "");
}

function diffDaysSafe(start, end) {
    const s = parseDateSafe(start);
    const e = parseDateSafe(end);
    if (!s || !e) return null;

    return Math.max(0, Math.round((e.getTime() - s.getTime()) / 86400000));
}


function TimelineBar({ label, start, end, accent = "#2563eb", muted = false }) {
    const startLabel = formatMonthYear(start);
    const endLabel = formatMonthYear(end);
    const days = diffDaysSafe(start, end);
    const hasRange = startLabel !== "—" && endLabel !== "—";

    return (
        <div style={{ marginBottom: 20 }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 12,
                    alignItems: "center",
                    marginBottom: 8,
                }}
            >
                <div style={{ fontSize: 12, fontWeight: 900, color: "#7dd3fc", letterSpacing: ".04em", textTransform: "uppercase" }}>{label}</div>
                <div style={{ fontSize: 12, color: "#b9e8ff", fontWeight: 800 }}>
                    {days !== null ? `${days} días` : "Sin rango completo"}
                </div>
            </div>

            <div
                style={{
                    height: 12,
                    borderRadius: 999,
                    background: "rgba(148,163,184,.25)",
                    overflow: "hidden",
                    position: "relative",
                    border: "1px solid rgba(125,211,252,.12)",
                }}
                title={`${label}: ${startLabel} a ${endLabel}`}
            >
                <div
                    style={{
                        width: hasRange ? "100%" : "0%",
                        height: "100%",
                        borderRadius: 999,
                        background: muted ? "#64748b" : accent,
                        opacity: hasRange ? 1 : 0.25,
                    }}
                />
            </div>

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 12,
                    marginTop: 7,
                    color: "#b9e8ff",
                    fontSize: 12,
                    fontWeight: 800,
                }}
            >
                <span>{startLabel}</span>
                <span>{endLabel}</span>
            </div>
        </div>
    );
}

function ProjectTimeComparison({ project, tasks }) {
    const plannedStart = project?.planned_start_date || project?.start_date;
    const plannedEnd = project?.planned_end_date || project?.end_date;
    const realStart = project?.actual_start_date || project?.start_date;
    const realEnd = project?.actual_end_date || project?.end_date;

    const plannedDays = diffDaysSafe(plannedStart, plannedEnd);
    const realDays = diffDaysSafe(realStart, realEnd);
    const overdueTasks = (tasks || []).filter((t) => {
        if (!t.due_date) return false;
        if (t.status === "terminada" || t.status === "cancelada") return false;
        return new Date(t.due_date) < new Date();
    }).length;

    let reading = "Compara la línea planificada contra la línea real para detectar desviaciones de tiempo.";
    if (plannedDays !== null && realDays !== null) {
        if (realDays > plannedDays) {
            reading = `La duración real supera la planeada por ${realDays - plannedDays} día(s). Revisa impacto en entregables, riesgos y ruta crítica.`;
        } else if (realDays < plannedDays) {
            reading = `La duración real es menor que la planeada por ${plannedDays - realDays} día(s). Valida que el avance tenga evidencia suficiente.`;
        } else {
            reading = "La duración real coincide con la duración planeada. Mantén seguimiento sobre vencimientos y dependencias.";
        }
    } else if (overdueTasks > 0) {
        reading = `Existen ${overdueTasks} tarea(s) vencida(s). La presión de calendario debe revisarse en WBS y riesgos.`;
    }

    return (
        <div
            style={{
                marginTop: 18,
                border: "1px solid rgba(0,178,255,.24)",
                borderRadius: 18,
                padding: 18,
                background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                boxShadow: "0 14px 30px rgba(0,0,0,.18)",
            }}
        >
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap", marginBottom: 14 }}>
                <div>
                    <div style={{ fontSize: 16, fontWeight: 900, color: "#ffffff" }}>
                        Línea de tiempo del proyecto
                        <PmoHelp text="Compara el periodo planificado contra el periodo real del proyecto. Sirve para detectar desviación de calendario." />
                    </div>
                    <div style={{ fontSize: 12, color: "#b9e8ff", marginTop: 4, fontWeight: 600 }}>
                        Vista ejecutiva tipo Gantt: planeado vs real.
                    </div>
                </div>

                <PmoBadge tone={overdueTasks > 0 ? "red" : "green"} tooltip="Tareas vencidas pendientes dentro del proyecto.">
                    {overdueTasks} tarea(s) vencida(s)
                </PmoBadge>
            </div>

            <TimelineBar
                label="Planificado"
                start={plannedStart}
                end={plannedEnd}
                accent="#2563eb"
            />

            <TimelineBar
                label="Real"
                start={realStart}
                end={realEnd}
                accent="#7c3aed"
                muted={!realStart && !realEnd}
            />

            <div
                style={{
                    marginTop: 12,
                    padding: 12,
                    borderRadius: 14,
                    background: "rgba(255,255,255,.04)",
                    border: "1px solid rgba(125,211,252,.18)",
                    color: "#d7efff",
                    fontSize: 13,
                    fontWeight: 650,
                    lineHeight: 1.5,
                }}
            >
                {reading}
            </div>
        </div>
    );
}

function inferValueType(project) {
    const text = `${project?.strategic_impact || ""} ${project?.esg_focus || ""} ${project?.success_criteria || ""}`.toLowerCase();
    const hasEconomic = Number(project?.ebitda_impact_est || 0) > 0 || /venta|ingreso|ahorro|margen|rentabilidad|econ[oó]mico|presupuesto|costo/.test(text);
    const hasSocial = /social|ciudadano|comunidad|ambiental|esg|salud|p[úu]blico|gobierno/.test(text);
    const hasOperational = /operaci[oó]n|proceso|producci[oó]n|calidad|eficiencia|tiempo|capacidad/.test(text);
    const hasCompliance = /cumplimiento|norma|permiso|legal|regulatorio|ambiental/.test(text);

    const types = [];
    if (hasEconomic) types.push("Económico");
    if (hasOperational) types.push("Operativo");
    if (hasSocial) types.push("Social / ESG");
    if (hasCompliance) types.push("Cumplimiento");

    return types.length ? types.join(" · ") : "Estratégico";
}

function getValueCompleteness(project) {
    const checks = [
        !!String(project?.strategic_impact || "").trim(),
        Number(project?.ebitda_impact_est || 0) > 0,
        !!String(project?.esg_focus || "").trim(),
        !!String(project?.success_criteria || "").trim(),
    ];

    const done = checks.filter(Boolean).length;
    return Math.round((done / checks.length) * 100);
}

function ValueReadinessBadge({ percent }) {
    let tone = "red";
    let label = "Valor por definir";

    if (percent >= 75) {
        tone = "green";
        label = "Valor bien definido";
    } else if (percent >= 50) {
        tone = "yellow";
        label = "Valor parcialmente definido";
    }

    return (
        <PmoBadge
            tone={tone}
            tooltip="Nivel de claridad del valor esperado usando impacto estratégico, valor económico, ESG y criterios de éxito."
        >
            {label} · {percent}%
        </PmoBadge>
    );
}


function ValueDimensionCard({ title, question, value, subtitle, tone = "blue", children }) {
    return (
        <div
            style={{
                border: "1px solid rgba(0,178,255,.24)",
                borderRadius: 18,
                padding: 16,
                background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                minHeight: 150,
                boxShadow: "0 12px 28px rgba(0,0,0,.18)",
            }}
        >
            <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "start" }}>
                <div>
                    <div style={{ fontSize: 13, fontWeight: 900, color: "#ffffff" }}>{title}</div>
                    <div style={{ fontSize: 11, color: "#b9e8ff", marginTop: 3, fontWeight: 600 }}>{question}</div>
                </div>
                <PmoBadge tone={tone}>{subtitle}</PmoBadge>
            </div>

            <div style={{ marginTop: 12, fontSize: 14, color: "#ffffff", lineHeight: 1.55, fontWeight: 700 }}>
                {value || "—"}
            </div>

            {children ? <div style={{ marginTop: 12 }}>{children}</div> : null}
        </div>
    );
}


function ProjectValueExpectedPanel({ project }) {
    const valueType = inferValueType(project);
    const completeness = getValueCompleteness(project);
    const economicValue = Number(project?.ebitda_impact_est || 0);

    return (
        <div style={{ display: "grid", gap: 14 }}>
            <div
                style={{
                    border: "1px solid rgba(139,92,246,.38)",
                    borderRadius: 18,
                    padding: 18,
                    background: "linear-gradient(180deg, rgba(88,28,135,.36), rgba(2,25,48,.96))",
                    boxShadow: "0 14px 30px rgba(0,0,0,.18)",
                }}
            >
                <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap", alignItems: "start" }}>
                    <div>
                        <div style={{ fontSize: 12, fontWeight: 900, color: "#c4b5fd", textTransform: "uppercase", letterSpacing: ".06em" }}>
                            Lectura de valor
                        </div>
                        <div style={{ fontSize: 20, color: "#ffffff", fontWeight: 900, marginTop: 4 }}>
                            ¿Por qué existe este proyecto?
                        </div>
                        <div style={{ fontSize: 13, color: "#d7efff", lineHeight: 1.55, marginTop: 6, maxWidth: 820, fontWeight: 600 }}>
                            Un proyecto no se justifica solo por tareas, compras o entregables. Se justifica por el valor que genera al terminar:
                            beneficio económico, capacidad operativa, cumplimiento, impacto social o ventaja estratégica.
                        </div>
                    </div>

                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>
                        <PmoBadge tone="purple" tooltip="Tipo de valor inferido a partir de la información capturada.">
                            {valueType}
                        </PmoBadge>
                        <ValueReadinessBadge percent={completeness} />
                    </div>
                </div>
            </div>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
                    gap: 14,
                }}
            >
                <ValueDimensionCard
                    title="Impacto estratégico"
                    question="¿Qué cambia para la organización?"
                    value={project?.strategic_impact}
                    subtitle="Estrategia"
                    tone="purple"
                />

                <ValueDimensionCard
                    title="Valor económico estimado"
                    question="¿Qué beneficio financiero puede generar?"
                    value={economicValue > 0 ? formatMoney(economicValue, project?.currency || "MXN") : "Sin estimación económica capturada"}
                    subtitle="Económico"
                    tone={economicValue > 0 ? "green" : "yellow"}
                />

                <ValueDimensionCard
                    title="Valor social / ESG"
                    question="¿Qué impacto social, ambiental o institucional produce?"
                    value={project?.esg_focus}
                    subtitle="ESG"
                    tone="green"
                />

                <ValueDimensionCard
                    title="Criterios de éxito"
                    question="¿Cómo sabremos que el valor fue logrado?"
                    value={project?.success_criteria}
                    subtitle="Éxito"
                    tone={project?.success_criteria ? "blue" : "yellow"}
                />
            </div>

            <div
                style={{
                    border: "1px solid rgba(125,211,252,.18)",
                    borderRadius: 16,
                    padding: 16,
                    background: "rgba(255,255,255,.04)",
                }}
            >
                <div style={{ fontSize: 13, color: "#ffffff", fontWeight: 850, marginBottom: 6 }}>
                    Notas de valor
                    <PmoHelp text="Espacio para explicar beneficios, supuestos, impactos no financieros o aprendizaje esperado del proyecto." />
                </div>
                <div style={{ fontSize: 14, color: "#d7efff", lineHeight: 1.55, fontWeight: 600 }}>
                    {project?.notes || "Sin notas de valor capturadas."}
                </div>
            </div>
        </div>
    );
}

function getMilestoneTone(status, health) {
    const s = String(status || "").toLowerCase();
    const h = String(health || "").toLowerCase();

    if (s === "cumplido") return "green";
    if (s === "cancelado") return "gray";
    if (s === "retrasado" || s === "en_riesgo" || h === "rojo") return "red";
    if (s === "en_proceso" || h === "amarillo") return "yellow";
    return "blue";
}

function getMilestoneTypeLabel(type) {
    const map = {
        control: "Control",
        decision: "Decisión",
        entrega: "Entrega",
        validacion: "Validación",
        fase: "Fase",
        cierre: "Cierre",
    };
    return map[type] || normalizeLabel(type);
}

function MilestoneTimelineDot({ item }) {
    const tone = getMilestoneTone(item.status, item.health_status);
    const colorMap = {
        green: "#22c55e",
        yellow: "#f59e0b",
        red: "#ef4444",
        blue: "#2563eb",
        gray: "#64748b",
    };
    const color = colorMap[tone] || colorMap.blue;

    return (
        <div
            title={`${item.title || "Hito"} · ${normalizeLabel(item.status)}`}
            style={{
                width: 18,
                height: 18,
                borderRadius: "50%",
                background: color,
                border: "3px solid #fff",
                boxShadow: "0 0 0 2px rgba(15,23,42,.12)",
                flex: "0 0 auto",
            }}
        />
    );
}

function MilestoneExecutiveTimeline({ items }) {
    if (!items || items.length === 0) {
        return (
            <div
                style={{
                    border: "1px dashed rgba(125,211,252,.32)",
                    borderRadius: 16,
                    padding: 18,
                    color: "#b9e8ff",
                    background: "linear-gradient(180deg, rgba(8,47,73,.72), rgba(2,25,48,.92))",
                }}
            >
                No hay milestones registrados para este proyecto.
            </div>
        );
    }

    const ordered = [...items].sort((a, b) => {
        const da = parseDateSafe(a.target_date)?.getTime() || Number.MAX_SAFE_INTEGER;
        const db = parseDateSafe(b.target_date)?.getTime() || Number.MAX_SAFE_INTEGER;
        return da - db;
    });

    return (
        <div
            style={{
                border: "1px solid rgba(0,178,255,.24)",
                borderRadius: 18,
                padding: 18,
                background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                marginBottom: 18,
                boxShadow: "0 14px 30px rgba(0,0,0,.18)",
            }}
        >
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap", marginBottom: 18 }}>
                <div>
                    <div style={{ fontSize: 16, fontWeight: 900, color: "#ffffff" }}>
                        Línea ejecutiva de hitos
                        <PmoHelp text="Vista de control ejecutivo: muestra los hitos ordenados por fecha objetivo y su estado de salud." />
                    </div>
                    <div style={{ fontSize: 12, color: "#b9e8ff", marginTop: 4, fontWeight: 600 }}>
                        Lectura tipo milestone timeline. La integración Milestone + Gantt se construirá sobre esta base.
                    </div>
                </div>
                <PmoBadge tone="purple">{ordered.length} hito(s)</PmoBadge>
            </div>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: `repeat(${Math.max(ordered.length, 1)}, minmax(155px, 1fr))`,
                    gap: 10,
                    alignItems: "start",
                    overflowX: "auto",
                    paddingBottom: 6,
                }}
            >
                {ordered.map((item, index) => (
                    <div
                        key={item.id || index}
                        style={{
                            minWidth: 155,
                            padding: 10,
                            borderRadius: 14,
                            background: "rgba(255,255,255,.035)",
                            border: "1px solid rgba(125,211,252,.14)",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: 0, marginBottom: 10 }}>
                            <MilestoneTimelineDot item={item} />
                            {index < ordered.length - 1 ? (
                                <div style={{ height: 2, background: "rgba(125,211,252,.35)", flex: 1 }} />
                            ) : null}
                        </div>
                        <div style={{ fontSize: 11, color: "#7dd3fc", fontWeight: 900, letterSpacing: ".04em", textTransform: "uppercase" }}>
                            {formatMonthYear(item.target_date)}
                        </div>
                        <div style={{ fontSize: 12, color: "#ffffff", fontWeight: 900, lineHeight: 1.35, marginTop: 5 }}>
                            {item.title}
                        </div>
                        <div style={{ marginTop: 8 }}>
                            <PmoBadge tone={getMilestoneTone(item.status, item.health_status)}>
                                {normalizeLabel(item.status)}
                            </PmoBadge>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

function getTaskDatePressure(task) {
    if (!task?.due_date) return { overdue: false, label: "Sin fecha compromiso", tone: "gray" };
    if (task.status === "terminada" || task.status === "cancelada") {
        return { overdue: false, label: `Fecha compromiso: ${formatHumanDate(task.due_date)}`, tone: "green" };
    }

    const due = parseDateSafe(task.due_date);
    if (!due) return { overdue: false, label: "Fecha compromiso no válida", tone: "gray" };

    const today = new Date();
    today.setHours(12, 0, 0, 0);
    const diff = Math.round((due.getTime() - today.getTime()) / 86400000);

    if (diff < 0) {
        return { overdue: true, label: `Vencida hace ${Math.abs(diff)} día(s)`, tone: "red" };
    }

    if (diff === 0) {
        return { overdue: false, label: "Vence hoy", tone: "yellow" };
    }

    if (diff <= 7) {
        return { overdue: false, label: `Vence en ${diff} día(s)`, tone: "yellow" };
    }

    return { overdue: false, label: `Fecha compromiso: ${formatHumanDate(task.due_date)}`, tone: "blue" };
}

function buildMilestoneOrbisReading(item, task, deliverable) {
    const signals = [];
    let tone = getMilestoneTone(item.status, item.health_status);

    if (item.status === "cumplido") {
        return {
            tone: "green",
            title: "Lectura ORBIS",
            message: "Este hito está cumplido. Mantén evidencia, fecha real y entregable asociado para sostener la trazabilidad del cierre.",
        };
    }

    if (item.status === "en_riesgo" || item.health_status === "rojo") {
        signals.push("el hito ya está marcado en riesgo");
        tone = "red";
    }

    if (task) {
        const taskStatus = String(task.status || "").toLowerCase();
        const taskProgress = Number(task.progress_percent || 0);
        const datePressure = getTaskDatePressure(task);

        if (taskStatus === "bloqueada" || Number(task.is_blocked || 0) === 1) {
            signals.push("la tarea WBS vinculada está bloqueada");
            tone = "red";
        }

        if (datePressure.overdue) {
            signals.push("la tarea WBS vinculada está vencida");
            tone = "red";
        }

        if (taskProgress < 50 && item.status !== "pendiente") {
            signals.push(`el avance de la tarea vinculada es bajo (${taskProgress.toFixed(0)}%)`);
            if (tone !== "red") tone = "yellow";
        }

        if (Number(task.evidence_required || 0) === 1 && Number(task.evidence_count || 0) === 0) {
            signals.push("la tarea requiere evidencia y no muestra soporte documental asociado");
            tone = "red";
        }
    } else if (item.related_task_id || item.related_task_wbs_code) {
        signals.push("hay tarea WBS indicada, pero no se pudo cruzar con el listado operativo de tareas");
        if (tone !== "red") tone = "yellow";
    }

    if (deliverable) {
        const status = String(deliverable.status || "").toLowerCase();
        if (!["aprobado", "completado", "terminado", "cerrado"].includes(status)) {
            signals.push(`el entregable vinculado aún está ${normalizeLabel(deliverable.status)}`);
            if (tone !== "red") tone = "yellow";
        }
    }

    if (signals.length === 0) {
        return {
            tone: "green",
            title: "Lectura ORBIS",
            message: "El hito no muestra señales críticas con la información actual. Mantén seguimiento de fecha objetivo, evidencia y dependencias WBS.",
        };
    }

    return {
        tone,
        title: "Lectura ORBIS",
        message: `Este hito requiere atención porque ${signals.join(", ")}. Revisa responsable, evidencia, fecha objetivo y decisiones necesarias para proteger el avance del proyecto.`,
    };
}

function MiniMetric({ label, value, tone = "gray", tooltip }) {
    return (
        <div
            title={tooltip || undefined}
            style={{
                border: "1px solid rgba(125,211,252,.18)",
                borderRadius: 12,
                padding: "10px 12px",
                background: "rgba(255,255,255,.04)",
                minHeight: 58,
            }}
        >
            <div style={{ fontSize: 10, color: "#b9e8ff", fontWeight: 900, textTransform: "uppercase", letterSpacing: ".06em" }}>
                {label}
            </div>
            <div style={{ marginTop: 5 }}>
                {typeof value === "string" || typeof value === "number" ? (
                    <PmoBadge tone={tone}>{value}</PmoBadge>
                ) : (
                    value
                )}
            </div>
        </div>
    );
}

function MilestoneLinkedWorkPanel({ item, task, deliverable }) {
    const reading = buildMilestoneOrbisReading(item, task, deliverable);
    const datePressure = task ? getTaskDatePressure(task) : null;
    const taskProgress = Number(task?.progress_percent || 0);
    const hasOperationalLink = Boolean(task || deliverable || item.related_task_wbs_code || item.related_deliverable_name);

    return (
        <div
            style={{
                marginTop: 12,
                display: "grid",
                gap: 10,
            }}
        >
            <div
                style={{
                    border: "1px solid rgba(125,211,252,.18)",
                    borderRadius: 14,
                    padding: 12,
                    background: "rgba(255,255,255,.04)",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 10,
                        alignItems: "center",
                        marginBottom: hasOperationalLink ? 10 : 0,
                    }}
                >
                    <div style={{ fontSize: 12, fontWeight: 900, color: "#ffffff" }}>
                        WBS / soporte del hito
                        <PmoHelp text="Cruza el hito con su tarea WBS y entregable vinculado para interpretar si el hito puede cumplirse o si requiere intervención PMO." />
                    </div>
                    <PmoBadge tone={hasOperationalLink ? "blue" : "gray"}>
                        {hasOperationalLink ? "Con relación operativa" : "Sin relación operativa"}
                    </PmoBadge>
                </div>

                {hasOperationalLink ? (
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(185px, 1fr))",
                            gap: 10,
                        }}
                    >
                        <MiniMetric
                            label="Tarea WBS"
                            tone={task ? getStatusTone(task.status) : "gray"}
                            value={
                                task
                                    ? `${task.wbs_code ? `${task.wbs_code} · ` : ""}${task.name}`
                                    : (item.related_task_wbs_code ? `${item.related_task_wbs_code} · ${item.related_task_name}` : "Sin WBS")
                            }
                            tooltip="Tarea WBS relacionada al hito."
                        />

                        <MiniMetric
                            label="Avance tarea"
                            value={task ? (
                                <div>
                                    <div style={{ fontSize: 13, fontWeight: 900, color: "#ffffff", marginBottom: 6 }}>{taskProgress.toFixed(0)}%</div>
                                    <div style={{ height: 8, borderRadius: 999, background: "#e5e7eb", overflow: "hidden" }}>
                                        <div
                                            style={{
                                                width: `${Math.max(0, Math.min(taskProgress, 100))}%`,
                                                height: "100%",
                                                background: taskProgress >= 80 ? "#22c55e" : taskProgress >= 50 ? "#f59e0b" : "#ef4444",
                                            }}
                                        />
                                    </div>
                                </div>
                            ) : "Sin avance"}
                            tone="gray"
                        />

                        <MiniMetric
                            label="Presión fecha"
                            tone={datePressure?.tone || "gray"}
                            value={datePressure?.label || "Sin fecha"}
                            tooltip="Presión de calendario de la tarea vinculada."
                        />

                        <MiniMetric
                            label="Evidencia / revisión"
                            value={task ? (
                                <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
                                    <PmoBadge tone={Number(task.evidence_required || 0) === 1 ? "yellow" : "gray"}>
                                        {Number(task.evidence_required || 0) === 1 ? "Evidencia requerida" : "Sin requisito"}
                                    </PmoBadge>
                                    <PmoBadge tone={getStatusTone(task.review_status)}>
                                        {normalizeLabel(task.review_status || "Sin revisión")}
                                    </PmoBadge>
                                </div>
                            ) : "Sin revisión"}
                            tone="gray"
                        />

                        <MiniMetric
                            label="Entregable"
                            value={
                                deliverable
                                    ? (
                                        <div>
                                            <div style={{ fontSize: 12, color: "#ffffff", fontWeight: 850, lineHeight: 1.35 }}>{deliverable.name}</div>
                                            <div style={{ marginTop: 5 }}>
                                                <PmoBadge tone={getStatusTone(deliverable.status)}>{normalizeLabel(deliverable.status)}</PmoBadge>
                                            </div>
                                        </div>
                                    )
                                    : (item.related_deliverable_name || "Sin entregable")
                            }
                            tone="gray"
                        />
                    </div>
                ) : null}
            </div>

            <div
                style={{
                    padding: 13,
                    borderRadius: 14,
                    background: reading.tone === "red" ? "#fef2f2" : reading.tone === "yellow" ? "#fffbeb" : "#ecfdf5",
                    border: reading.tone === "red" ? "1px solid #fecaca" : reading.tone === "yellow" ? "1px solid #fde68a" : "1px solid #a7f3d0",
                    color: reading.tone === "red" ? "#991b1b" : reading.tone === "yellow" ? "#92400e" : "#047857",
                    fontSize: 13,
                    lineHeight: 1.55,
                    fontWeight: 700,
                }}
            >
                <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                    <span style={{ fontWeight: 950 }}>Lectura ORBIS:</span>
                    <span>{reading.message}</span>
                </div>
            </div>
        </div>
    );
}

function MilestoneCard({ item, tasks = [], deliverables = [], onEdit, onDelete, onComplete }) {
    const tone = getMilestoneTone(item.status, item.health_status);
    const accent = tone === "red" ? "#ef4444" : tone === "yellow" ? "#f59e0b" : tone === "green" ? "#22c55e" : "#00baff";
    const linkedTask = (tasks || []).find((task) => String(task.id) === String(item.related_task_id));
    const linkedDeliverable = (deliverables || []).find((deliverable) => String(deliverable.id) === String(item.related_deliverable_id));

    return (
        <OrbisRecordCard accent={accent}>
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "minmax(320px, 1.6fr) minmax(180px, .8fr) minmax(220px, 1fr) minmax(260px, 1.1fr)",
                    gap: 16,
                    alignItems: "start",
                }}
            >
                <div>
                    <OrbisFieldLabel>Milestone / hito</OrbisFieldLabel>
                    <div style={{ color: "#fff", fontWeight: 950, fontSize: 15, lineHeight: 1.35 }}>
                        {item.title}
                    </div>
                    <div style={{ color: "#b9e8ff", fontSize: 12, lineHeight: 1.5, marginTop: 7 }}>
                        {truncateForCard(item.description || "Sin descripción registrada.", 190)}
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <PmoBadge tone={tone}>{normalizeLabel(item.status)}</PmoBadge>
                        {Number(item.decision_gate || 0) === 1 ? (
                            <PmoBadge tone="purple" tooltip="Este hito funciona como punto de decisión ejecutiva.">Gate decisión</PmoBadge>
                        ) : null}
                    </div>
                </div>

                <div>
                    <OrbisFieldLabel>Fechas</OrbisFieldLabel>
                    <div style={{ color: "#fff", fontWeight: 850, fontSize: 13 }}>Objetivo: {formatHumanDate(item.target_date)}</div>
                    <div style={{ color: "#b9e8ff", fontWeight: 750, fontSize: 12, marginTop: 5 }}>Real: {formatHumanDate(item.actual_date)}</div>
                    <div style={{ marginTop: 10 }}>
                        <OrbisFieldLabel>Responsable</OrbisFieldLabel>
                        <div style={{ color: "#fff", fontWeight: 850, fontSize: 13 }}>{item.owner_name_resolved || item.owner_name || "—"}</div>
                    </div>
                </div>

                <div>
                    <OrbisFieldLabel>WBS / entregable</OrbisFieldLabel>
                    <div style={{ color: "#fff", fontWeight: 850, fontSize: 13, lineHeight: 1.35 }}>
                        {linkedTask
                            ? `${linkedTask.wbs_code ? `${linkedTask.wbs_code} · ` : ""}${linkedTask.name}`
                            : item.related_task_wbs_code ? `${item.related_task_wbs_code} · ${item.related_task_name}` : "Sin WBS vinculada"}
                    </div>
                    <div style={{ marginTop: 8 }}>
                        {linkedTask ? (
                            <>
                                <PmoBadge tone={getStatusTone(linkedTask.status)}>{normalizeLabel(linkedTask.status)}</PmoBadge>
                                <PmoBadge tone={Number(linkedTask.evidence_required || 0) === 1 ? "yellow" : "gray"}>
                                    {Number(linkedTask.evidence_required || 0) === 1 ? "Evidencia requerida" : "Sin requisito"}
                                </PmoBadge>
                            </>
                        ) : null}
                    </div>
                    <div style={{ color: "#b9e8ff", fontSize: 12, marginTop: 6 }}>
                        Entregable: {linkedDeliverable?.name || item.related_deliverable_name || "—"}
                    </div>
                </div>

                <div>
                    <OrbisFieldLabel>Acciones</OrbisFieldLabel>
                    <DetailActionButtons
                        onView={null}
                        onEdit={() => onEdit?.(item)}
                        onDelete={() => onDelete?.(item)}
                        editLabel="Editar"
                        deleteLabel="Eliminar"
                    />
                    <div style={{ marginTop: 8 }}>
                        <OrbisButton
                            compact
                            variant="success"
                            onClick={() => onComplete?.(item)}
                            disabled={item.status === "cumplido"}
                            title="Marcar hito como cumplido"
                        >
                            ✓ Cumplir
                        </OrbisButton>
                    </div>
                </div>
            </div>

            <MilestoneLinkedWorkPanel item={item} task={linkedTask} deliverable={linkedDeliverable} />

            {item.executive_impact ? (
                <div
                    style={{
                        marginTop: 12,
                        padding: 12,
                        borderRadius: 14,
                        background: "rgba(139,92,246,.10)",
                        border: "1px solid rgba(139,92,246,.38)",
                        fontSize: 13,
                        color: "#e9d5ff",
                        lineHeight: 1.5,
                    }}
                >
                    <strong>Impacto ejecutivo:</strong> {item.executive_impact}
                </div>
            ) : null}

            {item.success_criteria ? (
                <div
                    style={{
                        marginTop: 10,
                        padding: 12,
                        borderRadius: 14,
                        background: "rgba(14,165,233,.10)",
                        border: "1px solid rgba(125,211,252,.28)",
                        fontSize: 13,
                        color: "#d7efff",
                        lineHeight: 1.5,
                    }}
                >
                    <strong>Criterio de cumplimiento:</strong> {item.success_criteria}
                </div>
            ) : null}
        </OrbisRecordCard>
    );
}

function MilestonesPanel({ items, tasks = [], deliverables = [], onEdit, onDelete, onComplete }) {
    const stats = (items || []).reduce((acc, item) => {
        acc.total += 1;
        if (item.status === "cumplido") acc.cumplidos += 1;
        if (item.status === "en_riesgo") acc.enRiesgo += 1;
        if (item.status === "retrasado") acc.retrasados += 1;
        if (Number(item.decision_gate || 0) === 1) acc.gates += 1;
        return acc;
    }, { total: 0, cumplidos: 0, enRiesgo: 0, retrasados: 0, gates: 0 });

    return (
        <div style={{ display: "grid", gap: 16 }}>
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
                    gap: 12,
                }}
            >
                <InfoRow label="Total de hitos" value={stats.total} asBadge tone="blue" tooltip="Cantidad total de milestones registrados." />
                <InfoRow label="Cumplidos" value={stats.cumplidos} asBadge tone="green" tooltip="Hitos cumplidos." />
                <InfoRow label="En riesgo" value={stats.enRiesgo} asBadge tone={stats.enRiesgo > 0 ? "red" : "green"} tooltip="Hitos que requieren atención ejecutiva." />
                <InfoRow label="Retrasados" value={stats.retrasados} asBadge tone={stats.retrasados > 0 ? "red" : "green"} tooltip="Hitos con retraso formal." />
                <InfoRow label="Decision gates" value={stats.gates} asBadge tone="purple" tooltip="Hitos que funcionan como puntos de decisión." />
            </div>

            <MilestoneExecutiveTimeline items={items} />

            <div style={{ fontSize: 12, color: "#b9e8ff", fontWeight: 700 }}>
                Detalle ejecutivo por hito: WBS, soporte, entregable e interpretación automática ORBIS.
            </div>

            <div style={{ display: "grid", gap: 10 }}>
                {(items || []).map((item) => (
                    <MilestoneCard key={item.id} item={item} tasks={tasks} deliverables={deliverables} onEdit={onEdit} onDelete={onDelete} onComplete={onComplete} />
                ))}
            </div>
        </div>
    );
}

function normalizeLabel(value = "") {
    const raw = String(value || "—").replace(/_/g, " ").trim();
    const map = {
        ejecucion: "Ejecución",
        planeacion: "Planeación",
        revision: "Revisión",
        critica: "Crítica",
        critico: "Crítico",
        en_proceso: "En proceso",
        en_riesgo: "En riesgo",
        en_revision: "En revisión",
        en_monitoreo: "En monitoreo",
        pendiente_revision: "Pendiente revisión",
        sin_revision: "Sin revisión",
        "en proceso": "En proceso",
        "en riesgo": "En riesgo",
        "en revision": "En revisión",
        "en monitoreo": "En monitoreo",
        "pendiente revision": "Pendiente revisión",
        "sin revision": "Sin revisión",
        borrador: "Borrador",
        activo: "Activo",
        pausado: "Pausado",
        terminado: "Terminado",
        cancelado: "Cancelado",
        otro: "Otro",
    };
    const key = raw.toLowerCase();
    if (map[key]) return map[key];
    return raw.replace(/\b\w/g, (c) => c.toUpperCase());
}


function ProjectMiniLabel({ label, tooltip }) {
    return (
        <div
            style={{
                color: "#7dd3fc",
                fontSize: 10,
                fontWeight: 950,
                textTransform: "uppercase",
                letterSpacing: ".12em",
                marginBottom: 6,
            }}
        >
            {label}
            <OrbisTooltip text={tooltip} />
        </div>
    );
}

function OrbisTooltip({ text }) {
    if (!text) return null;

    return (
        <span
            title={text}
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 16,
                height: 16,
                marginLeft: 6,
                borderRadius: "50%",
                border: "1px solid rgba(125,211,252,.45)",
                color: "#7dd3fc",
                fontSize: 10,
                fontWeight: 950,
                cursor: "help",
                verticalAlign: "middle",
            }}
        >
            ?
        </span>
    );
}


function DetailLabel({ children, tooltip }) {
    return <ProjectMiniLabel label={children} tooltip={tooltip} />;
}

function PmoHelp({ text }) {
    if (!text) return null;

    return (
        <span
            title={text}
            style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 16,
                height: 16,
                marginLeft: 6,
                borderRadius: "50%",
                border: "1px solid rgba(0,178,255,.24)",
                color: "#2563eb",
                background: "#eff6ff",
                fontSize: 10,
                fontWeight: 900,
                cursor: "help",
                verticalAlign: "middle",
            }}
        >
            ?
        </span>
    );
}



function PmoBadge({ children, tone = "default", tooltip }) {
    const tones = {
        default: { bg: "rgba(14,165,233,.14)", color: "#bfdbfe", border: "rgba(125,211,252,.24)" },
        blue: { bg: "rgba(14,165,233,.16)", color: "#7dd3fc", border: "rgba(125,211,252,.32)" },
        green: { bg: "rgba(16,185,129,.16)", color: "#bbf7d0", border: "rgba(16,185,129,.38)" },
        yellow: { bg: "rgba(244,185,27,.18)", color: "#fde68a", border: "rgba(244,185,27,.42)" },
        red: { bg: "rgba(239,68,68,.16)", color: "#fecaca", border: "rgba(239,68,68,.42)" },
        purple: { bg: "rgba(139,92,246,.20)", color: "#e9d5ff", border: "rgba(139,92,246,.42)" },
        gray: { bg: "rgba(148,163,184,.13)", color: "#cbd5e1", border: "rgba(148,163,184,.26)" },
        gold: { bg: "#f4b91b", color: "#06111f", border: "#f4b91b" },
        danger: { bg: "transparent", color: "#ffb4b4", border: "rgba(239,68,68,.68)" },
    };
    const s = tones[tone] || tones.default;

    return (
        <span
            title={tooltip || undefined}
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "5px 10px",
                borderRadius: 999,
                background: s.bg,
                color: s.color,
                border: `1px solid ${s.border}`,
                fontSize: 11,
                fontWeight: 850,
                lineHeight: 1.15,
                whiteSpace: "nowrap",
                marginRight: 6,
                marginBottom: 6,
            }}
        >
            {children}
        </span>
    );
}

function getStatusTone(status) {
    const v = String(status || "").toLowerCase();
    if (["terminado", "cerrado", "aprobado", "completado", "mitigado"].includes(v)) return "green";
    if (["activo", "en_proceso", "abierto", "en_monitoreo"].includes(v)) return "blue";
    if (["pendiente", "borrador", "pausado", "con_cambios"].includes(v)) return "yellow";
    if (["bloqueada", "vencido", "rechazado", "cancelado", "critico", "crítica"].includes(v)) return "red";
    return "gray";
}

function getPriorityTone(value) {
    const v = String(value || "").toLowerCase();
    if (["critica", "crítica", "alta", "alto", "critico", "crítico"].includes(v)) return "red";
    if (["media", "medio"].includes(v)) return "yellow";
    if (["baja", "bajo"].includes(v)) return "green";
    return "gray";
}

function getHealthLabel(health) {
    const h = String(health || "").toLowerCase();
    if (h === "verde") return "En control";
    if (h === "amarillo") return "En atención";
    if (h === "rojo") return "Crítica";
    return normalizeLabel(health || "Sin salud");
}

function getReviewStatusBadge(status) {
    const map = {
        borrador: { bg: "#f3f4f6", color: "#d7efff", label: "Borrador" },
        pendiente_revision: { bg: "#fffbeb", color: "#92400e", label: "Pendiente revisión" },
        aprobado: { bg: "#ecfdf5", color: "#166534", label: "Aprobado" },
        rechazado: { bg: "#fef2f2", color: "#991b1b", label: "Rechazado" },
        con_cambios: { bg: "#eff6ff", color: "#1d4ed8", label: "Con cambios" },
        en_revision: { bg: "#fffbeb", color: "#92400e", label: "En revisión" },
    };

    return map[status] || { bg: "#f3f4f6", color: "#d7efff", label: status || "—" };
}

function getTaskStatusLabel(status) {
    const map = {
        pendiente: "Pendiente",
        en_proceso: "En proceso",
        bloqueada: "Bloqueada",
        terminada: "Terminada",
        cancelada: "Cancelada",
    };

    return map[String(status || "").toLowerCase()] || status || "—";
}

function getTaskReviewStatusLabel(status) {
    const map = {
        borrador: "Borrador",
        en_revision: "En revisión",
        pendiente_revision: "Pendiente de revisión",
        aprobado: "Aprobado",
        rechazado: "Rechazado",
        con_cambios: "Con cambios",
    };

    return map[String(status || "").toLowerCase()] || status || "—";
}




function TaskStatusBadge({ status, reviewStatus, children }) {
    const cleanReview = String(reviewStatus || "").trim();
    const cleanStatus = String(status || "").trim();
    const raw = (cleanReview || cleanStatus || String(children || "")).toLowerCase();

    const labelFromReview = cleanReview ? getTaskReviewStatusLabel(cleanReview) : "";
    const labelFromStatus = cleanStatus ? getTaskStatusLabel(cleanStatus) : "";
    const text = children || labelFromReview || labelFromStatus || normalizeLabel(raw) || "—";

    const styles = {
        pendiente: { bg: "rgba(244,185,27,.18)", color: "#fde68a", border: "rgba(244,185,27,.42)", dot: "#f59e0b" },
        en_proceso: { bg: "rgba(14,165,233,.16)", color: "#7dd3fc", border: "rgba(125,211,252,.32)", dot: "#38bdf8" },
        bloqueada: { bg: "rgba(239,68,68,.16)", color: "#fecaca", border: "rgba(239,68,68,.42)", dot: "#ef4444" },
        terminada: { bg: "rgba(16,185,129,.16)", color: "#bbf7d0", border: "rgba(16,185,129,.38)", dot: "#22c55e" },
        cancelada: { bg: "rgba(148,163,184,.13)", color: "#cbd5e1", border: "rgba(148,163,184,.26)", dot: "#94a3b8" },
        borrador: { bg: "rgba(148,163,184,.13)", color: "#cbd5e1", border: "rgba(148,163,184,.26)", dot: "#94a3b8" },
        en_revision: { bg: "rgba(244,185,27,.18)", color: "#fde68a", border: "rgba(244,185,27,.42)", dot: "#f59e0b" },
        pendiente_revision: { bg: "rgba(244,185,27,.18)", color: "#fde68a", border: "rgba(244,185,27,.42)", dot: "#f59e0b" },
        aprobado: { bg: "rgba(16,185,129,.16)", color: "#bbf7d0", border: "rgba(16,185,129,.38)", dot: "#22c55e" },
        rechazada: { bg: "rgba(239,68,68,.16)", color: "#fecaca", border: "rgba(239,68,68,.42)", dot: "#ef4444" },
        rechazado: { bg: "rgba(239,68,68,.16)", color: "#fecaca", border: "rgba(239,68,68,.42)", dot: "#ef4444" },
        con_cambios: { bg: "rgba(239,68,68,.16)", color: "#fecaca", border: "rgba(239,68,68,.42)", dot: "#ef4444" },
    };

    const cfg = styles[raw] || { bg: "rgba(14,165,233,.14)", color: "#7dd3fc", border: "rgba(125,211,252,.28)", dot: "#38bdf8" };

    return (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 7,
                padding: "6px 11px",
                borderRadius: 999,
                background: cfg.bg,
                color: cfg.color,
                border: `1px solid ${cfg.border}`,
                fontSize: 12,
                fontWeight: 900,
                lineHeight: 1,
                whiteSpace: "nowrap",
                marginRight: 6,
                marginBottom: 6,
            }}
            title={text}
        >
            <span style={{ width: 7, height: 7, borderRadius: "50%", background: cfg.dot, display: "inline-block", flex: "0 0 auto" }} />
            <span>{text}</span>
        </span>
    );
}

function Badge({ children, bg = "rgba(14,165,233,.14)", color = "#bfdbfe" }) {
    const safeColor = bg === "#fff" || bg === "#ffffff" || bg === "#f8fafc" || bg === "#f3f4f6" || bg === "#eef2ff"
        ? "#111827"
        : color;

    return (
        <span
            style={{
                display: "inline-block",
                padding: "4px 10px",
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 800,
                background: bg,
                color: safeColor,
                marginRight: 6,
                marginBottom: 6,
                border: bg === "rgba(14,165,233,.14)" ? "1px solid rgba(125,211,252,.24)" : undefined,
            }}
        >
            {children}
        </span>
    );
}

function ActionButton({
    children,
    onClick,
    bg = "#06111f",
    color = "#fff",
    border = "1px solid rgba(125,211,252,.35)",
    disabled = false,
    type = "button",
}) {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            style={{
                padding: "10px 16px",
                borderRadius: 999,
                border,
                background: disabled ? "#9ca3af" : bg,
                color,
                fontWeight: 900,
                cursor: disabled ? "not-allowed" : "pointer",
                marginRight: 8,
                marginBottom: 8,
                boxShadow: bg === "#f4b91b" ? "0 10px 22px rgba(244,185,27,.20)" : "0 8px 18px rgba(2,8,23,.14)",
                whiteSpace: "nowrap",
            }}
        >
            {children}
        </button>
    );
}

function OrbisButton({
    children,
    onClick,
    variant = "dark",
    disabled = false,
    title,
    type = "button",
    compact = false,
}) {
    const styles = {
        primary: {
            background: "#8b5cf6",
            color: "#fff",
            border: "1px solid rgba(255,255,255,.20)",
            boxShadow: "0 10px 22px rgba(139,92,246,.24)",
        },
        gold: {
            background: "#f4b91b",
            color: "#06111f",
            border: "1px solid #f4b91b",
            boxShadow: "0 10px 22px rgba(244,185,27,.20)",
        },
        dark: {
            background: "#06111f",
            color: "#fff",
            border: "1px solid rgba(125,211,252,.30)",
            boxShadow: "none",
        },
        ghost: {
            background: "transparent",
            color: "#d7efff",
            border: "1px solid rgba(125,211,252,.35)",
            boxShadow: "none",
        },
        danger: {
            background: "transparent",
            color: "#ffb4b4",
            border: "1px solid rgba(239,68,68,.65)",
            boxShadow: "none",
        },
        light: {
            background: "rgba(255,255,255,.04)",
            color: "#06111f",
            border: "1px solid #dbeafe",
            boxShadow: "0 8px 18px rgba(2,8,23,.08)",
        },
        success: {
            background: "#22c55e",
            color: "#052e16",
            border: "1px solid #22c55e",
            boxShadow: "0 10px 22px rgba(34,197,94,.18)",
        },
    };
    const s = styles[variant] || styles.dark;

    return (
        <button
            type={type}
            title={title}
            onClick={onClick}
            disabled={disabled}
            style={{
                ...s,
                borderRadius: 999,
                padding: compact ? "7px 12px" : "10px 16px",
                fontSize: compact ? 12 : 13,
                fontWeight: 900,
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.55 : 1,
                whiteSpace: "nowrap",
                margin: 0,
            }}
        >
            {children}
        </button>
    );
}

function OrbisActions({ children }) {
    return (
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
            {children}
        </div>
    );
}



function DetailActionButtons({ onView, onEdit, onDelete, viewLabel = "Ver detalle", editLabel = "Editar", deleteLabel = "Eliminar" }) {
    return (
        <OrbisActions>
            {onView ? <OrbisButton compact variant="primary" onClick={onView}>{viewLabel}</OrbisButton> : null}
            {onEdit ? <OrbisButton compact variant="gold" onClick={onEdit}>{editLabel}</OrbisButton> : null}
            {onDelete ? <OrbisButton compact variant="danger" onClick={onDelete}>{deleteLabel}</OrbisButton> : null}
        </OrbisActions>
    );
}

function OrbisRecordCard({ children, accent = "#00baff", selected = false, style = {} }) {
    return (
        <div
            style={{
                background: selected
                    ? "linear-gradient(180deg, rgba(14,165,233,.18), rgba(2,25,48,.96))"
                    : "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                border: selected ? "1px solid rgba(125,211,252,.65)" : "1px solid rgba(0,178,255,.28)",
                borderRadius: 18,
                padding: 16,
                position: "relative",
                overflow: "hidden",
                boxShadow: selected ? "0 14px 30px rgba(0,0,0,.24)" : "0 8px 22px rgba(0,0,0,.14)",
                ...style,
            }}
        >
            <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 5, background: accent }} />
            <div style={{ paddingLeft: 10 }}>{children}</div>
        </div>
    );
}

function OrbisFieldLabel({ children }) {
    return (
        <div style={{ color: "#7dd3fc", fontSize: 10, fontWeight: 900, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 5 }}>
            {children}
        </div>
    );
}

function getRiskAccent(risk = {}) {
    const level = String(risk.risk_level || risk.impact || "").toLowerCase();
    if (level.includes("crit")) return "#ef4444";
    if (level.includes("alto")) return "#f97316";
    if (level.includes("medio")) return "#f59e0b";
    return "#22c55e";
}

function getTaskAccent(task = {}) {
    const status = String(task.status || "").toLowerCase();
    if (status === "bloqueada") return "#ef4444";
    if (status === "en_proceso") return "#f59e0b";
    if (status === "terminada") return "#22c55e";
    if (status === "cancelada") return "#64748b";
    return "#00baff";
}

function getDeliverableAccent(deliverable = {}) {
    const status = String(deliverable.status || "").toLowerCase();
    if (status === "aprobado" || status === "cerrado") return "#22c55e";
    if (status === "rechazado" || status === "vencido") return "#ef4444";
    if (status === "en_revision" || status === "en revisión") return "#f59e0b";
    return "#00baff";
}



function SectionCard({ title, right, children }) {
    return (
        <div
            style={{
                background: "rgba(2,25,48,.88)",
                borderRadius: 22,
                padding: 22,
                boxShadow: "0 20px 44px rgba(0,0,0,.22)",
                border: "1px solid rgba(0,178,255,.22)",
                marginBottom: 18,
                backdropFilter: "blur(10px)",
                color: "#e0f2fe",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 12,
                    marginBottom: 16,
                    flexWrap: "wrap",
                }}
            >
                <h3 style={{ margin: 0, fontSize: 18, color: "#ffffff", letterSpacing: "-.01em", fontWeight: 900 }}>{title}</h3>
                <div>{right}</div>
            </div>
            {children}
        </div>
    );
}


function StatCard({ title, value, subtitle, bg = "#ffffff", accent = "#00baff", variant = "orbis" }) {
    const isOrbis = variant === "orbis";
    return (
        <div
            style={{
                background: isOrbis ? "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))" : bg,
                border: isOrbis ? "1px solid rgba(0,178,255,.28)" : "1px solid #e5e7eb",
                borderRadius: 18,
                padding: 18,
                boxShadow: isOrbis ? "0 14px 32px rgba(0,0,0,.18)" : "0 1px 4px rgba(0,0,0,0.05)",
                minHeight: 118,
                position: "relative",
                overflow: "hidden",
            }}
        >
            <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 5, background: accent }} />
            <div style={{ paddingLeft: 10 }}>
                <div style={{ fontSize: 11, color: isOrbis ? "#7dd3fc" : "#6b7280", marginBottom: 8, fontWeight: 900, textTransform: "uppercase", letterSpacing: ".12em" }}>{title}</div>
                <div style={{ fontSize: 30, fontWeight: 950, color: isOrbis ? "#ffffff" : "#111827", marginBottom: 6, letterSpacing: "-.03em" }}>
                    {value}
                </div>
                <div style={{ fontSize: 12, color: isOrbis ? "#bfdbfe" : "#6b7280", fontWeight: 750, lineHeight: 1.4 }}>{subtitle}</div>
            </div>
        </div>
    );
}



function Input({ label, hint, value, onChange, disabled = false, ...props }) {
    return (
        <div style={{ marginBottom: 14 }}>
            <div
                style={{
                    fontSize: 11,
                    color: "#7dd3fc",
                    marginBottom: 7,
                    fontWeight: 900,
                    letterSpacing: ".06em",
                    textTransform: "uppercase",
                }}
            >
                {label}
            </div>
            <input
                value={value ?? ""}
                onChange={onChange}
                disabled={disabled}
                {...props}
                style={{
                    width: "100%",
                    padding: "11px 12px",
                    borderRadius: 10,
                    border: "1px solid rgba(125,211,252,.35)",
                    outline: "none",
                    fontSize: 14,
                    boxSizing: "border-box",
                    background: disabled ? "#e2e8f0" : "#ffffff",
                    color: "#111827",
                    WebkitTextFillColor: "#111827",
                    fontWeight: 650,
                    caretColor: "#111827",
                }}
            />
            {hint ? <div style={{ fontSize: 11, color: "#b9e8ff", marginTop: 6, lineHeight: 1.4, fontWeight: 600 }}>{hint}</div> : null}
        </div>
    );
}


function TextArea({ label, hint, value, onChange, rows = 4, disabled = false, ...props }) {
    return (
        <div style={{ marginBottom: 14 }}>
            <div
                style={{
                    fontSize: 11,
                    color: "#7dd3fc",
                    marginBottom: 7,
                    fontWeight: 900,
                    letterSpacing: ".06em",
                    textTransform: "uppercase",
                }}
            >
                {label}
            </div>
            <textarea
                value={value ?? ""}
                onChange={onChange}
                rows={rows}
                disabled={disabled}
                {...props}
                style={{
                    width: "100%",
                    padding: "11px 12px",
                    borderRadius: 10,
                    border: "1px solid rgba(125,211,252,.35)",
                    outline: "none",
                    fontSize: 14,
                    boxSizing: "border-box",
                    resize: "vertical",
                    background: disabled ? "#e2e8f0" : "#ffffff",
                    color: "#111827",
                    WebkitTextFillColor: "#111827",
                    fontWeight: 650,
                    caretColor: "#111827",
                }}
            />
            {hint ? <div style={{ fontSize: 11, color: "#b9e8ff", marginTop: 6, lineHeight: 1.4, fontWeight: 600 }}>{hint}</div> : null}
        </div>
    );
}

function Select({ label, hint, value, onChange, children, disabled = false, name }) {
    return (
        <div style={{ marginBottom: 14 }}>
            <div
                style={{
                    fontSize: 11,
                    color: "#7dd3fc",
                    marginBottom: 7,
                    fontWeight: 900,
                    letterSpacing: ".06em",
                    textTransform: "uppercase",
                }}
            >
                {label}
            </div>
            <select
                name={name}
                value={value ?? ""}
                onChange={onChange}
                disabled={disabled}
                style={{
                    width: "100%",
                    padding: "11px 12px",
                    borderRadius: 10,
                    border: "1px solid rgba(125,211,252,.35)",
                    outline: "none",
                    fontSize: 14,
                    boxSizing: "border-box",
                    background: disabled ? "#e2e8f0" : "#ffffff",
                    color: "#111827",
                    WebkitTextFillColor: "#111827",
                    fontWeight: 650,
                    caretColor: "#111827",
                }}
            >
                {children}
            </select>
            {hint ? <div style={{ fontSize: 11, color: "#b9e8ff", marginTop: 6, lineHeight: 1.4, fontWeight: 600 }}>{hint}</div> : null}
        </div>
    );
}

function TableWrapper({ children, minWidth = 1180 }) {
    return (
        <div style={{ overflowX: "auto" }}>
            <table
                style={{
                    width: "100%",
                    borderCollapse: "separate",
                    borderSpacing: "0 0",
                    minWidth,
                }}
            >
                {children}
            </table>
        </div>
    );
}


function Th({ children }) {
    return (
        <th
            style={{
                textAlign: "left",
                padding: "14px 16px",
                background: "rgba(2,25,48,.98)",
                borderBottom: "1px solid rgba(0,178,255,.24)",
                color: "#93c5fd",
                fontSize: 11,
                textTransform: "uppercase",
                letterSpacing: ".08em",
                fontWeight: 900,
            }}
        >
            {children}
        </th>
    );
}


function Td({ children, colSpan }) {
    return (
        <td
            colSpan={colSpan}
            style={{
                padding: "18px 16px",
                borderBottom: "10px solid rgba(0,24,39,.84)",
                verticalAlign: "top",
                fontSize: 13,
                color: "#e0f2fe",
                background: "rgba(2,25,48,.72)",
            }}
        >
            {children}
        </td>
    );
}


function ModalShell({ open, title, onClose, children, width = 900 }) {
    if (!open) return null;

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0, 20, 32, 0.70)",
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 20,
                backdropFilter: "blur(4px)",
            }}
        >

            <style>{`
                    .orbis-task-modal-footer {
                        background: #041c2c !important;
                        background-image: linear-gradient(180deg, rgba(8,47,73,.98), rgba(2,25,48,1)) !important;
                    }

                    select option {
                        color: #111827;
                        background: #ffffff;
                    }
                    input::placeholder,
                    textarea::placeholder {
                        color: #64748b;
                    }
                `}</style>
            <div
                style={{
                    width: "100%",
                    maxWidth: width,
                    maxHeight: "92vh",
                    overflow: "auto",
                    background: "rgba(255,255,255,.04)",
                    borderRadius: 20,
                    boxShadow: "0 32px 85px rgba(0,0,0,0.42)",
                    border: "1px solid rgba(0,186,255,.30)",
                }}
            >
                <div
                    style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 12,
                        padding: "18px 22px",
                        background: "linear-gradient(135deg, #041c2c 0%, #083a55 100%)",
                        color: "#fff",
                        borderBottom: "1px solid rgba(0,186,255,.25)",
                    }}
                >
                    <div>
                        <div style={{ color: "#ffd43b", fontSize: 10, fontWeight: 900, letterSpacing: ".16em", textTransform: "uppercase" }}>
                            Plataforma PM · ORBIS
                        </div>
                        <h2 style={{ margin: "5px 0 0", fontSize: 21, fontWeight: 900, letterSpacing: "-.01em" }}>{title}</h2>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{
                            border: "1px solid rgba(125,211,252,.45)",
                            background: "rgba(255,255,255,.08)",
                            color: "#fff",
                            borderRadius: 999,
                            width: 36,
                            height: 36,
                            cursor: "pointer",
                            fontSize: 20,
                            fontWeight: 900,
                            lineHeight: 1,
                        }}
                    >
                        ×
                    </button>
                </div>

                <div style={{ padding: 22 }}>{children}</div>
            </div>
        </div>
    );
}

function DualHorizontalScroll({ minWidth = 980, height = 12, children }) {
    const topRef = React.useRef(null);
    const bottomRef = React.useRef(null);
    const innerRef = React.useRef(null);
    const syncingRef = React.useRef(false);
    const [trackWidth, setTrackWidth] = React.useState(minWidth);

    React.useEffect(() => {
        const updateWidth = () => {
            if (innerRef.current) {
                setTrackWidth(Math.max(minWidth, innerRef.current.scrollWidth || minWidth));
            }
        };

        updateWidth();

        let observer = null;
        if (window.ResizeObserver && innerRef.current) {
            observer = new ResizeObserver(updateWidth);
            observer.observe(innerRef.current);
        }

        window.addEventListener('resize', updateWidth);
        return () => {
            window.removeEventListener('resize', updateWidth);
            if (observer) observer.disconnect();
        };
    }, [minWidth, children]);

    const syncScroll = (source, targetA, targetB) => {
        if (!source) return;
        if (syncingRef.current) return;
        syncingRef.current = true;
        const left = source.scrollLeft;
        if (targetA) targetA.scrollLeft = left;
        if (targetB) targetB.scrollLeft = left;
        requestAnimationFrame(() => {
            syncingRef.current = false;
        });
    };

    return (
        <div>
            <div
                ref={topRef}
                onScroll={() => syncScroll(topRef.current, bottomRef.current, null)}
                style={{ overflowX: 'auto', overflowY: 'hidden', height, borderBottom: '1px solid #e5e7eb' }}
            >
                <div style={{ width: trackWidth, height: 1 }} />
            </div>

            <div
                ref={bottomRef}
                onScroll={() => syncScroll(bottomRef.current, topRef.current, null)}
                style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 620 }}
            >
                <div ref={innerRef} style={{ minWidth }}>
                    {children}
                </div>
            </div>
        </div>
    );
}



function ProgressBar({ value }) {
    const safe = Math.max(0, Math.min(100, Number(value || 0)));
    return (
        <div>
            <div style={{ fontWeight: 900, marginBottom: 6, color: "#ffffff" }}>{safe.toFixed(0)}%</div>
            <div
                style={{
                    width: "100%",
                    height: 10,
                    background: "rgba(148,163,184,.25)",
                    borderRadius: 999,
                    overflow: "hidden",
                    minWidth: 120,
                }}
            >
                <div
                    style={{
                        width: `${safe}%`,
                        height: "100%",
                        background: safe >= 80 ? "#22c55e" : safe >= 50 ? "#2563eb" : "#f59e0b",
                    }}
                />
            </div>
        </div>
    );
}

function formatMoney(value, currency = "MXN") {
    if (value === null || value === undefined || value === "") return "—";
    const num = Number(value);
    if (Number.isNaN(num)) return value;
    try {
        return new Intl.NumberFormat("es-MX", {
            style: "currency",
            currency: currency || "MXN",
            maximumFractionDigits: 0,
        }).format(num);
    } catch {
        return `${currency || "MXN"} ${num.toLocaleString("es-MX")}`;
    }
}

function getStatusBg(status) {
    const map = {
        activo: "#d1fae5",
        pausado: "#fef3c7",

        terminada: "#dcfce7",
        cancelado: "#fee2e2",
        pendiente: "#e5e7eb",
        en_progreso: "#dbeafe",
        bloqueada: "#fee2e2",
        completada: "#dcfce7",
        abierto: "#fee2e2",
        en_monitoreo: "#fef3c7",
        mitigado: "#dbeafe",
        cerrado: "#dcfce7",
        enviado: "#dbeafe",
        aprobado: "#dcfce7",
        rechazado: "#fee2e2",
        inicio: "#e0f2fe",
        planeacion: "#ede9fe",
        ejecucion: "#dcfce7",
        monitoreo: "#fef3c7",
        cierre: "#dbeafe",
        verde: "#d1fae5",
        amarillo: "#fef3c7",
        rojo: "#fee2e2",
        bajo: "#dcfce7",
        medio: "#fef3c7",
        alto: "#fee2e2",
        critica: "#fee2e2",
    };
    return map[status] || "#eef2ff";
}

const buildAuthHeaders = (extra = {}) => {
    const token =
        localStorage.getItem("cani_auth") ||
        localStorage.getItem("token") ||
        "";

    return {
        ...extra,
        Authorization: token ? `Bearer ${token}` : "",
        "X-CANI-AUTH": token || "",
    };
};


async function safeJsonFetch(url, options = {}) {
    const res = await fetch(url, options);
    const text = await res.text();

    if (!text) {
        throw new Error(`Respuesta vacía (${res.status}) en ${url}`);
    }

    let data;
    try {
        data = JSON.parse(text);
    } catch {
        throw new Error(`Respuesta no-JSON (${res.status}) en ${url}: ${text.slice(0, 250)}`);
    }

    return data;
}

function getLoggedUserSignals() {
    return {
        displayName:
            localStorage.getItem("displayName") ||
            localStorage.getItem("user_name") ||
            localStorage.getItem("userDisplayName") ||
            "",
        email:
            localStorage.getItem("email") ||
            localStorage.getItem("user_email") ||
            localStorage.getItem("userEmail") ||
            "",
        userId:
            localStorage.getItem("user_id") ||
            localStorage.getItem("uid") ||
            "",
    };
}

function resolveLoggedUserId(usersCatalog) {
    const signals = getLoggedUserSignals();
    if (!Array.isArray(usersCatalog) || !usersCatalog.length) return "";

    if (signals.userId) {
        const byId = usersCatalog.find((u) => String(u.id) === String(signals.userId));
        if (byId) return String(byId.id);
    }

    if (signals.email) {
        const byEmail = usersCatalog.find(
            (u) => String(u.email || "").toLowerCase() === String(signals.email).toLowerCase()
        );
        if (byEmail) return String(byEmail.id);
    }

    if (signals.displayName) {
        const byName = usersCatalog.find(
            (u) => String(u.display_name || "").toLowerCase() === String(signals.displayName).toLowerCase()
        );
        if (byName) return String(byName.id);
    }

    return "";
}


function PillarCard({ title, subtitle, accent = "#00baff", children, actions }) {
    return (
        <div
            style={{
                background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                borderRadius: 18,
                border: "1px solid rgba(0,178,255,.24)",
                boxShadow: "0 12px 28px rgba(0,0,0,.18)",
                overflow: "hidden",
                height: "100%",
                position: "relative",
            }}
        >
            <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 5, background: accent }} />
            <div style={{ padding: 18, paddingLeft: 24 }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 12, marginBottom: 14, flexWrap: "wrap" }}>
                    <div>
                        <div style={{ fontSize: 17, fontWeight: 900, color: "#ffffff" }}>{title}</div>
                        {subtitle ? (
                            <div style={{ fontSize: 12, color: "#b9e8ff", marginTop: 4, fontWeight: 600 }}>{subtitle}</div>
                        ) : null}
                    </div>
                    <div>{actions}</div>
                </div>
                {children}
            </div>
        </div>
    );
}


function InfoRow({ label, value, tooltip, asBadge = false, tone = "default" }) {
    return (
        <div
            style={{
                marginBottom: 12,
                background: "rgba(255,255,255,.035)",
                border: "1px solid rgba(125,211,252,.14)",
                borderRadius: 14,
                padding: 12,
                minHeight: 70,
            }}
        >
            <div style={{ fontSize: 10, color: "#7dd3fc", marginBottom: 6, fontWeight: 900, textTransform: "uppercase", letterSpacing: ".08em" }}>
                {label}
                {tooltip ? <span title={tooltip} style={{ marginLeft: 6, cursor: "help", color: "#7dd3fc" }}>?</span> : null}
            </div>
            {asBadge ? (
                <PmoBadge tone={tone}>{value || "—"}</PmoBadge>
            ) : (
                <div style={{ fontSize: 14, color: "#ffffff", fontWeight: 800, lineHeight: 1.45 }}>{value || "—"}</div>
            )}
        </div>
    );
}

function hasChildTasks(taskId, tasks) {
    return Array.isArray(tasks) && tasks.some(
        (t) => String(t.parent_task_id || "") === String(taskId || "")
    );
}

function getChildTasks(taskId, tasks) {
    return Array.isArray(tasks)
        ? tasks.filter((t) => String(t.parent_task_id || "") === String(taskId || ""))
        : [];
}

function getDescendantTaskIds(taskId, tasks, visited = new Set()) {
    const directChildren = getChildTasks(taskId, tasks);
    const ids = [];

    directChildren.forEach((child) => {
        const childId = String(child.id || "");
        if (!childId || visited.has(childId)) return;
        visited.add(childId);
        ids.push(childId);
        ids.push(...getDescendantTaskIds(childId, tasks, visited));
    });

    return ids;
}

function getTaskPanelTone(task) {
    if (!task) return { bg: "#fff", border: "#e5e7eb", accent: "#64748b" };

    const review = String(task.review_status || "").toLowerCase();
    const status = String(task.status || "").toLowerCase();

    if (review === "en_revision" || review === "pendiente_revision") {
        return { bg: "#fff7ed", border: "#fdba74", accent: "#ea580c" };
    }

    if (review === "rechazado" || review === "con_cambios") {
        return { bg: "#fef2f2", border: "#fecaca", accent: "#dc2626" };
    }

    if (status === "terminada" || review === "aprobado") {
        return { bg: "#ecfdf5", border: "#a7f3d0", accent: "#059669" };
    }

    if (status === "bloqueada" || Number(task.is_blocked || 0) === 1) {
        return { bg: "#fef2f2", border: "#fecaca", accent: "#dc2626" };
    }

    return { bg: "#f8fafc", border: "#e5e7eb", accent: "#2563eb" };
}

function isTaskInReview(task) {
    return ["en_revision", "pendiente_revision"].includes(
        String(task?.review_status || "").toLowerCase()
    );
}

function formatTaskDate(value) {
    return formatHumanDate(value);
}


function formatLogDayLabel(dateValue) {
    const d = parseDateSafe(dateValue);
    if (!d) return "Sin fecha";

    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const sameDay = (a, b) =>
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();

    if (sameDay(d, today)) return "Hoy";
    if (sameDay(d, yesterday)) return "Ayer";

    return formatHumanDate(dateValue, "Sin fecha");
}

function groupLogsByDay(logs) {
    const groups = [];

    logs.forEach((log) => {
        const label = formatLogDayLabel(log.created_at);
        const lastGroup = groups[groups.length - 1];

        if (!lastGroup || lastGroup.label !== label) {
            groups.push({
                label,
                items: [log],
            });
        } else {
            lastGroup.items.push(log);
        }
    });

    return groups;
}

function buildCompactReviewCycles(logs = []) {
    const ordered = [...(logs || [])].sort((a, b) => {
        const ad = new Date(a.created_at || 0).getTime();
        const bd = new Date(b.created_at || 0).getTime();
        if (ad !== bd) return ad - bd;
        return Number(a.id || 0) - Number(b.id || 0);
    });

    const cycles = [];
    let current = null;

    ordered.forEach((log) => {
        const action = String(log.action_type || "").toLowerCase();

        if (action === "enviado_revision") {
            current = {
                id: log.id,
                sentLog: log,
                reviewLog: null,
                otherLogs: [],
            };
            cycles.push(current);
            return;
        }

        if (
            current &&
            ["aprobado", "rechazado", "solicitud_cambios", "con_cambios"].includes(action)
        ) {
            current.reviewLog = log;
            return;
        }

        if (current) {
            current.otherLogs.push(log);
        }
    });

    return cycles.reverse();
}

function getCompactCycleResult(cycle) {
    const reviewLog = cycle?.reviewLog;
    const action = String(reviewLog?.action_type || "").toLowerCase();
    const reviewStatus = String(reviewLog?.review_status || "").toLowerCase();
    const newStatus = String(reviewLog?.new_status || "").toLowerCase();
    const newProgress = Number(reviewLog?.new_progress_percent || 0);

    if (action === "aprobado" || reviewStatus === "aprobado") {
        if (newStatus === "terminada" || newProgress >= 100) {
            return {
                label: "Aprobado final",
                bg: "#ecfdf5",
                color: "#166534",
                border: "#bbf7d0",
            };
        }

        return {
            label: "Aprobado parcial",
            bg: "#eff6ff",
            color: "#1d4ed8",
            border: "#bfdbfe",
        };
    }

    if (action === "rechazado" || reviewStatus === "rechazado") {
        return {
            label: "Rechazado",
            bg: "#fef2f2",
            color: "#991b1b",
            border: "#fecaca",
        };
    }

    if (action === "solicitud_cambios" || action === "con_cambios" || reviewStatus === "con_cambios") {
        return {
            label: "Cambios solicitados",
            bg: "#fff7ed",
            color: "#9a3412",
            border: "#fdba74",
        };
    }

    return {
        label: "Pendiente de revisión",
        bg: "#fffbeb",
        color: "#92400e",
        border: "#fde68a",
    };
}

function getCompactCycleProgress(cycle) {
    const sentLog = cycle?.sentLog;
    const reviewLog = cycle?.reviewLog;

    return (
        sentLog?.new_progress_percent ||
        reviewLog?.new_progress_percent ||
        sentLog?.old_progress_percent ||
        "—"
    );
}

function hasEvidenceItems(log) {
    return Array.isArray(log?.evidence_items) && log.evidence_items.length > 0;
}

function hasGeoEvidence(log) {
    return Array.isArray(log?.evidence_items) &&
        log.evidence_items.some((ev) =>
            Number(ev.has_geo || 0) === 1 || (ev.latitude && ev.longitude)
        );
}
function CompactTaskEvidenceList({ items = [] }) {
    const list = Array.isArray(items) ? items : [];

    if (list.length === 0) return null;

    return (
        <div style={{ marginTop: 10, display: "grid", gap: 8 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: "#d7efff" }}>
                Evidencias asociadas
            </div>

            {list.map((ev) => {
                const hasGeo =
                    Number(ev.has_geo || 0) === 1 ||
                    (ev.latitude && ev.longitude);

                const mapsUrl = hasGeo
                    ? `https://www.google.com/maps?q=${ev.latitude},${ev.longitude}`
                    : "";

                return (
                    <div
                        key={ev.id}
                        style={{
                            padding: 10,
                            borderRadius: 10,
                            background: "rgba(255,255,255,.04)",
                            border: "1px solid rgba(125,211,252,.18)",
                        }}
                    >
                        <div style={{ fontSize: 13, fontWeight: 800, color: "#ffffff" }}>
                            {ev.title || ev.file_name || "Evidencia"}
                        </div>

                        <div style={{ fontSize: 12, color: "#b9e8ff", marginTop: 2 }}>
                            {ev.evidence_type || "evidencia"} · {ev.evidence_context || "—"} ·{" "}
                            {ev.uploaded_by_name || "Usuario"}
                        </div>

                        {ev.description ? (
                            <div
                                style={{
                                    fontSize: 12,
                                    color: "#d7efff",
                                    marginTop: 6,
                                    whiteSpace: "pre-wrap",
                                }}
                            >
                                {ev.description}
                            </div>
                        ) : null}

                        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 8 }}>
                            {ev.file_url ? (
                                <a
                                    href={ev.file_url}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ color: "#2563eb", fontSize: 12, fontWeight: 800 }}
                                >
                                    Ver archivo
                                </a>
                            ) : null}

                            {ev.external_url ? (
                                <a
                                    href={ev.external_url}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ color: "#2563eb", fontSize: 12, fontWeight: 800 }}
                                >
                                    Abrir enlace
                                </a>
                            ) : null}

                            {hasGeo ? (
                                <a
                                    href={mapsUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ color: "#166534", fontSize: 12, fontWeight: 800 }}
                                >
                                    Ver ubicación
                                </a>
                            ) : null}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

function Nav360Button({ active, label, question, title, onClick }) {
    return (
        <button
            type="button"
            title={title}
            onClick={onClick}
            style={{
                padding: "10px 13px",
                borderRadius: 14,
                border: active ? "1px solid #f4b91b" : "1px solid rgba(125,211,252,.35)",
                background: active ? "#f4b91b" : "rgba(255,255,255,.04)",
                color: active ? "#06111f" : "#e6f8ff",
                cursor: "pointer",
                boxShadow: active ? "0 10px 22px rgba(244,185,27,.20)" : "none",
                transition: "all 0.18s ease",
                whiteSpace: "nowrap",
                textAlign: "left",
                minWidth: 136,
            }}
            onMouseEnter={(e) => {
                if (!active) {
                    e.currentTarget.style.background = "rgba(0,186,255,.14)";
                    e.currentTarget.style.border = "1px solid rgba(125,211,252,.65)";
                }
            }}
            onMouseLeave={(e) => {
                if (!active) {
                    e.currentTarget.style.background = "rgba(255,255,255,.04)";
                    e.currentTarget.style.border = "1px solid rgba(125,211,252,.35)";
                }
            }}
        >
            <div style={{ fontWeight: 900, fontSize: 12 }}>{label}</div>
            {question ? (
                <div style={{ fontSize: 10, lineHeight: 1.25, marginTop: 3, opacity: active ? 0.88 : 0.72 }}>
                    {question}
                </div>
            ) : null}
        </button>
    );
}

function SectionIntro({ tabKey }) {
    const guide = getTabGuide(tabKey);

    return (
        <div
            style={{
                background: "linear-gradient(180deg, #08324b 0%, #06283d 100%)",
                border: "1px solid rgba(0,186,255,.25)",
                borderRadius: 16,
                padding: 16,
                marginBottom: 16,
                boxShadow: "0 10px 24px rgba(0,0,0,.12)",
            }}
        >
            <div style={{ fontSize: 11, color: "#7dd3fc", fontWeight: 900, marginBottom: 6, letterSpacing: ".10em", textTransform: "uppercase" }}>
                {guide.label}
            </div>
            <div style={{ fontSize: 22, color: "#ffffff", fontWeight: 900, marginBottom: 6, letterSpacing: "-.01em" }}>
                {guide.question}
            </div>
            <div style={{ fontSize: 13, color: "#d7efff", lineHeight: 1.55 }}>
                {guide.tooltip}
            </div>
        </div>
    );
}

function truncateForCard(value, max = 180) {
    const text = String(value || "—").replace(/\s+/g, " ").trim();
    if (text.length <= max) return text;
    return `${text.slice(0, max).trim()}…`;
}


function PmoMiniCard({ title, question, value, subtitle, accent = "#2563eb", onClick }) {
    const displayValue = truncateForCard(value, 190);

    return (
        <button
            type="button"
            onClick={onClick}
            title={String(value || "")}
            style={{
                textAlign: "left",
                background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                border: "1px solid rgba(0,178,255,.24)",
                borderRadius: 18,
                padding: 18,
                cursor: onClick ? "pointer" : "default",
                boxShadow: "0 12px 28px rgba(0,0,0,.18)",
                minHeight: 172,
                alignSelf: "start",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                position: "relative",
                overflow: "hidden",
            }}
        >
            <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 6, background: accent }} />
            <div style={{ paddingLeft: 8 }}>
                <div style={{ fontSize: 14, fontWeight: 900, color: "#ffffff" }}>{title}</div>
                <div style={{ fontSize: 11, color: "#b9e8ff", marginTop: 4, fontWeight: 600 }}>{question}</div>
                <div
                    style={{
                        fontSize: 13,
                        fontWeight: 800,
                        color: "#ffffff",
                        marginTop: 12,
                        lineHeight: 1.48,
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitLineClamp: 6,
                        WebkitBoxOrient: "vertical",
                    }}
                >
                    {displayValue}
                </div>
                <div style={{ fontSize: 12, color: "#b9e8ff", marginTop: "auto", paddingTop: 12, fontWeight: 700 }}>
                    {subtitle || ""}
                </div>
            </div>
        </button>
    );
}

function ProjectDetailPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    const cameFromMyWork =
        !!location.state?.fromMyWork ||
        searchParams.get("from") === "my-work" ||
        searchParams.get("return_to") === "/my-work";

    const cameFromMyTaskDetail =
        !!location.state?.fromMyTaskDetail ||
        searchParams.get("from") === "my-task-detail" ||
        !!searchParams.get("return_to");

    const [access, setAccess] = useState(null);
    const [projectAccess, setProjectAccess] = useState([]);
    const [selectedUser, setSelectedUser] = useState("");
    const [accessDrafts, setAccessDrafts] = useState({});
    const initialTabFromQuery = searchParams.get("tab") || "";
    const initialTaskIdFromQuery = searchParams.get("task_id") || "";
    const taskIdFromUrl = searchParams.get("task_id");
    const initialModeFromQuery = searchParams.get("mode") || "view";
    const projectTabStorageKey = `pmo_active_tab_${id || "global"}`;

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [activeTab, setActiveTab] = useState(() => {
        if (typeof window === "undefined") return "overview";
        return localStorage.getItem(projectTabStorageKey) || "overview";
    });
    const [quickReadOpen, setQuickReadOpen] = useState(false);
    const [toast, setToast] = useState(null);

    const [savingProject, setSavingProject] = useState(false);
    const [savingBudget, setSavingBudget] = useState(false);
    const [savingUpdate, setSavingUpdate] = useState(false);
    const [savingTask, setSavingTask] = useState(false);
    const [savingRisk, setSavingRisk] = useState(false);
    const [savingMilestone, setSavingMilestone] = useState(false);
    const [savingDeliverable, setSavingDeliverable] = useState(false);
    const [savingDocument, setSavingDocument] = useState(false);
    const [savingArea, setSavingArea] = useState(false);
    const [savingStakeholder, setSavingStakeholder] = useState(false);
    const [savingScope, setSavingScope] = useState(false);

    const [project, setProject] = useState(null);
    const [usersCatalog, setUsersCatalog] = useState([]);
    const [updates, setUpdates] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [risks, setRisks] = useState([]);
    const [milestones, setMilestones] = useState([]);
    const [deliverables, setDeliverables] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [areas, setAreas] = useState([]);
    const [stakeholders, setStakeholders] = useState([]);
    const [scopeData, setScopeData] = useState(null);

    const [projectForm, setProjectForm] = useState(emptyProjectForm);
    const [budgetForm, setBudgetForm] = useState(emptyBudgetForm);
    const [updateForm, setUpdateForm] = useState(emptyUpdateForm);
    const [taskForm, setTaskForm] = useState(emptyTaskForm);
    const [riskForm, setRiskForm] = useState(emptyRiskForm);
    const [milestoneForm, setMilestoneForm] = useState(emptyMilestoneForm);
    const [deliverableForm, setDeliverableForm] = useState(emptyDeliverableForm);
    const [documentForm, setDocumentForm] = useState(emptyDocumentForm);
    const [areaForm, setAreaForm] = useState(emptyAreaForm);
    const [stakeholderForm, setStakeholderForm] = useState(emptyStakeholderForm);
    const [scopeForm, setScopeForm] = useState(emptyScopeForm);

    const [showProjectModal, setShowProjectModal] = useState(false);
    const [showBudgetModal, setShowBudgetModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showTaskModal, setShowTaskModal] = useState(false);
    const [showRiskModal, setShowRiskModal] = useState(false);
    const [showMilestoneModal, setShowMilestoneModal] = useState(false);
    const [showDeliverableModal, setShowDeliverableModal] = useState(false);
    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [showAreaModal, setShowAreaModal] = useState(false);
    const [showStakeholderModal, setShowStakeholderModal] = useState(false);
    const [showScopeModal, setShowScopeModal] = useState(false);

    const [updateMode, setUpdateMode] = useState("view");
    const [taskMode, setTaskMode] = useState("view");

    const currentTaskMode =
        taskMode ||
        searchParams.get("mode") ||
        location.state?.taskMode ||
        "edit";

    const canReviewCurrentTask =
        currentTaskMode === "review" &&
        Number(taskForm.requires_review || 0) === 1 &&
        isTaskInReview(taskForm);

    const [riskMode, setRiskMode] = useState("view");

    const [deliverableMode, setDeliverableMode] = useState("view");
    const [documentMode, setDocumentMode] = useState("view");
    const [documentUploadFile, setDocumentUploadFile] = useState(null);
    const [areaMode, setAreaMode] = useState("view");
    const [stakeholderMode, setStakeholderMode] = useState("view");

    const loggedUserId = useMemo(() => resolveLoggedUserId(usersCatalog), [usersCatalog]);
    const [taskLogs, setTaskLogs] = useState([]);
    const [loadingTaskLogs, setLoadingTaskLogs] = useState(false);
    const [savingTaskProgress, setSavingTaskProgress] = useState(false);
    const [reviewingTask, setReviewingTask] = useState(false);
    const [selectedTaskId, setSelectedTaskId] = useState("");
    const [hoveredTaskRowId, setHoveredTaskRowId] = useState("");


    const progressSectionRef = useRef(null);
    const reviewSectionRef = useRef(null);
    const tasksPanelRef = useRef(null);
    const selectedTaskPanelRef = useRef(null);
    const groupedTaskLogs = useMemo(() => groupLogsByDay(taskLogs || []), [taskLogs]);
    const compactReviewCycles = useMemo(
        () => buildCompactReviewCycles(taskLogs || []),
        [taskLogs]
    );
    const latestReviewSubmissionLog = useMemo(() => {
        return [...(taskLogs || [])].find((log) =>
            String(log.action_type || "").toLowerCase() === "enviado_revision"
        );
    }, [taskLogs]);

    const setActiveTabAndRemember = (tabKey) => {
        setActiveTab(tabKey);
        if (typeof window !== "undefined") {
            localStorage.setItem(projectTabStorageKey, tabKey);
        }
    };

    const goBackToMyWork = () => {
        navigate("/my-work");
    };



    const handleAddAccess = async () => {
        try {
            if (!selectedUser) {
                alert("Selecciona un usuario");
                return;
            }

            const json = await safeJsonFetch(`${API_BASE}/project_user_access_save.php`, {
                method: "POST",
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({
                    project_id: Number(id),
                    user_id: Number(selectedUser),
                }),
            });

            if (!json.success) {
                throw new Error(json.message || "No se pudo agregar acceso");
            }

            setSelectedUser("");
            await loadAll(id);
            setToast({ type: "ok", msg: "Acceso agregado correctamente" });
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo agregar acceso" });
        }
    };

    const updateAccessDraft = (userId, field, value) => {
        setAccessDrafts((prev) => ({
            ...prev,
            [userId]: {
                ...(prev[userId] || {}),
                [field]: value,
            },
        }));
    };

    const toggleAccessDraft = (userId, field) => {
        setAccessDrafts((prev) => ({
            ...prev,
            [userId]: {
                ...(prev[userId] || {}),
                [field]: Number(prev[userId]?.[field] || 0) === 1 ? 0 : 1,
            },
        }));
    };

    const saveAccessRow = async (userId) => {
        try {
            const draft = accessDrafts[userId];
            const original = (projectAccess || []).find((x) => Number(x.user_id) === Number(userId));
            if (!draft || !original) return;

            const originalType = String(original.access_type || "limited");
            const draftType = String(draft.access_type || "limited");

            if (originalType !== draftType) {
                const typeMap = {
                    full: "Total",
                    limited: "Limitado",
                    view_only: "Lectura",
                };

                const typeJson = await safeJsonFetch(`${API_BASE}/project_user_access_toggle.php`, {
                    method: "POST",
                    headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                    body: JSON.stringify({
                        project_id: Number(id),
                        user_id: Number(userId),
                        field: "access_type",
                        value: typeMap[draftType] || "Limitado",
                    }),
                });

                if (!typeJson.success) {
                    throw new Error(typeJson.message || "No se pudo actualizar tipo");
                }
            }

            const locked = draftType === "full" || draftType === "view_only";
            if (!locked) {
                const fields = [
                    "can_view_project",
                    "can_view_updates",
                    "can_view_tasks",
                    "can_edit_tasks",
                    "can_view_documents",
                    "can_upload_documents",
                    "can_view_scope",
                    "can_view_budget",
                ];

                for (const field of fields) {
                    const oldValue = Number(original[field] || 0);
                    const newValue = Number(draft[field] || 0);
                    if (oldValue !== newValue) {
                        const json = await safeJsonFetch(`${API_BASE}/project_user_access_toggle.php`, {
                            method: "POST",
                            headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                            body: JSON.stringify({
                                project_id: Number(id),
                                user_id: Number(userId),
                                field,
                            }),
                        });
                        if (!json.success) {
                            throw new Error(json.message || `No se pudo actualizar ${field}`);
                        }
                    }
                }
            }

            await loadAll(id);
            setToast({ type: "ok", msg: "Acceso actualizado correctamente" });
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo guardar acceso" });
        }
    };

    const removeAccess = async (userId) => {
        try {
            const ok = window.confirm("¿Eliminar este acceso del proyecto?");
            if (!ok) return;

            const json = await safeJsonFetch(`${API_BASE}/project_user_access_delete.php`, {
                method: "POST",
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({
                    project_id: Number(id),
                    user_id: Number(userId),
                }),
            });

            if (!json.success) {
                throw new Error(json.message || "No se pudo eliminar acceso");
            }

            await loadAll(id);
            setToast({ type: "ok", msg: "Acceso eliminado correctamente" });
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo eliminar acceso" });
        }
    };

    const handleCloseTaskModal = () => {
        setShowTaskModal(false);
        setTaskLogs([]);
        setTaskReviewForm({
            accion: "aprobar",
            comment: "",
        });
        setTaskProgressForm({
            progress_percent: "",
            comment: "",
            enviar_revision: false,
        });

        const directReturnTo =
            searchParams.get("return_to") ||
            location.state?.returnTo ||
            "";

        const directReturnLabel =
            searchParams.get("return_label") ||
            location.state?.returnLabel ||
            "";

        const isReturningToMyTaskDetail =
            directReturnTo.includes("/my-work/task/");

        if (isReturningToMyTaskDetail) {
            navigate(directReturnTo, {
                replace: true,
                state: {
                    fromProjectDetail: false,
                    fromFicha360: true,
                    returnTo: "",
                    returnLabel: "",
                },
            });
            return;
        }

        const originReturnTo =
            searchParams.get("origin_return_to") ||
            location.state?.originReturnTo ||
            "";

        const originReturnLabel =
            searchParams.get("origin_return_label") ||
            location.state?.originReturnLabel ||
            "";

        if (originReturnTo) {
            navigate(originReturnTo, {
                replace: true,
                state: {
                    returnTo: originReturnTo,
                    returnLabel: originReturnLabel || "Regresar",
                },
            });
            return;
        }

        if (cameFromMyTaskDetail && directReturnTo) {
            navigate(directReturnTo, {
                replace: true,
                state: {
                    returnTo: directReturnTo,
                    returnLabel: directReturnLabel || "Detalle de tarea",
                },
            });
            return;
        }

        setTaskMode("view");

        const next = new URLSearchParams(searchParams);
        next.delete("task_id");
        next.delete("mode");
        next.delete("return_to");
        next.delete("return_label");

        setSearchParams(next);
    };


    const [taskProgressForm, setTaskProgressForm] = useState({
        task_id: "",
        user_id: "",
        progress_percent: "",
        comment: "",
        enviar_revision: false,
    });

    const [taskReviewForm, setTaskReviewForm] = useState({
        task_id: "",
        reviewed_by_user_id: "",
        accion: "aprobar",
        comment: "",
    });

    const userOptions = useMemo(() => {
        return (usersCatalog || []).map((u) => ({
            value: String(u.id),
            label: u.label || u.display_name || `Usuario #${u.id}`,
        }));
    }, [usersCatalog]);

    const documentSectionOptions = useMemo(() => {
        const taskOptions = (tasks || []).map((t) => ({ value: String(t.id), label: `${t.wbs_code || t.id} · ${t.name || "Tarea"}` }));
        const riskOptions = (risks || []).map((r) => ({ value: String(r.id), label: r.risk_title || `Riesgo #${r.id}` }));
        const deliverableOptions = (deliverables || []).map((d) => ({ value: String(d.id), label: d.name || `Entregable #${d.id}` }));
        const stakeholderOptions = (stakeholders || []).map((s) => ({ value: String(s.id), label: s.name || `Stakeholder #${s.id}` }));
        const areaOptions = (areas || []).map((a) => ({ value: String(a.id), label: a.name || `Área #${a.id}` }));
        const updateOptions = (updates || []).map((u) => ({ value: String(u.id), label: `${u.update_date || ""} · ${u.title || `Avance #${u.id}`}` }));
        return {
            project: [],
            update: updateOptions,
            task: taskOptions,
            risk: riskOptions,
            deliverable: deliverableOptions,
            stakeholder: stakeholderOptions,
            area: areaOptions,
            scope: [{ value: String(id), label: "Alcance del proyecto" }],
        };
    }, [tasks, risks, deliverables, stakeholders, areas, updates, id]);

    const documentMatrix = useMemo(() => {
        const sectionOrder = ["project", "update", "task", "risk", "deliverable", "stakeholder", "area", "scope"];
        const matrix = {};
        sectionOrder.forEach((sec) => {
            matrix[sec] = { documento: 0, imagen: 0, evidencia: 0 };
        });

        (documents || []).forEach((doc) => {
            const sec = doc.section_type || "project";
            const mime = String(doc.file_type || "").toLowerCase();
            let cat = String(doc.document_category || "").toLowerCase();

            if (!["documento", "imagen", "evidencia"].includes(cat)) {
                if (mime.startsWith("image/")) {
                    cat = "imagen";
                } else if (cat.includes("evid")) {
                    cat = "evidencia";
                } else {
                    cat = "documento";
                }
            }

            if (!matrix[sec]) {
                matrix[sec] = { documento: 0, imagen: 0, evidencia: 0 };
            }
            matrix[sec][cat] = (matrix[sec][cat] || 0) + 1;
        });

        return sectionOrder.map((sec) => ({
            section: sec,
            documento: matrix[sec]?.documento || 0,
            imagen: matrix[sec]?.imagen || 0,
            evidencia: matrix[sec]?.evidencia || 0,
        }));
    }, [documents]);

    const uploadProjectDocument = async () => {
        if (!documentUploadFile) {
            throw new Error("Selecciona un archivo o imagen");
        }

        const form = new FormData();
        form.append("project_id", String(id));
        form.append("section_type", documentForm.section_type || "project");
        if (documentForm.section_id) form.append("section_id", String(documentForm.section_id));
        form.append("document_category", documentForm.document_category || "documento");
        form.append("title", documentForm.title || documentUploadFile.name);
        form.append("description", documentForm.description || "");
        form.append("uploaded_by_user_id", documentForm.uploaded_by_user_id || "");
        form.append("file", documentUploadFile);

        const res = await fetch(`${API_BASE}/project_document_upload.php`, {
            method: "POST",
            headers: buildAuthHeaders(),
            body: form,
        });
        const text = await res.text();
        const json = JSON.parse(text);
        if (!res.ok || !json.success) {
            throw new Error(json.message || "No se pudo subir el documento");
        }
        return json;
    };

    const getSectionLabel = (sectionType) =>
        DOCUMENT_SECTION_OPTIONS.find((opt) => opt.value === sectionType)?.label || sectionType || "Proyecto";

    const selectedTaskHasChildren = useMemo(() => {
        if (!taskForm?.id) return false;
        return hasChildTasks(taskForm.id, tasks);
    }, [taskForm, tasks]);

    const taskParentOptions = useMemo(() => {
        const currentId = String(taskForm?.id || "");
        const descendantIds = currentId ? new Set(getDescendantTaskIds(currentId, tasks)) : new Set();

        return (tasks || [])
            .filter((t) => {
                const candidateId = String(t.id || "");
                if (!candidateId) return false;
                if (candidateId === currentId) return false;
                if (descendantIds.has(candidateId)) return false;
                return true;
            })
            .sort((a, b) => String(a.wbs_code || "").localeCompare(String(b.wbs_code || ""), "es"))
            .map((t) => ({
                value: String(t.id),
                label: `${t.wbs_code || t.id} · ${t.name || "Sin nombre"}`,
            }));
    }, [taskForm?.id, tasks]);
    const taskDependencyOptions = useMemo(() => {
        const currentId = String(taskForm?.id || "");

        return (tasks || [])
            .filter((t) => String(t.id || "") !== currentId)
            .sort((a, b) => String(a.wbs_code || "").localeCompare(String(b.wbs_code || ""), "es"))
            .map((t) => ({
                value: String(t.id),
                label: `${t.wbs_code || t.id} · ${t.name || "Sin nombre"}`,
            }));
    }, [taskForm?.id, tasks]);

    const taskAreaOptions = useMemo(() => {
        return (areas || [])
            .sort((a, b) => String(a.name || "").localeCompare(String(b.name || ""), "es"))
            .map((a) => ({
                value: String(a.id),
                label: a.name || `Área #${a.id}`,
            }));
    }, [areas]);

    const selectedTaskCard = useMemo(() => {
        if (!selectedTaskId) return null;
        return tasks.find((t) => String(t.id) === String(selectedTaskId)) || null;
    }, [selectedTaskId, tasks]);

    const selectedTaskChildren = useMemo(() => {
        if (!selectedTaskCard?.id) return [];
        return getChildTasks(selectedTaskCard.id, tasks).sort((a, b) => String(a.wbs_code || "").localeCompare(String(b.wbs_code || ""), "es"));
    }, [selectedTaskCard, tasks]);

    const selectedTaskPanelTone = useMemo(() => getTaskPanelTone(selectedTaskCard), [selectedTaskCard]);

    const projectCompletion = useMemo(() => {
        if (!tasks.length) return 0;
        const total = tasks.reduce((acc, item) => acc + Number(item.progress_percent || 0), 0);
        return Math.round(total / tasks.length);
    }, [tasks]);



    useEffect(() => {
        if (id) loadAll(id);
    }, [id]);

    useEffect(() => {
        if (!toast) return;
        const t = setTimeout(() => setToast(null), 3200);
        return () => clearTimeout(t);
    }, [toast]);

    useEffect(() => {
        const drafts = {};
        (projectAccess || []).forEach((a) => {
            drafts[a.user_id] = {
                access_type: a.access_type || "limited",
                can_view_project: Number(a.can_view_project) || 0,
                can_view_updates: Number(a.can_view_updates) || 0,
                can_view_tasks: Number(a.can_view_tasks) || 0,
                can_edit_tasks: Number(a.can_edit_tasks) || 0,
                can_view_documents: Number(a.can_view_documents) || 0,
                can_upload_documents: Number(a.can_upload_documents) || 0,
                can_view_scope: Number(a.can_view_scope) || 0,
                can_view_budget: Number(a.can_view_budget) || 0,
            };
        });
        setAccessDrafts(drafts);
    }, [projectAccess]);

    useEffect(() => {
        if (typeof window === "undefined") return;
        localStorage.setItem(projectTabStorageKey, activeTab);
    }, [projectTabStorageKey, activeTab]);

    useEffect(() => {
        if (typeof window === "undefined") return;
        if (initialTabFromQuery) return;

        const storedTab = localStorage.getItem(projectTabStorageKey);
        if (storedTab && storedTab !== activeTab) {
            setActiveTab(storedTab);
        }
    }, [projectTabStorageKey, initialTabFromQuery]);


    useEffect(() => {
        if (!tasks.length) return;
        if (!initialTaskIdFromQuery) return;

        const foundTask = tasks.find(
            (t) => String(t.id) === String(initialTaskIdFromQuery)
        );

        if (!foundTask) return;

        if (initialTabFromQuery) {
            setActiveTabAndRemember(initialTabFromQuery);
        } else {
            setActiveTabAndRemember("tasks");
        }

        setSelectedTaskId(String(foundTask.id || ""));

        const safeMode = ["view", "edit", "progress", "review"].includes(initialModeFromQuery)
            ? initialModeFromQuery
            : "edit";

        openTaskModal(foundTask, safeMode);

        //const newParams = new URLSearchParams(searchParams);
        //newParams.delete("task_id");
        //newParams.delete("mode");
        //setSearchParams(newParams, { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tasks]);

    useEffect(() => {
        if (!showTaskModal) return;

        const timer = setTimeout(() => {
            if (taskMode === "progress" && progressSectionRef.current) {
                progressSectionRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }

            if (taskMode === "review" && reviewSectionRef.current) {
                reviewSectionRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }, 150);

        return () => clearTimeout(timer);
    }, [showTaskModal, taskMode]);

    useEffect(() => {
        if (!location.state?.openTaskId) return;
        if (!tasks.length) return;

        const { openTaskId, taskMode } = location.state;

        const foundTask = tasks.find(
            (t) => String(t.id) === String(openTaskId)
        );

        if (!foundTask) return;

        setActiveTab("tasks");
        setSelectedTaskId(String(foundTask.id || ""));

        const safeModeFromState = taskMode || searchParams.get("mode") || "edit";

        const safeMode = ["view", "edit", "progress", "review"].includes(safeModeFromState)
            ? safeModeFromState
            : "edit";

        openTaskModal(foundTask, safeMode);
    }, [location.state, tasks, searchParams]);

    useEffect(() => {
        if (!tasks.length) {
            setSelectedTaskId("");
            return;
        }

        const incomingTaskId =
            searchParams.get("task_id") ||
            location.state?.openTaskId ||
            location.state?.taskId ||
            "";

        if (incomingTaskId && tasks.some((t) => String(t.id) === String(incomingTaskId))) {
            setSelectedTaskId(String(incomingTaskId));
            return;
        }

        const storageKey = `pmo_selected_task_${id}`;
        const hasCurrentSelection =
            selectedTaskId && tasks.some((t) => String(t.id) === String(selectedTaskId));

        if (hasCurrentSelection) return;

        const storedTaskId = localStorage.getItem(storageKey) || "";
        if (storedTaskId && tasks.some((t) => String(t.id) === String(storedTaskId))) {
            setSelectedTaskId(String(storedTaskId));
            return;
        }

        const sorted = [...tasks].sort((a, b) =>
            String(a.wbs_code || "").localeCompare(String(b.wbs_code || ""), "es")
        );

        setSelectedTaskId(String(sorted[0]?.id || ""));
    }, [tasks, selectedTaskId, id, searchParams, location.state]);

    useEffect(() => {
        if (!id || !selectedTaskId) return;
        localStorage.setItem(`pmo_selected_task_${id}`, String(selectedTaskId));
    }, [id, selectedTaskId]);

    useEffect(() => {
        if (activeTab !== "tasks") return;
        if (!selectedTaskId) return;
        if (typeof window === "undefined") return;
        if (window.innerWidth > 1024) return;

        const timer = setTimeout(() => {
            if (selectedTaskPanelRef.current) {
                selectedTaskPanelRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }, 120);

        return () => clearTimeout(timer);
    }, [activeTab, selectedTaskId]);

    useEffect(() => {
        if (activeTab !== "tasks") return;
        if (!selectedTaskId) return;
        loadTaskLogs(selectedTaskId);
    }, [activeTab, selectedTaskId]);


    const loadAll = async (projectId) => {
        try {
            setLoading(true);
            setError("");


            // 🔐 CARGAR PERMISOS
            const accessPayload = await safeJsonFetch(
                `${API_BASE}/project_user_access_get.php?project_id=${projectId}`,
                { headers: buildAuthHeaders() }
            );

            setAccess(accessPayload.data || {});
            const [
                usersPayload,
                projectPayload,
                updatesPayload,
                tasksPayload,
                risksPayload,
                milestonesPayload,
                deliverablesPayload,
                documentsPayload,
                areasPayload,
                stakeholdersPayload,
                accessListPayload,
            ] = await Promise.all([
                safeJsonFetch(`${API_BASE}/catalog_users_list.php`, {
                    headers: buildAuthHeaders(),
                }),
                safeJsonFetch(`${API_BASE}/projects.php?id=${projectId}`, {
                    headers: buildAuthHeaders(),
                }),
                safeJsonFetch(`${API_BASE}/project_updates.php?project_id=${projectId}`, {
                    headers: buildAuthHeaders(),
                }),
                safeJsonFetch(`${API_BASE}/project_tasks.php?project_id=${projectId}`, {
                    headers: buildAuthHeaders(),
                }),
                safeJsonFetch(`${API_BASE}/project_risks.php?project_id=${projectId}`, {
                    headers: buildAuthHeaders(),
                }),
                safeJsonFetch(`${API_BASE}/project_milestones.php?project_id=${projectId}`, {
                    headers: buildAuthHeaders(),
                }).catch((err) => {
                    console.warn("Milestones no disponibles todavía:", err);
                    return {
                        success: true,
                        items: [],
                        data: [],
                        stats: {
                            total: 0,
                            pendientes: 0,
                            en_proceso: 0,
                            en_riesgo: 0,
                            cumplidos: 0,
                            retrasados: 0,
                            cancelados: 0,
                            decision_gates: 0,
                        },
                        warning: err?.message || "Endpoint de milestones no disponible",
                    };
                }),
                safeJsonFetch(`${API_BASE}/project_deliverables.php?project_id=${projectId}`, {
                    headers: buildAuthHeaders(),
                }),
                safeJsonFetch(`${API_BASE}/project_documents.php?project_id=${projectId}`, {
                    headers: buildAuthHeaders(),
                }),
                safeJsonFetch(`${API_BASE}/project_areas.php?project_id=${projectId}`, {
                    headers: buildAuthHeaders(),
                }),
                safeJsonFetch(`${API_BASE}/project_stakeholders.php?project_id=${projectId}`, {
                    headers: buildAuthHeaders(),
                }),
                safeJsonFetch(`${API_BASE}/project_user_access_list.php?project_id=${projectId}`, {
                    headers: buildAuthHeaders(),
                }),
            ]);


            if (!usersPayload?.success) throw new Error(usersPayload?.message || "No se pudo cargar usuarios");
            if (!projectPayload?.success) throw new Error(projectPayload?.message || "No se pudo cargar proyecto");
            if (!updatesPayload?.success) throw new Error(updatesPayload?.message || "No se pudieron cargar avances");
            if (!tasksPayload?.success) throw new Error(tasksPayload?.message || "No se pudieron cargar tareas");
            if (!risksPayload?.success) throw new Error(risksPayload?.message || "No se pudieron cargar riesgos");
            if (!milestonesPayload?.success) {
                console.warn("No se pudieron cargar milestones:", milestonesPayload?.message);
            }
            if (!deliverablesPayload?.success) throw new Error(deliverablesPayload?.message || "No se pudieron cargar entregables");
            if (!documentsPayload?.success) throw new Error(documentsPayload?.message || "No se pudieron cargar documentos");
            if (!areasPayload?.success) throw new Error(areasPayload?.message || "No se pudieron cargar áreas");
            if (!stakeholdersPayload?.success) throw new Error(stakeholdersPayload?.message || "No se pudieron cargar stakeholders");

            setUsersCatalog(usersPayload.data || []);
            setProject(projectPayload.data || null);
            setUpdates(updatesPayload.data || []);
            setTasks(tasksPayload.data || []);
            setRisks(risksPayload.data || []);
            setMilestones(milestonesPayload.items || milestonesPayload.data || []);
            setDeliverables(deliverablesPayload.data || []);
            setDocuments(documentsPayload.data || []);
            setAreas(areasPayload.data || []);
            setStakeholders(stakeholdersPayload.data || []);
            setProjectAccess(accessListPayload?.success ? accessListPayload.data || [] : []);
            setScopeData(
                projectPayload?.data
                    ? {
                        project_objective: projectPayload.data.scope_statement || "",
                        product_scope: projectPayload.data.scope_statement || "",
                        deliverables: "",
                        acceptance_criteria: projectPayload.data.success_criteria || "",
                        exclusions: "",
                        created_by_user_id: projectPayload.data.created_by_user_id || "",
                    }
                    : null
            );
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al cargar ficha 360");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (setter) => (e) => {
        const { name, value } = e.target;
        setter((prev) => ({ ...prev, [name]: value }));
    };

    const openProjectModal = () => {
        if (!project) return;
        setProjectForm({
            ...emptyProjectForm,
            ...project,
            id: String(project.id || ""),
            account_id: project.account_id ? String(project.account_id) : "",
            opportunity_id: project.opportunity_id ? String(project.opportunity_id) : "",
            project_manager_user_id: project.project_manager_user_id ? String(project.project_manager_user_id) : (loggedUserId || ""),
            sponsor_user_id: project.sponsor_user_id ? String(project.sponsor_user_id) : "",
            created_by_user_id: project.created_by_user_id ? String(project.created_by_user_id) : (loggedUserId || ""),
        });
        setShowProjectModal(true);
    };

    const openBudgetModal = () => {
        if (!project) return;
        setBudgetForm({
            ...emptyBudgetForm,
            ...project,
            id: String(project.id || ""),
            account_id: project.account_id ? String(project.account_id) : "",
            opportunity_id: project.opportunity_id ? String(project.opportunity_id) : "",
            contract_value: project.contract_value ?? "",
            budget_planned: project.budget_planned ?? "",
            budget_actual: project.budget_actual ?? "",
            currency: project.currency || "MXN",
            ebitda_impact_est: project.ebitda_impact_est ?? "",
            budget_description: project.budget_description || "",
            budget_justification: project.budget_justification || "",
            budget_notes: project.budget_notes || "",
        });
        setShowBudgetModal(true);
    };

    const openUpdateModal = (item = null, mode = "view") => {
        setUpdateMode(mode);
        if (item) {
            setUpdateForm({
                ...emptyUpdateForm,
                ...item,
                id: String(item.id || ""),
                project_id: String(item.project_id || id),
                created_by: item.created_by ? String(item.created_by) : (loggedUserId || ""),
            });
        } else {
            setUpdateForm({
                ...emptyUpdateForm,
                project_id: String(id),
                update_date: new Date().toISOString().slice(0, 10),
                created_by: loggedUserId || "",
            });
            setUpdateMode("edit");
        }
        setShowUpdateModal(true);
    };

    const getDefaultReviewerUserId = () => {
        return (
            project?.project_manager_user_id ||
            projectForm?.project_manager_user_id ||
            ""
        );
    };

    const openTaskModal = (item = null, mode = "view") => {
        setTaskMode(mode);

        if (item) {
            const normalizedTask = {
                ...emptyTaskForm,
                ...item,
                id: String(item.id || ""),
                project_id: String(item.project_id || id),
                parent_task_id: item.parent_task_id ? String(item.parent_task_id) : "",
                depends_on_task_id: item.depends_on_task_id ? String(item.depends_on_task_id) : "",
                dependency_type: item.dependency_type || "FS",
                lag_days:
                    item.lag_days !== undefined && item.lag_days !== null
                        ? String(item.lag_days)
                        : "0",
                owner_user_id: item.owner_user_id ? String(item.owner_user_id) : (loggedUserId || ""),
                reviewer_user_id: item.reviewer_user_id ? String(item.reviewer_user_id) : "",
                requires_review: Number(item.requires_review || 0),
                review_status: item.review_status || "borrador",
                evidence_required: Number(item.evidence_required || 0),
                geo_evidence_required: Number(item.geo_evidence_required || 0),
                reviewer_evidence_required: Number(item.reviewer_evidence_required || 0),
                reviewer_geo_evidence_required: Number(item.reviewer_geo_evidence_required || 0),
                area_id: item.area_id ? String(item.area_id) : "",
                progress_percent:
                    item.progress_percent !== undefined && item.progress_percent !== null
                        ? String(item.progress_percent)
                        : "0",
            };

            setTaskForm(normalizedTask);

            setTaskProgressForm({
                task_id: String(item.id || ""),
                user_id: loggedUserId || "",
                progress_percent:
                    item.progress_percent !== undefined && item.progress_percent !== null
                        ? String(item.progress_percent)
                        : "0",
                comment: "",
                enviar_revision: false,
            });

            setTaskReviewForm({
                task_id: String(item.id || ""),
                reviewed_by_user_id: loggedUserId || "",
                accion: "aprobar",
                comment: "",
            });

            setSelectedTaskId(String(item.id || ""));
            loadTaskLogs(item.id);
        } else {
            const defaultReviewerUserId = getDefaultReviewerUserId();

            setTaskForm({
                ...emptyTaskForm,
                project_id: String(id),
                owner_user_id: loggedUserId || "",
                reviewer_user_id: defaultReviewerUserId ? String(defaultReviewerUserId) : "",
                requires_review: 1,
                review_status: "borrador",
                evidence_required: 0,
                geo_evidence_required: 0,
                reviewer_evidence_required: 0,
                reviewer_geo_evidence_required: 0,
                dependency_type: "FS",
                lag_days: 0,
                area_id: "",
            });

            setTaskProgressForm({
                task_id: "",
                user_id: loggedUserId || "",
                progress_percent: "0",
                comment: "",
                enviar_revision: false,
            });

            setTaskReviewForm({
                task_id: "",
                reviewed_by_user_id: loggedUserId || "",
                accion: "aprobar",
                comment: "",
            });

            setTaskLogs([]);
            setTaskMode("edit");
        }

        setShowTaskModal(true);
        //    handleCloseTaskModal();
    };

    const openRiskModal = (item = null, mode = "view") => {
        setRiskMode(mode);
        if (item) {
            setRiskForm({
                ...emptyRiskForm,
                ...item,
                id: String(item.id || ""),
                project_id: String(item.project_id || id),
                owner_user_id: item.owner_user_id ? String(item.owner_user_id) : (loggedUserId || ""),
                risk_level: item.risk_level || item.level || "medio",
                mitigation_plan: item.mitigation_plan || "",
                owner_name: item.owner_name || item.owner_display_name || item.owner_name_text || "",
            });
        } else {
            setRiskForm({
                ...emptyRiskForm,
                project_id: String(id),
                owner_user_id: loggedUserId || "",
                risk_level: "medio",
                mitigation_plan: "",
            });
            setRiskMode("edit");
        }
        setShowRiskModal(true);
    };

    const openDeliverableModal = (item = null, mode = "view") => {
        setDeliverableMode(mode);
        if (item) {
            setDeliverableForm({
                ...emptyDeliverableForm,
                ...item,
                id: String(item.id || ""),
                project_id: String(item.project_id || id),
                owner_user_id: item.owner_user_id ? String(item.owner_user_id) : (loggedUserId || ""),
            });
        } else {
            setDeliverableForm({
                ...emptyDeliverableForm,
                project_id: String(id),
                owner_user_id: loggedUserId || "",
            });
            setDeliverableMode("edit");
        }
        setShowDeliverableModal(true);
    };

    const openDocumentModal = (item = null, mode = "view") => {
        setDocumentMode(mode);
        setDocumentUploadFile(null);
        if (item) {
            setDocumentForm({
                ...emptyDocumentForm,
                ...item,
                id: String(item.id || ""),
                project_id: String(item.project_id || id),
                section_type: item.section_type || "project",
                section_id: item.section_id ? String(item.section_id) : "",
                document_category: item.document_category || "documento",
                title: item.title || item.document_name || "",
                description: item.description || "",
                file_name: item.file_name || "",
                file_url: item.file_url || item.file_path || "",
                uploaded_by_user_id: item.uploaded_by_user_id ? String(item.uploaded_by_user_id) : (loggedUserId || ""),
            });
        } else {
            setDocumentForm({
                ...emptyDocumentForm,
                project_id: String(id),
                uploaded_by_user_id: loggedUserId || "",
            });
            setDocumentMode("edit");
        }
        setShowDocumentModal(true);
    };

    const openAreaModal = (item = null, mode = "view") => {
        setAreaMode(mode);
        if (item) {
            setAreaForm({
                ...emptyAreaForm,
                ...item,
                id: String(item.id || ""),
                project_id: String(item.project_id || id),
                parent_area_id: item.parent_area_id ? String(item.parent_area_id) : "",
                owner_user_id: item.owner_user_id ? String(item.owner_user_id) : "",
                progress_percent: item.progress_percent ?? 0,
            });
        } else {
            setAreaForm({
                ...emptyAreaForm,
                project_id: String(id),
                owner_user_id: loggedUserId || "",
            });
            setAreaMode("edit");
        }
        setShowAreaModal(true);
    };


    const openStakeholderModal = (item = null, mode = "view") => {
        setStakeholderMode(mode);
        if (item) {
            setStakeholderForm({
                ...emptyStakeholderForm,
                ...item,
                id: String(item.id || ""),
                project_id: String(item.project_id || id),
                user_id: item.user_id ? String(item.user_id) : "",
                is_primary_contact: Number(item.is_primary_contact || 0) === 1,
            });
        } else {
            setStakeholderForm({
                ...emptyStakeholderForm,
                project_id: String(id),
            });
            setStakeholderMode("edit");
        }
        setShowStakeholderModal(true);
    };

    const openScopeModal = () => {
        setScopeForm({
            ...emptyScopeForm,
            ...(scopeData || {}),
            project_id: String(id),
            created_by_user_id: scopeData?.created_by_user_id ? String(scopeData.created_by_user_id) : (loggedUserId || ""),
        });
        setShowScopeModal(true);
    };

    // bloque 3

    const saveProject = async () => {
        try {
            setSavingProject(true);

            const payload = {
                ...project,
                ...projectForm,
                id: Number(projectForm.id),
                account_id: projectForm.account_id || null,
                opportunity_id: projectForm.opportunity_id || null,
                project_manager_user_id: projectForm.project_manager_user_id || null,
                sponsor_user_id: projectForm.sponsor_user_id || null,
                created_by_user_id: projectForm.created_by_user_id || null,
                progress_percent: projectForm.progress_percent || 0,
                contract_value: project?.contract_value ?? null,
                budget_planned: project?.budget_planned ?? null,
                budget_actual: project?.budget_actual ?? null,
                budget_description: project?.budget_description ?? null,
                budget_justification: project?.budget_justification ?? null,
                budget_notes: project?.budget_notes ?? null,
                currency: project?.currency || "MXN",
                ebitda_impact_est: project?.ebitda_impact_est ?? null,
                project_manager: project?.project_manager || null,
                sponsor: project?.sponsor || null,
            };

            const json = await safeJsonFetch(`${API_BASE}/projects.php`, {
                method: "PUT",
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            if (!json.success) throw new Error(json.message || "No se pudo guardar el proyecto");

            setShowProjectModal(false);
            setToast({ type: "ok", msg: "Proyecto guardado correctamente" });
            await loadAll(id);
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo guardar el proyecto" });
        } finally {
            setSavingProject(false);
        }
    };

    const saveBudget = async () => {
        try {
            setSavingBudget(true);

            const payload = {
                ...project,
                ...budgetForm,
                id: Number(budgetForm.id),
                account_id: budgetForm.account_id || null,
                opportunity_id: budgetForm.opportunity_id || null,
                project_manager_user_id: project?.project_manager_user_id || null,
                sponsor_user_id: project?.sponsor_user_id || null,
                created_by_user_id: project?.created_by_user_id || null,
                progress_percent: project?.progress_percent || 0,
                contract_value: budgetForm.contract_value || null,
                budget_planned: budgetForm.budget_planned || null,
                budget_actual: budgetForm.budget_actual || null,
                currency: budgetForm.currency || "MXN",
                ebitda_impact_est: budgetForm.ebitda_impact_est || null,
                budget_description: budgetForm.budget_description || null,
                budget_justification: budgetForm.budget_justification || null,
                budget_notes: budgetForm.budget_notes || null,
            };

            const json = await safeJsonFetch(`${API_BASE}/projects.php`, {
                method: "PUT",
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            if (!json.success) throw new Error(json.message || "No se pudo guardar el presupuesto");

            setShowBudgetModal(false);
            setToast({ type: "ok", msg: "Presupuesto guardado correctamente" });
            await loadAll(id);
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo guardar el presupuesto" });
        } finally {
            setSavingBudget(false);
        }
    };

    const saveUpdate = async () => {
        try {
            setSavingUpdate(true);

            const method = updateForm.id ? "PUT" : "POST";

            const payload = {
                ...updateForm,
                project_id: id,
                created_by: updateForm.created_by || null,
                summary: updateForm.summary || null,
                description: updateForm.description || null,
                status_note: updateForm.status_note || null,
            };
            console.log("UPDATE PAYLOAD", payload);
            console.log("UPDATE PAYLOAD RAW", payload);
            console.log("UPDATE PAYLOAD JSON", JSON.stringify(payload, null, 2));

            const json = await safeJsonFetch(`${API_BASE}/project_updates.php`, {
                method,
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            if (!json.success) throw new Error(json.message || "No se pudo guardar el avance");

            setShowUpdateModal(false);
            setToast({ type: "ok", msg: "Avance guardado correctamente" });
            await loadAll(id);
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo guardar el avance" });
        } finally {
            setSavingUpdate(false);
        }
    };

    const saveTask = async () => {
        try {
            setSavingTask(true);

            const method = taskForm.id ? "PUT" : "POST";
            const isParentTask = taskForm.id ? hasChildTasks(taskForm.id, tasks) : false;


            const payload = {
                id: taskForm.id ? Number(taskForm.id) : null,
                project_id: Number(id),

                parent_task_id: taskForm.parent_task_id ? Number(taskForm.parent_task_id) : null,
                depends_on_task_id: taskForm.depends_on_task_id ? Number(taskForm.depends_on_task_id) : null,
                dependency_type: taskForm.dependency_type || "FS",
                lag_days:
                    taskForm.lag_days === "" || taskForm.lag_days === null || taskForm.lag_days === undefined
                        ? 0
                        : Number(taskForm.lag_days),

                area_id: taskForm.area_id ? Number(taskForm.area_id) : null,

                wbs_code: taskForm.wbs_code || null,
                name: taskForm.name || "",
                description: taskForm.description || null,

                status: taskForm.status || "pendiente",
                priority: taskForm.priority || "media",

                start_date: taskForm.start_date || null,
                due_date: taskForm.due_date || null,
                end_date: taskForm.end_date || null,

                progress_percent: isParentTask
                    ? Number(taskForm.progress_percent || 0)
                    : (
                        taskForm.progress_percent === "" || taskForm.progress_percent === null
                            ? 0
                            : Number(taskForm.progress_percent)
                    ),

                owner_user_id: taskForm.owner_user_id ? Number(taskForm.owner_user_id) : null,
                reviewer_user_id: taskForm.reviewer_user_id ? Number(taskForm.reviewer_user_id) : null,

                requires_review: Number(taskForm.requires_review || 0),
                review_status: taskForm.review_status || "borrador",

                evidence_required: Number(taskForm.evidence_required || 0),
                geo_evidence_required: Number(taskForm.geo_evidence_required || 0),

                reviewer_evidence_required: Number(taskForm.reviewer_evidence_required || 0),
                reviewer_geo_evidence_required: Number(taskForm.reviewer_geo_evidence_required || 0),
            };
            console.log("TASK PAYLOAD", payload);
            const json = await safeJsonFetch(`${API_BASE}/project_tasks.php`, {
                method,
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            if (!json.success) throw new Error(json.message || "No se pudo guardar la tarea");

            setShowTaskModal(false);
            setToast({ type: "ok", msg: "Tarea guardada correctamente" });
            await loadAll(id);
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo guardar la tarea" });
        } finally {
            setSavingTask(false);
        }
    };

    const loadTaskLogs = async (taskId) => {
        try {
            if (!taskId) {
                setTaskLogs([]);
                return;
            }

            setLoadingTaskLogs(true);

            const json = await safeJsonFetch(`${API_BASE}/task_logs.php?task_id=${taskId}`, {
                headers: buildAuthHeaders(),
            });

            if (!json.success) {
                throw new Error(json.message || "No se pudo cargar la bitácora de la tarea");
            }

            setTaskLogs(Array.isArray(json.data) ? json.data : []);
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo cargar la bitácora" });
            setTaskLogs([]);
        } finally {
            setLoadingTaskLogs(false);
        }
    };



    const saveTaskProgressUpdate = async () => {
        try {
            setSavingTaskProgress(true);
            const response = await fetch(`${API_BASE}/project_task_progress.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...buildAuthHeaders(),
                },
                body: JSON.stringify({
                    task_id: Number(taskForm.id),
                    project_id: Number(id),
                    progress_percent: taskProgressForm.progress_percent,
                    comment: taskProgressForm.comment,
                    enviar_revision: !!taskProgressForm.enviar_revision,
                    user_id: loggedUserId,
                })
            });

            const raw = await response.text();
            console.log("STATUS:", response.status);
            console.log("RAW RESPONSE:", raw);

            if (!raw || !raw.trim()) {
                throw new Error("El backend respondió vacío");
            }

            let result = {};
            try {
                result = JSON.parse(raw);
            } catch (e) {
                throw new Error(`El backend no devolvió JSON válido. Respuesta: ${raw}`);
            }

            if (!response.ok || !result.success) {
                throw new Error(result.message || result.detail || "No se pudo guardar el avance");
            }

            alert(result.message || "Avance guardado correctamente");

            setTaskProgressForm({
                progress_percent: "",
                comment: "",
                enviar_revision: false,
            });

            if (cameFromMyWork) {
                navigate("/my-work");
                return;
            }

            await loadTaskLogs(taskForm.id);

            if (id) {
                await loadAll(id);
            }
        } catch (error) {
            console.error(error);
            alert(error.message || "Error al guardar avance");
        } finally {
            setSavingTaskProgress(false);
        }
    };


    const reviewTaskProgress = async (log, accion) => {
        try {
            setReviewingTask(true);

            const reviewerUserId =
                Number(loggedUserId || 0) ||
                Number(taskForm.reviewer_user_id || 0) ||
                Number(selectedTask?.reviewer_user_id || 0) ||
                0;

            const activeTaskForReview = taskForm?.id
                ? taskForm
                : selectedTaskCard;

            if (
                taskForm?.id &&
                selectedTaskCard?.id &&
                String(taskForm.id) !== String(selectedTaskCard.id)
            ) {
                console.warn("Desalineación de tarea", {
                    taskFormId: taskForm.id,
                    selectedTaskCardId: selectedTaskCard.id,
                    taskFormName: taskForm.name,
                    selectedTaskCardName: selectedTaskCard.name,
                });
            }

            console.log("DEBUG REVISION TASK", {
                accion,
                taskFormId: taskForm?.id,
                taskFormName: taskForm?.name,
                selectedTaskCardId: selectedTaskCard?.id,
                selectedTaskCardName: selectedTaskCard?.name,
                activeTaskId: activeTaskForReview?.id,
                activeTaskName: activeTaskForReview?.name,
            });


            const response = await fetch(`${API_BASE}/project_task_review.php?t=${Date.now()}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    project_id: Number(id),
                    task_id: Number(activeTaskForReview?.id || 0),
                    reviewer_user_id: Number(
                        loggedUserId ||
                        activeTaskForReview?.reviewer_user_id ||
                        selectedTaskCard?.reviewer_user_id ||
                        0
                    ),
                    accion,
                    comment: taskReviewForm.comment || "",
                }),
            });

            const raw = await response.text();

            console.log("REVIEW HTTP STATUS:", response.status);
            console.log("REVIEW RAW RESPONSE:", raw);

            if (!raw || !raw.trim()) {
                throw new Error(`El backend respondió vacío. HTTP ${response.status}`);
            }

            let result;
            try {
                result = JSON.parse(raw);
            } catch (e) {
                throw new Error(`El backend no devolvió JSON válido: ${raw}`);
            }

            if (!response.ok || !result.success) {
                throw new Error(result.message || result.detail || "No se pudo aplicar la revisión");
            }

            alert(result.message || "Revisión aplicada correctamente");

            setTaskReviewForm({
                accion: "aprobar",
                comment: "",
            });

            if (cameFromMyWork) {
                navigate("/my-work");
                return;
            }

            await loadTaskLogs(taskForm.id);

            if (id) {
                await loadAll(id);
            }
        } catch (error) {
            console.error(error);
            alert(error.message || "Error al revisar la tarea");
        } finally {
            setReviewingTask(false);
        }
    };




    const openMilestoneModal = (item = null) => {
        if (item) {
            setMilestoneForm({
                ...emptyMilestoneForm,
                ...item,
                id: String(item.id || ""),
                project_id: String(item.project_id || id || ""),
                target_date: item.target_date || "",
                actual_date: item.actual_date || "",
                related_task_id: item.related_task_id ? String(item.related_task_id) : "",
                related_deliverable_id: item.related_deliverable_id ? String(item.related_deliverable_id) : "",
                owner_user_id: item.owner_user_id ? String(item.owner_user_id) : "",
                decision_gate: Number(item.decision_gate || 0),
            });
        } else {
            setMilestoneForm({
                ...emptyMilestoneForm,
                project_id: String(id || ""),
                owner_user_id: loggedUserId || "",
            });
        }

        setShowMilestoneModal(true);
    };

    const saveMilestone = async () => {
        try {
            setSavingMilestone(true);

            const title = String(milestoneForm.title || "").trim();
            if (!title) {
                throw new Error("Captura el título del hito antes de guardar.");
            }

            const method = milestoneForm.id ? "PUT" : "POST";
            const payload = {
                id: milestoneForm.id ? Number(milestoneForm.id) : undefined,
                project_id: Number(milestoneForm.project_id || id),
                title,
                description: milestoneForm.description || "",
                milestone_type: milestoneForm.milestone_type || "control",
                status: milestoneForm.status || "pendiente",
                health_status: milestoneForm.health_status || "verde",
                target_date: milestoneForm.target_date || null,
                actual_date: milestoneForm.actual_date || null,
                related_task_id: milestoneForm.related_task_id ? Number(milestoneForm.related_task_id) : null,
                related_deliverable_id: milestoneForm.related_deliverable_id ? Number(milestoneForm.related_deliverable_id) : null,
                owner_user_id: milestoneForm.owner_user_id ? Number(milestoneForm.owner_user_id) : null,
                decision_gate: Number(milestoneForm.decision_gate || 0),
                success_criteria: milestoneForm.success_criteria || "",
                executive_impact: milestoneForm.executive_impact || "",
                notes: milestoneForm.notes || "",
                created_by_user_id: loggedUserId ? Number(loggedUserId) : null,
            };

            const json = await safeJsonFetch(`${API_BASE}/project_milestones.php`, {
                method,
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            if (!json.success) {
                throw new Error(json.message || "No se pudo guardar el milestone");
            }

            setShowMilestoneModal(false);
            setToast({ type: "ok", msg: "Milestone guardado correctamente" });

            if (id) {
                await loadAll(id);
            }
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo guardar el milestone" });
        } finally {
            setSavingMilestone(false);
        }
    };

    const deleteMilestone = async (item) => {
        if (!item?.id) return;
        if (!window.confirm(`¿Eliminar el milestone "${item.title}"?`)) return;

        try {
            const json = await safeJsonFetch(`${API_BASE}/project_milestones.php`, {
                method: "DELETE",
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({ id: Number(item.id) }),
            });

            if (!json.success) {
                throw new Error(json.message || "No se pudo eliminar el milestone");
            }

            setToast({ type: "ok", msg: "Milestone eliminado correctamente" });

            if (id) {
                await loadAll(id);
            }
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo eliminar el milestone" });
        }
    };

    const markMilestoneComplete = async (item) => {
        if (!item?.id) return;

        try {
            const payload = {
                ...item,
                id: Number(item.id),
                project_id: Number(item.project_id || id),
                status: "cumplido",
                health_status: "verde",
                actual_date: item.actual_date || new Date().toISOString().slice(0, 10),
                decision_gate: Number(item.decision_gate || 0),
            };

            const json = await safeJsonFetch(`${API_BASE}/project_milestones.php`, {
                method: "PUT",
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            if (!json.success) {
                throw new Error(json.message || "No se pudo marcar el milestone como cumplido");
            }

            setToast({ type: "ok", msg: "Milestone marcado como cumplido" });

            if (id) {
                await loadAll(id);
            }
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo marcar el milestone como cumplido" });
        }
    };


    const saveRisk = async () => {
        try {
            setSavingRisk(true);

            const title = String(riskForm.risk_title || "").trim();
            if (!title) {
                throw new Error("Captura el nombre del riesgo antes de guardar.");
            }

            const selectedOwner = usersCatalog.find(
                (user) => String(user.id) === String(riskForm.owner_user_id || "")
            );

            const method = riskForm.id ? "PUT" : "POST";

            const payload = {
                id: riskForm.id ? Number(riskForm.id) : undefined,
                project_id: Number(riskForm.project_id || id),
                risk_title: title,
                description: riskForm.description || "",
                probability: riskForm.probability || "media",
                impact: riskForm.impact || "medio",
                risk_level: riskForm.risk_level || "medio",
                mitigation_plan: riskForm.mitigation_plan || "",
                status: riskForm.status || "abierto",
                response_strategy: riskForm.response_strategy || "",
                owner_user_id: riskForm.owner_user_id ? Number(riskForm.owner_user_id) : null,
                owner_name:
                    riskForm.owner_name ||
                    selectedOwner?.display_name ||
                    selectedOwner?.name ||
                    selectedOwner?.email ||
                    "",
            };

            const json = await safeJsonFetch(`${API_BASE}/project_risks.php`, {
                method,
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            if (!json.success) {
                throw new Error(json.message || "No se pudo guardar el riesgo");
            }

            setShowRiskModal(false);
            setRiskMode("view");
            setToast({ type: "ok", msg: "Riesgo guardado correctamente" });

            if (id) {
                await loadAll(id);
            }
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo guardar el riesgo" });
        } finally {
            setSavingRisk(false);
        }
    };


    const saveDeliverable = async () => {
        try {
            setSavingDeliverable(true);

            const method = deliverableForm.id ? "PUT" : "POST";

            const payload = {
                ...deliverableForm,
                project_id: id,
                owner_user_id: deliverableForm.owner_user_id || null,
            };

            const json = await safeJsonFetch(`${API_BASE}/project_deliverables.php`, {
                method,
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            if (!json.success) throw new Error(json.message || "No se pudo guardar el entregable");

            setShowDeliverableModal(false);
            setToast({ type: "ok", msg: "Entregable guardado correctamente" });
            await loadAll(id);
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo guardar el entregable" });
        } finally {
            setSavingDeliverable(false);
        }
    };

    const saveArea = async () => {
        try {
            setSavingArea(true);

            const method = areaForm.id ? "PUT" : "POST";
            const payload = {
                ...areaForm,
                project_id: Number(id),
                parent_area_id: areaForm.parent_area_id ? Number(areaForm.parent_area_id) : null,
                owner_user_id: areaForm.owner_user_id ? Number(areaForm.owner_user_id) : null,
                progress_percent: Number(areaForm.progress_percent || 0),
            };

            const json = await safeJsonFetch(`${API_BASE}/project_areas.php`, {
                method,
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            if (!json.success) throw new Error(json.message || "No se pudo guardar el área");

            setShowAreaModal(false);
            setToast({ type: "ok", msg: "Área guardada correctamente" });
            await loadAll(id);
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo guardar el área" });
        } finally {
            setSavingArea(false);
        }
    };

    const saveDocument = async () => {
        try {
            setSavingDocument(true);

            if (!documentForm.id) {
                await uploadProjectDocument();
            } else {
                const payload = {
                    ...documentForm,
                    project_id: id,
                    section_id: documentForm.section_id || null,
                    uploaded_by_user_id: documentForm.uploaded_by_user_id || null,
                };

                const json = await safeJsonFetch(`${API_BASE}/project_documents.php`, {
                    method: "PUT",
                    headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                    body: JSON.stringify(payload),
                });

                if (!json.success) throw new Error(json.message || "No se pudo guardar el documento");
            }

            setShowDocumentModal(false);
            setDocumentUploadFile(null);
            setToast({ type: "ok", msg: "Documento guardado correctamente" });
            await loadAll(id);
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo guardar el documento" });
        } finally {
            setSavingDocument(false);
        }
    };

    const saveScope = async () => {
        try {
            setSavingScope(true);

            const payload = {
                ...scopeForm,
                project_id: id,
                created_by_user_id: scopeForm.created_by_user_id || null,
            };

            const json = await safeJsonFetch(`${API_BASE}/scope_statement.php`, {
                method: "POST",
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            if (!json.success) throw new Error(json.message || "No se pudo guardar el alcance");

            setShowScopeModal(false);
            setToast({ type: "ok", msg: "Alcance guardado correctamente" });
            await loadAll(id);
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo guardar el alcance" });
        } finally {
            setSavingScope(false);
        }
    };


    const saveStakeholder = async () => {
        try {
            setSavingStakeholder(true);
            const method = stakeholderForm.id ? "PUT" : "POST";
            const payload = {
                ...stakeholderForm,
                project_id: Number(id),
                user_id: stakeholderForm.user_id ? Number(stakeholderForm.user_id) : null,
                is_primary_contact: stakeholderForm.is_primary_contact ? 1 : 0,
            };

            const json = await safeJsonFetch(`${API_BASE}/project_stakeholders.php${method === "PUT" ? "" : ""}`, {
                method,
                headers: buildAuthHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            if (!json.success) throw new Error(json.message || "No se pudo guardar el stakeholder");

            setShowStakeholderModal(false);
            setToast({ type: "ok", msg: "Stakeholder guardado correctamente" });
            await loadAll(id);
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || "No se pudo guardar el stakeholder" });
        } finally {
            setSavingStakeholder(false);
        }
    };

    const deleteItem = async (endpoint, itemId, label, onClose) => {
        const ok = window.confirm(`¿Eliminar ${label}?`);
        if (!ok) return;

        try {
            const json = await safeJsonFetch(`${API_BASE}/${endpoint}?id=${itemId}`, {
                method: "DELETE",
                headers: buildAuthHeaders(),
            });

            if (!json.success) throw new Error(json.message || `No se pudo eliminar ${label}`);

            if (onClose) onClose();
            setToast({ type: "ok", msg: `${label} eliminado correctamente` });
            await loadAll(id);
        } catch (err) {
            console.error(err);
            setToast({ type: "error", msg: err.message || `No se pudo eliminar ${label}` });
        }
    };

    if (loading) {
        return (
            <MainLayout>
                <div style={{ padding: 24, fontSize: 16 }}>Cargando ficha PMO...</div>
            </MainLayout>
        );
    }

    return (
        <MainLayout>
            <div style={{ padding: 24, background: "#001f33", minHeight: "100vh" }}>
                <div
                    style={{
                        background: "linear-gradient(135deg, #00283f 0%, #063d59 100%)",
                        border: "1px solid rgba(0, 186, 255, .35)",
                        borderRadius: 22,
                        padding: 24,
                        marginBottom: 18,
                        boxShadow: "0 18px 45px rgba(0,0,0,.22)",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            gap: 18,
                            flexWrap: "wrap",
                        }}
                    >
                        <div>
                            <div style={{ color: "#ffd43b", fontSize: 11, fontWeight: 900, letterSpacing: ".16em", textTransform: "uppercase", marginBottom: 8 }}>
                                Ficha 360 PMO
                            </div>
                            <h1 style={{ margin: 0, fontSize: 31, color: "#fff", fontWeight: 900, letterSpacing: "-.02em" }}>
                                PMO · Ficha 360 del Proyecto
                            </h1>
                            <div style={{ color: "#b9e8ff", marginTop: 8, fontSize: 14, maxWidth: 760, lineHeight: 1.55 }}>
                                Centro ejecutivo, operativo y documental del proyecto. Lee salud, avance, valor, hitos, riesgos, entregables y trazabilidad desde una sola vista.
                            </div>
                        </div>

                        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "flex-end" }}>
                            <ActionButton
                                onClick={() => navigate("/projects")}
                                bg="transparent"
                                color="#e6f8ff"
                                border="1px solid rgba(125, 211, 252, .45)"
                            >
                                ← Regresar
                            </ActionButton>

                            <ActionButton
                                onClick={openProjectModal}
                                bg="transparent"
                                color="#e6f8ff"
                                border="1px solid rgba(125, 211, 252, .45)"
                                disabled={!project}
                            >
                                Editar proyecto
                            </ActionButton>

                            <ActionButton
                                onClick={openBudgetModal}
                                bg="transparent"
                                color="#e6f8ff"
                                border="1px solid rgba(125, 211, 252, .45)"
                                disabled={!project}
                            >
                                Editar presupuesto
                            </ActionButton>

                            <ActionButton
                                onClick={openScopeModal}
                                bg="#f4b91b"
                                color="#06111f"
                                border="1px solid #f4b91b"
                                disabled={!project}
                            >
                                Editar alcance
                            </ActionButton>
                        </div>
                    </div>
                </div>

                {error ? (
                    <div
                        style={{
                            background: "#fee2e2",
                            color: "#991b1b",
                            padding: 14,
                            borderRadius: 10,
                            marginBottom: 16,
                        }}
                    >
                        {error}
                    </div>
                ) : null}


                {!project ? (
                    <SectionCard title="Proyecto">
                        <div style={{ color: "#b9e8ff" }}>No se encontró el proyecto.</div>
                    </SectionCard>
                ) : (
                    <>
                        <div
                            style={{
                                background: "#06283d",
                                border: "1px solid rgba(0, 186, 255, .28)",
                                borderRadius: 20,
                                padding: 20,
                                marginBottom: 18,
                                boxShadow: "0 14px 32px rgba(0,0,0,.18)",
                            }}
                        >
                            <div style={{ display: "flex", justifyContent: "space-between", gap: 18, flexWrap: "wrap", alignItems: "flex-start" }}>
                                <div style={{ flex: "1 1 560px" }}>
                                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
                                        <PmoBadge tone="purple">{project.code || "Sin código"}</PmoBadge>
                                        {project.stage ? <PmoBadge tone="blue">Etapa: {normalizeLabel(project.stage)}</PmoBadge> : null}
                                        <PmoBadge tone="gray">Tipo: {normalizeLabel(project.project_type || "Sin tipo")}</PmoBadge>
                                        <PmoBadge tone={getStatusTone(project.status)}>{normalizeLabel(project.status)}</PmoBadge>
                                        <PmoBadge tone={project.health_status === "rojo" ? "red" : project.health_status === "amarillo" ? "yellow" : "green"}>
                                            Salud {getHealthLabel(project.health_status)}
                                        </PmoBadge>
                                        <PmoBadge tone={getPriorityTone(project.priority)}>Prioridad {normalizeLabel(project.priority || "Sin prioridad")}</PmoBadge>
                                    </div>

                                    <h2 style={{ color: "#fff", margin: 0, fontSize: 22, lineHeight: 1.25, fontWeight: 900 }}>
                                        {project.name || "Proyecto sin nombre"}
                                    </h2>

                                    <div style={{ color: "#b9e8ff", fontSize: 13, lineHeight: 1.6, marginTop: 12 }}>
                                        {project.description || "Sin descripción registrada."}
                                    </div>
                                </div>

                                <div
                                    style={{
                                        flex: "0 1 390px",
                                        display: "grid",
                                        gridTemplateColumns: "repeat(2, minmax(140px, 1fr))",
                                        gap: 10,
                                    }}
                                >
                                    <div style={{ background: "rgba(255,255,255,.06)", border: "1px solid rgba(125,211,252,.22)", borderRadius: 14, padding: 12 }}>
                                        <div style={{ color: "#7dd3fc", fontSize: 10, fontWeight: 900, textTransform: "uppercase", letterSpacing: ".08em" }}>Project Manager</div>
                                        <div style={{ color: "#fff", fontSize: 13, fontWeight: 800, marginTop: 5 }}>{project.project_manager_name || project.project_manager || "—"}</div>
                                    </div>
                                    <div style={{ background: "rgba(255,255,255,.06)", border: "1px solid rgba(125,211,252,.22)", borderRadius: 14, padding: 12 }}>
                                        <div style={{ color: "#7dd3fc", fontSize: 10, fontWeight: 900, textTransform: "uppercase", letterSpacing: ".08em" }}>Sponsor</div>
                                        <div style={{ color: "#fff", fontSize: 13, fontWeight: 800, marginTop: 5 }}>{project.sponsor_name || project.sponsor || "—"}</div>
                                    </div>
                                    <div style={{ background: "rgba(255,255,255,.06)", border: "1px solid rgba(125,211,252,.22)", borderRadius: 14, padding: 12 }}>
                                        <div style={{ color: "#7dd3fc", fontSize: 10, fontWeight: 900, textTransform: "uppercase", letterSpacing: ".08em" }}>Tiempo</div>
                                        <div style={{ color: "#fff", fontSize: 13, fontWeight: 800, marginTop: 5 }}>{formatHumanDate(project.planned_start_date)} → {formatHumanDate(project.planned_end_date)}</div>
                                    </div>
                                    <div style={{ background: "rgba(255,255,255,.06)", border: "1px solid rgba(125,211,252,.22)", borderRadius: 14, padding: 12 }}>
                                        <div style={{ color: "#7dd3fc", fontSize: 10, fontWeight: 900, textTransform: "uppercase", letterSpacing: ".08em" }}>Presupuesto</div>
                                        <div style={{ color: "#fff", fontSize: 13, fontWeight: 800, marginTop: 5 }}>{formatMoney(project.budget_planned, project.currency)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <SectionCard
                            title="Lectura rápida del proyecto"
                            right={
                                <button
                                    type="button"
                                    onClick={() => setQuickReadOpen((prev) => !prev)}
                                    style={{
                                        border: "1px solid #0ea5e9",
                                        background: quickReadOpen ? "#f4b91b" : "#06283d",
                                        color: quickReadOpen ? "#06111f" : "#ffffff",
                                        borderRadius: 999,
                                        padding: "9px 14px",
                                        fontWeight: 800,
                                        cursor: "pointer",
                                    }}
                                    title="Mostrar u ocultar la lectura rápida del proyecto."
                                >
                                    {quickReadOpen ? "Ocultar lectura ▲" : "Mostrar lectura ▼"}
                                </button>
                            }
                        >
                            <button
                                type="button"
                                onClick={() => setQuickReadOpen((prev) => !prev)}
                                style={{
                                    width: "100%",
                                    textAlign: "left",
                                    border: "1px solid rgba(0,186,255,.26)",
                                    background: "linear-gradient(180deg, #08324b 0%, #06283d 100%)",
                                    borderRadius: 16,
                                    padding: 16,
                                    cursor: "pointer",
                                    marginBottom: quickReadOpen ? 16 : 0,
                                    boxShadow: "0 10px 24px rgba(0,0,0,.12)",
                                }}
                            >
                                <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "center" }}>
                                    <div>
                                        <div style={{ fontSize: 11, color: "#7dd3fc", fontWeight: 900, letterSpacing: ".10em", textTransform: "uppercase" }}>
                                            Lectura ejecutiva ORBIS
                                        </div>
                                        <div style={{ fontSize: 16, fontWeight: 900, color: "#ffffff", marginTop: 5 }}>
                                            Alcance, presupuesto, tiempo y valor esperado
                                        </div>
                                        <div style={{ fontSize: 12, color: "#d7efff", marginTop: 5 }}>
                                            Abre esta lectura solo cuando necesites revisar los pilares ejecutivos del proyecto.
                                        </div>
                                    </div>
                                    <div style={{ fontSize: 20, color: "#ffd43b", fontWeight: 900 }}>
                                        {quickReadOpen ? "−" : "+"}
                                    </div>
                                </div>
                            </button>

                            {quickReadOpen ? (
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))",
                                        gap: 14,
                                        alignItems: "start",
                                    }}
                                >
                                    <PmoMiniCard
                                        title="Alcance"
                                        question="¿Qué vamos a lograr o entregar?"
                                        value={scopeData?.project_objective || "Ver alcance"}
                                        subtitle="Entregables, criterios y exclusiones"
                                        accent="#059669"
                                        onClick={() => setActiveTabAndRemember("scope")}
                                    />
                                    <PmoMiniCard
                                        title="Presupuesto"
                                        question="¿Cuánto cuesta o cuánto invertimos?"
                                        value={formatMoney(project.budget_planned || project.contract_value, project.currency)}
                                        subtitle="Planeado, actual y justificación"
                                        accent="#2563eb"
                                        onClick={() => setActiveTabAndRemember("budget")}
                                    />
                                    <PmoMiniCard
                                        title="Tiempo"
                                        question="¿Cuándo debe lograrse?"
                                        value={`${formatHumanDate(project.planned_start_date)} → ${formatHumanDate(project.planned_end_date)}`}
                                        subtitle="Fechas, desviaciones y presión"
                                        accent="#f59e0b"
                                        onClick={() => setActiveTabAndRemember("time")}
                                    />
                                    <PmoMiniCard
                                        title="Valor esperado"
                                        question="¿Qué beneficio genera al terminar?"
                                        value={project.strategic_impact || project.success_criteria || "Definir valor"}
                                        subtitle="Beneficio económico, operativo, social o estratégico"
                                        accent="#7c3aed"
                                        onClick={() => setActiveTabAndRemember("value")}
                                    />
                                </div>
                            ) : null}
                        </SectionCard>

                        <SectionCard title="Resumen ejecutivo">
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                                    gap: 16,
                                }}
                            >
                                <StatCard
                                    title="Avance del proyecto"
                                    value={`${Number(project?.progress_percent || 0).toFixed(0)}%`}
                                    subtitle={`Salud actual: ${getHealthLabel(project?.health_status)}`}
                                    variant="orbis"
                                    accent="#00baff"
                                />
                                <StatCard
                                    title="Tareas vencidas"
                                    value={tasks.filter((t) => {
                                        if (!t.due_date) return false;
                                        if (t.status === "terminada" || t.status === "cancelada") return false;
                                        return new Date(t.due_date) < new Date(new Date().toISOString().slice(0, 10));
                                    }).length}
                                    subtitle="Pendientes fuera de fecha"
                                    variant="orbis"
                                    accent="#f59e0b"
                                />
                                <StatCard
                                    title="Riesgos abiertos"
                                    value={risks.filter((r) => r.status !== "cerrado").length}
                                    subtitle={`${risks.length} riesgos totales`}
                                    variant="orbis"
                                    accent="#ef4444"
                                />
                                <StatCard
                                    title="Entregables aprobados"
                                    value={deliverables.filter((d) => d.status === "aprobado").length}
                                    subtitle={`${deliverables.length} entregables registrados`}
                                    variant="orbis"
                                    accent="#10b981"
                                />
                            </div>
                        </SectionCard>

                        <SectionCard title="Navegación de ficha 360">
                            <div
                                style={{
                                    background: "linear-gradient(135deg, #06283d 0%, #083a55 100%)",
                                    border: "1px solid rgba(0, 186, 255, .28)",
                                    borderRadius: 16,
                                    padding: 16,
                                }}
                            >
                                <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 12, fontWeight: 700 }}>
                                    Cada módulo responde una pregunta ejecutiva para navegar la Ficha 360 sin repetir información larga en la entrada.
                                </div>

                                <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                                    {FICHA360_NAV_ORDER
                                        .map((key) => ({ key, ...getTabGuide(key) }))
                                        .filter((tab) => access?.[tab.perm])
                                        .map((tab) => (
                                            <Nav360Button
                                                key={tab.key}
                                                active={activeTab === tab.key}
                                                label={tab.label}
                                                question={tab.question}
                                                title={tab.tooltip}
                                                onClick={() => setActiveTabAndRemember(tab.key)}
                                            />
                                        ))}
                                </div>                            </div>
                        </SectionCard>

                        {activeTab === "overview" && (
                            <>
                                <SectionCard title="Resumen del proyecto">
                                    <SectionIntro tabKey="overview" />
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "1fr 1fr",
                                            gap: 18,
                                        }}
                                    >
                                        <div
                                            style={{
                                                background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                                                border: "1px solid rgba(0,178,255,.24)",
                                                borderRadius: 18,
                                                padding: 16,
                                                boxShadow: "0 12px 28px rgba(0,0,0,.18)",
                                            }}
                                        >
                                            <div style={{ fontWeight: 900, marginBottom: 10, color: "#ffffff" }}>Últimas tareas</div>
                                            {tasks.slice(0, 5).length ? (
                                                tasks.slice(0, 5).map((t) => (
                                                    <div key={t.id} style={{ marginBottom: 10, paddingBottom: 10, borderBottom: "1px solid rgba(125,211,252,.12)" }}>
                                                        <div style={{ fontWeight: 850, color: "#ffffff" }}>{t.wbs_code || "—"} · {t.name}</div>
                                                        <div style={{ fontSize: 12, color: "#b9e8ff" }}>
                                                            {t.owner_user_name || "Sin responsable"} · {t.status || "sin estatus"}
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div style={{ color: "#b9e8ff" }}>Sin tareas registradas.</div>
                                            )}
                                        </div>

                                        <div
                                            style={{
                                                background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                                                border: "1px solid rgba(0,178,255,.24)",
                                                borderRadius: 18,
                                                padding: 16,
                                                boxShadow: "0 12px 28px rgba(0,0,0,.18)",
                                            }}
                                        >
                                            <div style={{ fontWeight: 900, marginBottom: 10, color: "#ffffff" }}>Síntesis PMO</div>

                                            <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 6 }}>Objetivo del proyecto</div>
                                            <div style={{ marginBottom: 12, color: "#ffffff", fontWeight: 750 }}>{scopeData?.project_objective || "—"}</div>

                                            <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 6 }}>Impacto estratégico</div>
                                            <div style={{ marginBottom: 12, color: "#ffffff", fontWeight: 750 }}>{project.strategic_impact || "—"}</div>

                                            <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 6 }}>Criterios de éxito</div>
                                            <div style={{ color: "#ffffff", fontWeight: 750 }}>{project.success_criteria || "—"}</div>
                                        </div>
                                    </div>
                                </SectionCard>

                                <SectionCard title="Marco presupuestal del proyecto">
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                                            gap: 16,
                                            marginBottom: 18,
                                        }}
                                    >
                                        <StatCard
                                            title="Valor del contrato"
                                            value={formatMoney(project.contract_value, project.currency)}
                                            subtitle="Monto contractual registrado"
                                            bg="#ffffff"
                                        />
                                        <StatCard
                                            title="Presupuesto planeado"
                                            value={formatMoney(project.budget_planned, project.currency)}
                                            subtitle="Base aprobada o estimada"
                                            bg="#eff6ff"
                                        />
                                        <StatCard
                                            title="Presupuesto actual"
                                            value={formatMoney(project.budget_actual, project.currency)}
                                            subtitle="Monto actualizado / ejercido"
                                            bg="#ecfeff"
                                        />
                                        <StatCard
                                            title="Impacto EBITDA"
                                            value={formatMoney(project.ebitda_impact_est, project.currency)}
                                            subtitle={`Moneda: ${project.currency || "MXN"}`}
                                            bg="#ecfdf5"
                                        />
                                    </div>

                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "1fr 1fr 1fr",
                                            gap: 16,
                                        }}
                                    >
                                        <div style={{ border: "1px solid rgba(125,211,252,.18)", borderRadius: 16, padding: 16 }}>
                                            <div style={{ fontSize: 12, color: "#7dd3fc", marginBottom: 8, fontWeight: 900, textTransform: "uppercase", letterSpacing: ".08em" }}>Descripción del presupuesto</div>
                                            <div>{project.budget_description || "—"}</div>
                                        </div>
                                        <div style={{ border: "1px solid rgba(125,211,252,.18)", borderRadius: 16, padding: 16 }}>
                                            <div style={{ fontSize: 12, color: "#7dd3fc", marginBottom: 8, fontWeight: 900, textTransform: "uppercase", letterSpacing: ".08em" }}>Justificación</div>
                                            <div>{project.budget_justification || "—"}</div>
                                        </div>
                                        <div style={{ border: "1px solid rgba(125,211,252,.18)", borderRadius: 16, padding: 16 }}>
                                            <div style={{ fontSize: 12, color: "#7dd3fc", marginBottom: 8, fontWeight: 900, textTransform: "uppercase", letterSpacing: ".08em" }}>Notas</div>
                                            <div>{project.budget_notes || "—"}</div>
                                        </div>
                                    </div>
                                </SectionCard>
                            </>
                        )}


                        {activeTab === "project" && (
                            <SectionCard
                                title="Proyecto"
                                right={<ActionButton onClick={openProjectModal}>Editar proyecto</ActionButton>}
                            >
                                <SectionIntro tabKey="project" />
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 16 }}>
                                    <InfoRow label="Nombre" value={project.name} />
                                    <InfoRow label="Código" value={project.code} />
                                    <InfoRow label="Tipo" value={normalizeLabel(project.project_type)} tooltip="Clasificación del proyecto para análisis del portafolio." asBadge tone="blue" />
                                    <InfoRow label="Prioridad" value={normalizeLabel(project.priority)} tooltip="Nivel de prioridad ejecutiva del proyecto." asBadge tone={getPriorityTone(project.priority)} />
                                    <InfoRow label="Project Manager" value={project.project_manager_name || project.project_manager || "—"} />
                                    <InfoRow label="Sponsor" value={project.sponsor_name || project.sponsor || "—"} />
                                    <InfoRow label="Etapa" value={normalizeLabel(project.stage)} tooltip="Fase actual del ciclo de vida del proyecto." asBadge tone="blue" />
                                    <InfoRow label="Estatus" value={normalizeLabel(project.status)} tooltip="Condición operativa actual del proyecto." asBadge tone={getStatusTone(project.status)} />
                                    <InfoRow label="Salud" value={getHealthLabel(project.health_status)} tooltip="Lectura ejecutiva de salud del proyecto." asBadge tone={project.health_status === "rojo" ? "red" : project.health_status === "amarillo" ? "yellow" : "green"} />
                                    <InfoRow label="Descripción" value={project.description} />
                                </div>
                            </SectionCard>
                        )}

                        {activeTab === "budget" && (
                            <SectionCard
                                title="Presupuesto"
                                right={<ActionButton onClick={openBudgetModal}>Editar presupuesto</ActionButton>}
                            >
                                <SectionIntro tabKey="budget" />
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 16 }}>
                                    <InfoRow label="Valor contractual" value={formatMoney(project.contract_value, project.currency)} />
                                    <InfoRow label="Presupuesto planeado" value={formatMoney(project.budget_planned, project.currency)} />
                                    <InfoRow label="Presupuesto actual" value={formatMoney(project.budget_actual, project.currency)} />
                                    <InfoRow label="Moneda" value={project.currency || "MXN"} />
                                    <InfoRow label="Impacto económico estimado" value={formatMoney(project.ebitda_impact_est, project.currency)} />
                                    <InfoRow label="Descripción presupuestal" value={project.budget_description} />
                                    <InfoRow label="Justificación" value={project.budget_justification} />
                                    <InfoRow label="Notas" value={project.budget_notes} />
                                </div>
                            </SectionCard>
                        )}

                        {activeTab === "time" && (
                            <SectionCard title="Tiempo">
                                <SectionIntro tabKey="time" />
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 16 }}>
                                    <InfoRow label="Inicio planeado" value={formatHumanDate(project.planned_start_date)} tooltip="Fecha comprometida para iniciar el proyecto." />
                                    <InfoRow label="Fin planeado" value={formatHumanDate(project.planned_end_date)} tooltip="Fecha comprometida de cierre o finalización." />
                                    <InfoRow label="Inicio real" value={formatHumanDate(project.actual_start_date || project.start_date)} tooltip="Fecha real de inicio registrada." />
                                    <InfoRow label="Fin real" value={formatHumanDate(project.actual_end_date || project.end_date)} tooltip="Fecha real de cierre, si ya existe." />
                                    <InfoRow label="Tareas vencidas" value={tasks.filter((t) => {
                                        if (!t.due_date) return false;
                                        if (t.status === "terminada" || t.status === "cancelada") return false;
                                        return new Date(t.due_date) < new Date();
                                    }).length} tooltip="Tareas con fecha compromiso vencida que aún no están terminadas o canceladas." asBadge tone={tasks.filter((t) => {
                                        if (!t.due_date) return false;
                                        if (t.status === "terminada" || t.status === "cancelada") return false;
                                        return new Date(t.due_date) < new Date();
                                    }).length > 0 ? "red" : "green"} />
                                    <InfoRow label="Tareas bloqueadas" value={tasks.filter((t) => t.status === "bloqueada" || Number(t.is_blocked || 0) === 1).length} tooltip="Tareas bloqueadas que requieren intervención o desbloqueo PMO." asBadge tone={tasks.filter((t) => t.status === "bloqueada" || Number(t.is_blocked || 0) === 1).length > 0 ? "red" : "green"} />
                                </div>

                                <ProjectTimeComparison project={project} tasks={tasks} />
                            </SectionCard>
                        )}

                        {activeTab === "value" && (
                            <SectionCard
                                title="Valor esperado"
                                right={<ActionButton onClick={openProjectModal}>Editar valor</ActionButton>}
                            >
                                <SectionIntro tabKey="value" />
                                <ProjectValueExpectedPanel project={project} />
                            </SectionCard>
                        )}

                        {activeTab === "milestones" && (
                            <SectionCard
                                title="Milestones"
                                right={<ActionButton onClick={() => openMilestoneModal(null)}>+ Nuevo hito</ActionButton>}
                            >
                                <SectionIntro tabKey="milestones" />
                                <MilestonesPanel
                                    items={milestones}
                                    tasks={tasks}
                                    deliverables={deliverables}
                                    onEdit={openMilestoneModal}
                                    onDelete={deleteMilestone}
                                    onComplete={markMilestoneComplete}
                                />
                            </SectionCard>
                        )}

                        {activeTab === "updates" && (
                            <SectionCard
                                title="Avances"
                                right={<ActionButton onClick={() => openUpdateModal(null, "edit")}>+ Nuevo avance</ActionButton>}
                            >
                                <SectionIntro tabKey="updates" />
                                <div style={{ display: "grid", gap: 12 }}>
                                    {updates.length ? (
                                        updates.map((u) => (
                                            <OrbisRecordCard key={u.id} accent={getDeliverableAccent(u)}>
                                                <div
                                                    style={{
                                                        display: "grid",
                                                        gridTemplateColumns: "minmax(260px, 1.4fr) minmax(130px, .65fr) minmax(120px, .65fr) minmax(130px, .65fr) minmax(180px, .8fr)",
                                                        gap: 14,
                                                        alignItems: "start",
                                                    }}
                                                >
                                                    <div>
                                                        <OrbisFieldLabel>Avance / actualización</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 950, fontSize: 14 }}>{u.title || "—"}</div>
                                                        <div style={{ color: "#b9e8ff", fontSize: 12, lineHeight: 1.45, marginTop: 6 }}>
                                                            {truncateForCard(u.summary || u.description || "Sin resumen", 220)}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Fecha</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 850 }}>{formatHumanDate(u.update_date)}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Avance</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 950 }}>{u.progress_percent ?? "—"}%</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Estatus</OrbisFieldLabel>
                                                        <HealthBadge health={u.status} label={normalizeLabel(u.status)} />
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Acciones</OrbisFieldLabel>
                                                        <DetailActionButtons
                                                            onView={() => openUpdateModal(u, "view")}
                                                            onEdit={() => openUpdateModal(u, "edit")}
                                                        />
                                                    </div>
                                                </div>
                                            </OrbisRecordCard>
                                        ))
                                    ) : (
                                        <OrbisRecordCard accent="#64748b">
                                            <div style={{ color: "#d7efff", fontWeight: 800 }}>Sin avances registrados.</div>
                                        </OrbisRecordCard>
                                    )}
                                </div>
                            </SectionCard>
                        )}

                        {activeTab === "tasks" && (
                            <SectionCard
                                title="Tareas WBS"
                                right={<ActionButton onClick={() => openTaskModal(null, "edit")}>+ Nueva tarea</ActionButton>}
                            >
                                <SectionIntro tabKey="tasks" />
                                <div style={{ display: "grid", gridTemplateColumns: "minmax(0, 1.6fr) minmax(360px, 0.9fr)", gap: 18, alignItems: "start" }}>
                                    <div
                                        ref={tasksPanelRef}
                                        style={{
                                            border: "1px solid rgba(0,178,255,.24)",
                                            borderRadius: 18,
                                            background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                                            overflow: "hidden",
                                            boxShadow: "0 14px 30px rgba(0,0,0,.18)",
                                        }}
                                    >
                                        <DualHorizontalScroll minWidth={980} height={12}>
                                            <table
                                                style={{
                                                    width: "100%",
                                                    borderCollapse: "separate",
                                                    borderSpacing: 0,
                                                    minWidth: 980,
                                                }}
                                            >
                                                <thead>
                                                    <tr style={{ background: "rgba(255,255,255,.04)" }}>
                                                        <Th>WBS</Th>
                                                        <Th>Tarea</Th>
                                                        <Th>Responsable</Th>
                                                        <Th>Prioridad</Th>
                                                        <Th>Avance</Th>
                                                        <Th>Compromiso</Th>
                                                        <Th>Estatus</Th>
                                                        <Th>Acciones</Th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {tasks.length ? (
                                                        [...tasks]
                                                            .sort((a, b) => String(a.wbs_code || "").localeCompare(String(b.wbs_code || ""), "es"))
                                                            .map((t, index) => {
                                                                const isSelected = String(selectedTaskId || "") === String(t.id || "");
                                                                const isHovered = String(hoveredTaskRowId || "") === String(t.id || "");
                                                                const rowBg = isSelected
                                                                    ? "rgba(14,165,233,.18)"
                                                                    : isHovered
                                                                        ? "rgba(14,165,233,.10)"
                                                                        : index % 2 === 0
                                                                            ? "rgba(255,255,255,.035)"
                                                                            : "rgba(255,255,255,.02)";
                                                                const taskAccent = getDeliverableAccent(t);
                                                                const childCodes = getChildTasks(t.id, tasks)
                                                                    .map((x) => `${x.wbs_code || x.id}`)
                                                                    .join(", ");

                                                                return (
                                                                    <tr
                                                                        key={t.id}
                                                                        onMouseEnter={() => setHoveredTaskRowId(String(t.id || ""))}
                                                                        onMouseLeave={() => setHoveredTaskRowId("")}
                                                                        onClick={() => setSelectedTaskId(String(t.id || ""))}
                                                                        style={{
                                                                            background: rowBg,
                                                                            cursor: "pointer",
                                                                            boxShadow: isSelected ? "inset 3px 0 0 #2563eb" : "none",
                                                                            transition: "background-color 0.15s ease, box-shadow 0.15s ease",
                                                                        }}
                                                                    >
                                                                        <Td>{t.wbs_code || "—"}</Td>
                                                                        <Td>
                                                                            <div style={{ fontWeight: 700 }}>
                                                                                {t.name || "—"}
                                                                                {hasChildTasks(t.id, tasks) ? (
                                                                                    <span
                                                                                        style={{
                                                                                            marginLeft: 8,
                                                                                            fontSize: 11,
                                                                                            fontWeight: 700,
                                                                                            color: "#92400e",
                                                                                            background: "#fffbeb",
                                                                                            border: "1px solid #fde68a",
                                                                                            padding: "2px 8px",
                                                                                            borderRadius: 999,
                                                                                        }}
                                                                                    >
                                                                                        Padre WBS
                                                                                    </span>
                                                                                ) : null}
                                                                            </div>
                                                                            {childCodes ? (
                                                                                <div style={{ color: "#b45309", fontSize: 11, marginTop: 4 }}>
                                                                                    Hijas: {childCodes}
                                                                                </div>
                                                                            ) : null}
                                                                            <div style={{ color: "#93c5fd", fontSize: 12 }}>{t.description || ""}</div>
                                                                        </Td>
                                                                        <Td>{t.owner_user_name || "—"}</Td>
                                                                        <Td>{t.priority || "—"}</Td>
                                                                        <Td><ProgressBar value={t.progress_percent || 0} /></Td>
                                                                        <Td>{formatTaskDate(t.due_date)}</Td>
                                                                        <Td>
                                                                            <TaskStatusBadge status={t.status} />
                                                                        </Td>                                                                       <Td>
                                                                            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }} onClick={(e) => e.stopPropagation()}>
                                                                                <OrbisButton compact variant="primary" onClick={() => openTaskModal(t, "view")}>
                                                                                    Ver detalle
                                                                                </OrbisButton>
                                                                                <OrbisButton compact variant="gold" onClick={() => openTaskModal(t, "edit")}>
                                                                                    Editar
                                                                                </OrbisButton>
                                                                            </div>
                                                                        </Td>
                                                                    </tr>
                                                                );
                                                            })
                                                    ) : (
                                                        <tr>
                                                            <Td colSpan={8}>Sin tareas registradas.</Td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </DualHorizontalScroll>
                                    </div>

                                    <div
                                        ref={selectedTaskPanelRef}
                                        style={{
                                            border: `1px solid ${selectedTaskPanelTone.border || "rgba(0,178,255,.24)"}`,
                                            borderRadius: 18,
                                            background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                                            boxShadow: "0 14px 30px rgba(0,0,0,.18)",
                                            overflow: "hidden",
                                        }}
                                    >
                                        {selectedTaskCard ? (
                                            <>
                                                <div style={{ padding: 16, borderBottom: "1px solid rgba(125,211,252,.18)" }}>
                                                    <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "flex-start" }}>
                                                        <div>
                                                            <div style={{ fontSize: 11, fontWeight: 900, color: "#7dd3fc", marginBottom: 6, letterSpacing: ".08em", textTransform: "uppercase" }}>
                                                                {selectedTaskCard.wbs_code || "SIN WBS"}
                                                            </div>
                                                            <div style={{ fontSize: 20, fontWeight: 950, color: "#ffffff", marginBottom: 6 }}>
                                                                {selectedTaskCard.name || "Sin nombre"}
                                                            </div>
                                                            <div style={{ fontSize: 13, color: "#b9e8ff", lineHeight: 1.45 }}>
                                                                {selectedTaskCard.description || "Sin descripción registrada."}
                                                            </div>
                                                        </div>
                                                        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-end" }}>
                                                            <Badge bg={getStatusBg(selectedTaskCard.status)}>{selectedTaskCard.status || "—"}</Badge>
                                                            {(() => {
                                                                const reviewConfig = getReviewStatusBadge(selectedTaskCard.review_status);
                                                                return (
                                                                    <Badge bg={reviewConfig.bg} color={reviewConfig.color}>
                                                                        {reviewConfig.label}
                                                                    </Badge>
                                                                );
                                                            })()}
                                                        </div>
                                                    </div>

                                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 12, marginTop: 16 }}>
                                                        <InfoRow label="Responsable" value={selectedTaskCard.owner_user_name || "—"} />
                                                        <InfoRow label="Prioridad" value={selectedTaskCard.priority || "—"} />
                                                        <InfoRow label="Inicio" value={formatTaskDate(selectedTaskCard.start_date)} />
                                                        <InfoRow label="Compromiso" value={formatTaskDate(selectedTaskCard.due_date)} />
                                                    </div>

                                                    {(() => {
                                                        const predecessor = tasks.find(
                                                            (x) => String(x.id) === String(selectedTaskCard.depends_on_task_id)
                                                        );
                                                        const dependencyTypeLabelMap = {
                                                            FS: "Fin a Inicio",
                                                            SS: "Inicio a Inicio",
                                                            FF: "Fin a Fin",
                                                            SF: "Inicio a Fin",
                                                        };
                                                        return predecessor ? (
                                                            <div style={{ marginTop: 12 }}>
                                                                <InfoRow
                                                                    label="Tarea predecesora"
                                                                    value={`${predecessor.wbs_code || predecessor.id} · ${dependencyTypeLabelMap[selectedTaskCard.dependency_type] || selectedTaskCard.dependency_type || "FS"}`}
                                                                />
                                                                <InfoRow
                                                                    label="Descripción predecesora"
                                                                    value={predecessor.description || predecessor.name || "Sin descripción registrada."}
                                                                />
                                                            </div>
                                                        ) : null;
                                                    })()}

                                                    <div style={{ marginTop: 8 }}>
                                                        <div style={{ fontSize: 11, color: "#7dd3fc", marginBottom: 6, fontWeight: 900, letterSpacing: ".08em", textTransform: "uppercase" }}>Avance</div>
                                                        <ProgressBar value={selectedTaskCard.progress_percent || 0} />
                                                    </div>

                                                    {(() => {
                                                        const predecessor = tasks.find(
                                                            (x) => String(x.id) === String(selectedTaskCard.depends_on_task_id)
                                                        );

                                                        const dependencyTypeLabelMap = {
                                                            FS: "Fin a Inicio",
                                                            SS: "Inicio a Inicio",
                                                            FF: "Fin a Fin",
                                                            SF: "Inicio a Fin",
                                                        };

                                                        return (
                                                            <div style={{ marginTop: 10, display: "flex", gap: 8, flexWrap: "wrap" }}>
                                                                <PmoBadge tone="gray">
                                                                    {predecessor
                                                                        ? `Predecesora: ${predecessor.wbs_code || predecessor.id} · ${dependencyTypeLabelMap[selectedTaskCard.dependency_type] || selectedTaskCard.dependency_type || "FS"}`
                                                                        : "Sin predecesora"}
                                                                </PmoBadge>

                                                                {predecessor ? (
                                                                    <PmoBadge tone="blue">
                                                                        {predecessor.name || "Sin nombre"}
                                                                    </PmoBadge>
                                                                ) : null}
                                                            </div>
                                                        );
                                                    })()}

                                                    <div style={{ marginTop: 14, display: "flex", gap: 8, flexWrap: "wrap" }}>
                                                        <OrbisButton compact variant="primary" onClick={() => openTaskModal(selectedTaskCard, "view")}>
                                                            Ver detalle
                                                        </OrbisButton>
                                                        <OrbisButton compact variant="gold" onClick={() => openTaskModal(selectedTaskCard, "edit")}>
                                                            Editar
                                                        </OrbisButton>
                                                        <OrbisButton compact variant="dark" onClick={() => openTaskModal(selectedTaskCard, "progress")}>
                                                            Registrar avance
                                                        </OrbisButton>
                                                        {isTaskInReview(selectedTaskCard) ? (
                                                            <OrbisButton compact variant="success" onClick={() => openTaskModal(selectedTaskCard, "review")}>
                                                                Revisar
                                                            </OrbisButton>
                                                        ) : null}
                                                    </div>
                                                </div>

                                                <div style={{ padding: 16, borderBottom: "1px solid rgba(125,211,252,.18)" }}>
                                                    <div style={{ fontSize: 14, fontWeight: 700, color: "#ffffff", marginBottom: 10 }}>
                                                        Subtareas hijas ({selectedTaskChildren.length})
                                                    </div>
                                                    {selectedTaskChildren.length ? (
                                                        <div style={{ display: "grid", gap: 10 }}>
                                                            {selectedTaskChildren.map((child) => (
                                                                <button
                                                                    key={child.id}
                                                                    type="button"
                                                                    onClick={() => setSelectedTaskId(String(child.id || ""))}
                                                                    style={{
                                                                        textAlign: "left",
                                                                        border: "1px solid rgba(125,211,252,.18)",
                                                                        background: "rgba(255,255,255,.04)",
                                                                        borderRadius: 14,
                                                                        padding: 12,
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    <div style={{ fontSize: 12, color: "#7dd3fc", fontWeight: 900, marginBottom: 4 }}>
                                                                        {child.wbs_code || child.id}
                                                                    </div>
                                                                    <div style={{ fontWeight: 900, color: "#ffffff", marginBottom: 8 }}>{child.name || "Sin nombre"}</div>
                                                                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                                                                        <TaskStatusBadge status={child.status} />
                                                                        <PmoBadge tone="blue">{Number(child.progress_percent || 0).toFixed(0)}%</PmoBadge>
                                                                    </div>
                                                                </button>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div style={{ color: "#b9e8ff", fontSize: 13 }}>Esta tarea no tiene subtareas hijas.</div>
                                                    )}
                                                </div>


                                                <div style={{ padding: 16 }}>
                                                    <div style={{ fontSize: 14, fontWeight: 700, color: "#ffffff", marginBottom: 10 }}>
                                                        Historial y Bitácora de la tarea
                                                    </div>
                                                    {loadingTaskLogs ? (
                                                        <div style={{ color: "#b9e8ff", fontSize: 13 }}>Cargando bitácora...</div>
                                                    ) : taskLogs.length === 0 ? (
                                                        <div style={{ color: "#b9e8ff", fontSize: 13 }}>No hay movimientos registrados.</div>
                                                    ) : (
                                                        <div>
                                                            {groupedTaskLogs.map((group) => (
                                                                <div key={group.label} style={{ marginBottom: 18 }}>
                                                                    <div
                                                                        style={{
                                                                            display: "inline-flex",
                                                                            alignItems: "center",
                                                                            padding: "6px 10px",
                                                                            borderRadius: 999,
                                                                            background: "rgba(14,165,233,.14)",
                                                                            color: "#7dd3fc",
                                                                            fontSize: 12,
                                                                            fontWeight: 800,
                                                                            marginBottom: 10,
                                                                        }}
                                                                    >
                                                                        {group.label}
                                                                    </div>
                                                                    <div style={{ display: "grid", gap: 10 }}>
                                                                        {group.items.map((log) => {
                                                                            const dotColor = getLogDotColor(log);
                                                                            return (
                                                                                <div
                                                                                    key={log.id}
                                                                                    style={{
                                                                                        border: "1px solid rgba(125,211,252,.18)",
                                                                                        borderRadius: 12,
                                                                                        background: "rgba(255,255,255,.04)",
                                                                                        padding: 12,
                                                                                    }}
                                                                                >
                                                                                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                                                                                        <span style={{ width: 10, height: 10, borderRadius: "50%", background: dotColor, display: "inline-block" }} />
                                                                                        <div style={{ fontWeight: 700, color: "#ffffff" }}>{getLogTitle(log)}</div>
                                                                                    </div>
                                                                                    <div style={{ fontSize: 12, color: "#7dd3fc", fontWeight: 800, marginBottom: 6 }}>{formatHumanDateTime(log.created_at)}</div>
                                                                                    {getLogSummary(log) ? (
                                                                                        <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 6, fontWeight: 700 }}>{getLogSummary(log)}</div>
                                                                                    ) : null}
                                                                                    <div style={{ fontSize: 13, color: "#d7efff" }}>{getLogComment(log)}</div>

                                                                                    <CompactTaskEvidenceList items={log.evidence_items} />
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                                {canReviewCurrentTask ? (
                                                    <div
                                                        style={{
                                                            margin: "0 16px 16px",
                                                            padding: 16,
                                                            borderRadius: 16,
                                                            background: "rgba(244,185,27,.12)",
                                                            border: "1px solid rgba(244,185,27,.42)",
                                                        }}
                                                    >
                                                        <div style={{ fontWeight: 800, color: "#fde68a", marginBottom: 8 }}>
                                                            Revisión pendiente de la tarea
                                                        </div>

                                                        <div style={{ fontSize: 13, color: "#fef3c7", marginBottom: 12 }}>
                                                            Esta tarea está marcada como en revisión. Puedes aprobarla, rechazarla o solicitar cambios aunque no exista un log pendiente.
                                                        </div>

                                                        <textarea
                                                            value={taskReviewForm.comment}
                                                            onChange={(e) =>
                                                                setTaskReviewForm((prev) => ({
                                                                    ...prev,
                                                                    comment: e.target.value,
                                                                }))
                                                            }
                                                            rows={3}
                                                            placeholder="Comentario de revisión (opcional)"
                                                            style={{
                                                                width: "100%",
                                                                borderRadius: 10,
                                                                border: "1px solid rgba(125,211,252,.35)",
                                                                padding: 10,
                                                                fontSize: 13,
                                                                background: "rgba(255,255,255,.04)",
                                                                color: "#ffffff",
                                                                marginBottom: 10,
                                                                boxSizing: "border-box",
                                                            }}
                                                        />

                                                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                                            <ActionButton
                                                                onClick={() => reviewTaskProgress(null, "aprobar")}
                                                                disabled={reviewingTask}
                                                                bg="#16a34a"
                                                                color="#fff"
                                                                border="1px solid #16a34a"
                                                            >
                                                                Aprobar
                                                            </ActionButton>

                                                            <ActionButton
                                                                onClick={() => reviewTaskProgress(null, "rechazar")}
                                                                disabled={reviewingTask}
                                                                bg="transparent"
                                                                color="#ffb4b4"
                                                                border="1px solid rgba(239,68,68,.70)"
                                                            >
                                                                Rechazar
                                                            </ActionButton>

                                                            <ActionButton
                                                                onClick={() => reviewTaskProgress(null, "solicitar_cambios")}
                                                                disabled={reviewingTask}
                                                                bg="transparent"
                                                                color="#fde68a"
                                                                border="1px solid rgba(244,185,27,.65)"
                                                            >
                                                                Solicitar cambios
                                                            </ActionButton>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </>
                                        ) : (
                                            <div style={{ padding: 18, color: "#b9e8ff" }}>Selecciona una tarea para ver su contexto, hijas y bitácora.</div>
                                        )}
                                    </div>
                                </div>
                            </SectionCard>
                        )}

                        {activeTab === "risks" && (
                            <SectionCard
                                title="Riesgos"
                                right={<ActionButton onClick={() => openRiskModal(null, "edit")}>+ Nuevo riesgo</ActionButton>}
                            >
                                <SectionIntro tabKey="risks" />
                                <div style={{ display: "grid", gap: 12 }}>
                                    {risks.length ? (
                                        risks.map((r) => (
                                            <OrbisRecordCard key={r.id} accent={getRiskAccent(r)}>
                                                <div
                                                    style={{
                                                        display: "grid",
                                                        gridTemplateColumns: "minmax(260px, 1.8fr) repeat(4, minmax(105px, .7fr)) minmax(170px, .9fr)",
                                                        gap: 14,
                                                        alignItems: "start",
                                                    }}
                                                >
                                                    <div>
                                                        <OrbisFieldLabel>Riesgo</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 900, fontSize: 14, lineHeight: 1.35 }}>
                                                            {r.risk_title || "—"}
                                                        </div>
                                                        <div style={{ color: "#b9e8ff", fontSize: 12, lineHeight: 1.45, marginTop: 6 }}>
                                                            {truncateForCard(r.description || "Sin descripción", 190)}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Probabilidad</OrbisFieldLabel>
                                                        <PmoBadge tone={getPriorityTone(r.probability)}>{normalizeLabel(r.probability)}</PmoBadge>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Impacto</OrbisFieldLabel>
                                                        <PmoBadge tone={getPriorityTone(r.impact)}>{normalizeLabel(r.impact)}</PmoBadge>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Estrategia</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 800, fontSize: 13 }}>{normalizeLabel(r.response_strategy || "Sin estrategia")}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Estatus</OrbisFieldLabel>
                                                        <PmoBadge tone={getStatusTone(r.status)}>{normalizeLabel(r.status)}</PmoBadge>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Acciones</OrbisFieldLabel>
                                                        <OrbisActions>
                                                            <OrbisButton compact variant="primary" onClick={() => openRiskModal(r, "view")}>Ver detalle</OrbisButton>
                                                            <OrbisButton compact variant="gold" onClick={() => openRiskModal(r, "edit")}>Editar</OrbisButton>
                                                        </OrbisActions>
                                                    </div>
                                                </div>
                                            </OrbisRecordCard>
                                        ))
                                    ) : (
                                        <OrbisRecordCard accent="#64748b">
                                            <div style={{ color: "#d7efff", fontWeight: 800 }}>Sin riesgos registrados.</div>
                                        </OrbisRecordCard>
                                    )}
                                </div>
                            </SectionCard>
                        )}

                        {activeTab === "deliverables" && (
                            <SectionCard
                                title="Entregables"
                                right={<ActionButton onClick={() => openDeliverableModal(null, "edit")}>+ Nuevo entregable</ActionButton>}
                            >
                                <SectionIntro tabKey="deliverables" />
                                <div style={{ display: "grid", gap: 12 }}>
                                    {deliverables.length ? (
                                        deliverables.map((d) => (
                                            <OrbisRecordCard key={d.id} accent={getDeliverableAccent(d)}>
                                                <div
                                                    style={{
                                                        display: "grid",
                                                        gridTemplateColumns: "minmax(260px, 1.7fr) repeat(3, minmax(120px, .7fr)) minmax(170px, .9fr)",
                                                        gap: 14,
                                                        alignItems: "start",
                                                    }}
                                                >
                                                    <div>
                                                        <OrbisFieldLabel>Entregable</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 900, fontSize: 14, lineHeight: 1.35 }}>{d.name || d.title || "—"}</div>
                                                        <div style={{ color: "#b9e8ff", fontSize: 12, lineHeight: 1.45, marginTop: 6 }}>{truncateForCard(d.description || "Sin descripción", 170)}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Estatus</OrbisFieldLabel>
                                                        <PmoBadge tone={getStatusTone(d.status)}>{normalizeLabel(d.status)}</PmoBadge>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Compromiso</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 800 }}>{formatHumanDate(d.due_date || d.target_date)}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Responsable</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 800 }}>{d.owner_name || d.owner_user_name || "—"}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Acciones</OrbisFieldLabel>
                                                        <OrbisActions>
                                                            <OrbisButton compact variant="primary" onClick={() => openDeliverableModal(d, "view")}>Ver detalle</OrbisButton>
                                                            <OrbisButton compact variant="gold" onClick={() => openDeliverableModal(d, "edit")}>Editar</OrbisButton>
                                                        </OrbisActions>
                                                    </div>
                                                </div>
                                            </OrbisRecordCard>
                                        ))
                                    ) : (
                                        <OrbisRecordCard accent="#64748b">
                                            <div style={{ color: "#d7efff", fontWeight: 800 }}>Sin entregables registrados.</div>
                                        </OrbisRecordCard>
                                    )}
                                </div>
                            </SectionCard>
                        )}



                        {activeTab === "areas" && (
                            <SectionCard
                                title="Áreas del proyecto"
                                right={<ActionButton onClick={() => openAreaModal(null, "edit")}>+ Nueva área</ActionButton>}
                            >
                                <SectionIntro tabKey="areas" />
                                <div
                                    style={{
                                        background: "linear-gradient(180deg, #08324b 0%, #06283d 100%)",
                                        color: "#d7efff",
                                        padding: 14,
                                        borderRadius: 14,
                                        border: "1px solid rgba(0,186,255,.22)",
                                        marginBottom: 16,
                                        fontSize: 13,
                                    }}
                                >
                                    Las áreas representan disciplinas o workstreams del proyecto. Una tarea puede pertenecer a un área para medir salud, avance y responsabilidad por bloque.
                                </div>

                                <div style={{ display: "grid", gap: 12 }}>
                                    {areas.length ? (
                                        areas.map((a) => (
                                            <OrbisRecordCard key={a.id} accent={a.health_status === "rojo" ? "#ef4444" : a.health_status === "amarillo" ? "#f59e0b" : "#00baff"}>
                                                <div
                                                    style={{
                                                        display: "grid",
                                                        gridTemplateColumns: "minmax(260px, 1.4fr) repeat(5, minmax(115px, .75fr)) minmax(180px, .9fr)",
                                                        gap: 14,
                                                        alignItems: "start",
                                                    }}
                                                >
                                                    <div>
                                                        <OrbisFieldLabel>Área</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 950, fontSize: 14 }}>{a.name || "—"}</div>
                                                        <div style={{ color: "#b9e8ff", fontSize: 12, lineHeight: 1.45, marginTop: 6 }}>{a.description || "Sin descripción"}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Nivel</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 850 }}>{a.level || "—"}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Responsable</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 850 }}>{a.owner_user_name || a.user_name || "—"}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Prioridad</OrbisFieldLabel>
                                                        <PmoBadge tone={getPriorityTone(a.priority)}>{normalizeLabel(a.priority || "—")}</PmoBadge>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Salud</OrbisFieldLabel>
                                                        <HealthBadge health={a.health_status} />
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Avance</OrbisFieldLabel>
                                                        <ProgressBar value={a.progress_percent || 0} />
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Acciones</OrbisFieldLabel>
                                                        <DetailActionButtons
                                                            onView={() => openAreaModal(a, "view")}
                                                            onEdit={() => openAreaModal(a, "edit")}
                                                        />
                                                    </div>
                                                </div>
                                                {a.notes ? (
                                                    <div style={{ marginTop: 12, color: "#d7efff", fontSize: 13, lineHeight: 1.5 }}>
                                                        <strong>Notas:</strong> {a.notes}
                                                    </div>
                                                ) : null}
                                            </OrbisRecordCard>
                                        ))
                                    ) : (
                                        <OrbisRecordCard accent="#64748b">
                                            <div style={{ color: "#d7efff", fontWeight: 800 }}>Sin áreas registradas.</div>
                                        </OrbisRecordCard>
                                    )}
                                </div>

                                <div style={{ marginTop: 18 }}>
                                    <div style={{ fontSize: 15, fontWeight: 900, color: "#ffffff", marginBottom: 10 }}>Matriz de áreas</div>
                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 14 }}>
                                        {areas.length ? areas.map((a) => (
                                            <div key={`card-${a.id}`} style={{ border: "1px solid rgba(0,186,255,.22)", borderRadius: 16, padding: 16, background: "linear-gradient(180deg, #08324b 0%, #06283d 100%)", boxShadow: "0 10px 20px rgba(0,0,0,.10)" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "center", marginBottom: 10 }}>
                                                    <div style={{ fontWeight: 900, color: "#ffffff" }}>{a.name || "Área"}</div>
                                                    <HealthBadge health={a.health_status} />
                                                </div>
                                                <div style={{ fontSize: 11, color: "#7dd3fc", marginBottom: 8, fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase" }}>Responsable</div>
                                                <div style={{ fontWeight: 700, color: "#ffffff", marginBottom: 10 }}>{a.owner_user_name || a.user_name || "—"}</div>
                                                <div style={{ fontSize: 11, color: "#7dd3fc", marginBottom: 8, fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase" }}>Avance</div>
                                                <ProgressBar value={a.progress_percent || 0} />
                                            </div>
                                        )) : (
                                            <div style={{ color: "#b9e8ff" }}>La matriz de áreas se mostrará cuando registres áreas del proyecto.</div>
                                        )}
                                    </div>
                                </div>
                            </SectionCard>
                        )}

                        {activeTab === "stakeholders" && (
                            <SectionCard
                                title="Stakeholders"
                                right={<ActionButton onClick={() => openStakeholderModal(null, "edit")}>+ Nuevo stakeholder</ActionButton>}
                            >
                                <SectionIntro tabKey="stakeholders" />
                                <div style={{ display: "grid", gap: 12 }}>
                                    {stakeholders.length ? (
                                        stakeholders.map((s) => (
                                            <OrbisRecordCard key={s.id} accent={Number(s.is_primary_contact || 0) === 1 ? "#f4b91b" : "#00baff"}>
                                                <div
                                                    style={{
                                                        display: "grid",
                                                        gridTemplateColumns: "minmax(260px, 1.4fr) repeat(4, minmax(120px, .75fr)) minmax(180px, .9fr)",
                                                        gap: 14,
                                                        alignItems: "start",
                                                    }}
                                                >
                                                    <div>
                                                        <OrbisFieldLabel>Stakeholder</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 950, fontSize: 14 }}>{s.name || s.user_name || "—"}</div>
                                                        <div style={{ color: "#b9e8ff", fontSize: 12, marginTop: 5 }}>{s.email || s.user_email || "—"}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Rol</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 850 }}>{normalizeLabel(s.role || "—")}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Empresa / tipo</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 850 }}>{s.company || "—"}</div>
                                                        <div style={{ color: "#b9e8ff", fontSize: 12, marginTop: 4 }}>{normalizeLabel(s.stakeholder_type || "—")}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Influencia</OrbisFieldLabel>
                                                        <PmoBadge tone={getPriorityTone(s.influence_level)}>{normalizeLabel(s.influence_level || "—")}</PmoBadge>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Interés</OrbisFieldLabel>
                                                        <PmoBadge tone={getPriorityTone(s.interest_level)}>{normalizeLabel(s.interest_level || "—")}</PmoBadge>
                                                        {Number(s.is_primary_contact || 0) === 1 ? <PmoBadge tone="gold">Principal</PmoBadge> : null}
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Acciones</OrbisFieldLabel>
                                                        <DetailActionButtons
                                                            onView={() => openStakeholderModal(s, "view")}
                                                            onEdit={() => openStakeholderModal(s, "edit")}
                                                        />
                                                    </div>
                                                </div>
                                            </OrbisRecordCard>
                                        ))
                                    ) : (
                                        <OrbisRecordCard accent="#64748b">
                                            <div style={{ color: "#d7efff", fontWeight: 800 }}>Sin stakeholders registrados.</div>
                                        </OrbisRecordCard>
                                    )}
                                </div>
                            </SectionCard>
                        )}

                        {activeTab === "documents" && (
                            <SectionCard
                                title="Documentos"
                                right={<ActionButton onClick={() => openDocumentModal(null, "edit")}>+ Subir documento</ActionButton>}
                            >
                                <SectionIntro tabKey="documents" />
                                <div
                                    style={{
                                        background: "linear-gradient(180deg, #08324b 0%, #06283d 100%)",
                                        color: "#d7efff",
                                        padding: 12,
                                        borderRadius: 10,
                                        border: "1px solid rgba(0,186,255,.22)",
                                        marginBottom: 16,
                                        fontSize: 13,
                                    }}
                                >
                                    Módulo documental único del proyecto. Aquí concentras documentos, imágenes y evidencias para Proyecto, Avances, Tareas, Riesgos, Entregables, Stakeholders, Áreas y Alcance.
                                </div>

                                <div style={{ marginBottom: 18 }}>
                                    <div style={{ fontSize: 15, fontWeight: 800, color: "#ffffff", marginBottom: 10 }}>Matriz documental PMO</div>
                                    <TableWrapper>
                                        <thead>
                                            <tr>
                                                <Th>Sección</Th>
                                                <Th>Documento</Th>
                                                <Th>Imagen</Th>
                                                <Th>Evidencia</Th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {documentMatrix.map((row) => (
                                                <tr key={row.section}>
                                                    <Td>{getSectionLabel(row.section)}</Td>
                                                    <Td>{row.documento}</Td>
                                                    <Td>{row.imagen}</Td>
                                                    <Td>{row.evidencia}</Td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </TableWrapper>
                                </div>

                                <div style={{ display: "grid", gap: 12 }}>
                                    {documents.length ? (
                                        documents.map((d) => (
                                            <OrbisRecordCard key={d.id} accent="#00baff">
                                                <div
                                                    style={{
                                                        display: "grid",
                                                        gridTemplateColumns: "minmax(300px, 1.5fr) repeat(4, minmax(120px, .75fr)) minmax(180px, .9fr)",
                                                        gap: 14,
                                                        alignItems: "start",
                                                    }}
                                                >
                                                    <div>
                                                        <OrbisFieldLabel>Documento</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 950, fontSize: 14 }}>{d.title || d.document_name || "—"}</div>
                                                        <div style={{ color: "#b9e8ff", fontSize: 12, lineHeight: 1.45, marginTop: 5 }}>{truncateForCard(d.description || "Sin descripción", 150)}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Sección</OrbisFieldLabel>
                                                        <PmoBadge tone="blue">{getSectionLabel(d.section_type)}</PmoBadge>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Categoría</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 850 }}>{d.document_category || "—"}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Archivo</OrbisFieldLabel>
                                                        {d.file_url || d.file_path ? (
                                                            <a href={d.file_url || d.file_path} target="_blank" rel="noreferrer" style={{ color: "#7dd3fc", fontWeight: 850 }}>
                                                                {d.file_name || "Abrir archivo"}
                                                            </a>
                                                        ) : <div style={{ color: "#b9e8ff" }}>—</div>}
                                                        <div style={{ color: "#b9e8ff", fontSize: 12, marginTop: 5 }}>{d.file_type || "Sin tipo"}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Subido por</OrbisFieldLabel>
                                                        <div style={{ color: "#fff", fontWeight: 850 }}>{d.uploaded_by_user_name || "—"}</div>
                                                    </div>
                                                    <div>
                                                        <OrbisFieldLabel>Acciones</OrbisFieldLabel>
                                                        <DetailActionButtons
                                                            onView={() => openDocumentModal(d, "view")}
                                                            onEdit={() => openDocumentModal(d, "edit")}
                                                        />
                                                    </div>
                                                </div>
                                            </OrbisRecordCard>
                                        ))
                                    ) : (
                                        <OrbisRecordCard accent="#64748b">
                                            <div style={{ color: "#d7efff", fontWeight: 800 }}>Sin documentos registrados.</div>
                                        </OrbisRecordCard>
                                    )}
                                </div>
                            </SectionCard>
                        )}

                        {activeTab === "scope" && (
                            <SectionCard
                                title="Alcance"
                                right={<ActionButton onClick={openScopeModal}>Editar alcance</ActionButton>}
                            >
                                <SectionIntro tabKey="scope" />
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        gap: 18,
                                    }}
                                >
                                    <div>
                                        <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 6 }}>Objetivo del proyecto</div>
                                        <div style={{ marginBottom: 18 }}>{scopeData?.project_objective || "—"}</div>

                                        <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 6 }}>Alcance del producto</div>
                                        <div>{scopeData?.product_scope || "—"}</div>
                                    </div>

                                    <div>
                                        <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 6 }}>Entregables</div>
                                        <div style={{ marginBottom: 18 }}>{scopeData?.deliverables || "—"}</div>

                                        <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 6 }}>Criterios de aceptación</div>
                                        <div style={{ marginBottom: 18 }}>{scopeData?.acceptance_criteria || "—"}</div>

                                        <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 6 }}>Exclusiones</div>
                                        <div>{scopeData?.exclusions || "—"}</div>
                                    </div>
                                </div>
                            </SectionCard>
                        )}
                        {activeTab === "access" && (
                            <SectionCard title="Accesos del proyecto">
                                <SectionIntro tabKey="access" />
                                <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 14 }}>
                                    Define el acceso por usuario al proyecto. El tipo <strong>Total</strong> habilita todo, <strong>Limitado</strong> permite configurar manualmente y <strong>Lectura</strong> deja solo lectura.
                                </div>

                                <div
                                    style={{
                                        marginBottom: 14,
                                        display: "flex",
                                        gap: 10,
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    <select
                                        value={selectedUser}
                                        onChange={(e) => setSelectedUser(e.target.value)}
                                        style={{
                                            padding: 10,
                                            borderRadius: 12,
                                            border: "1px solid rgba(125,211,252,.35)",
                                            minWidth: 260,
                                            background: "#06283d",
                                            color: "#fff",
                                        }}
                                    >
                                        <option value="">Seleccionar usuario</option>
                                        {usersCatalog.map((u) => (
                                            <option key={u.id} value={u.id}>
                                                {u.display_name}
                                            </option>
                                        ))}
                                    </select>
                                    <button
                                        type="button"
                                        onClick={async () => {
                                            try {
                                                await handleAddAccess();
                                            } catch (e) {
                                                console.error(e);
                                                alert(e.message || "No se pudo agregar acceso");
                                            }
                                        }}
                                        style={{
                                            padding: "10px 14px",
                                            borderRadius: 999,
                                            border: "1px solid rgba(125,211,252,.35)",
                                            background: "#f4b91b",
                                            color: "#06111f",
                                            fontWeight: 800,
                                            cursor: "pointer",
                                        }}
                                    >
                                        Agregar
                                    </button>
                                </div>

                                <div style={{ overflowX: "auto", borderRadius: 18, border: "1px solid rgba(0,186,255,.22)", background: "linear-gradient(180deg, #06283d 0%, #041c2c 100%)", padding: 10 }}>
                                    <table
                                        style={{
                                            width: "100%",
                                            minWidth: 1260,
                                            borderCollapse: "collapse",
                                            background: "linear-gradient(180deg, #06283d 0%, #041c2c 100%)",
                                            border: "1px solid rgba(0,186,255,.22)",
                                            borderRadius: 16,
                                            overflow: "hidden",
                                        }}
                                    >
                                        <thead>
                                            <tr style={{ background: "rgba(255,255,255,.02)" }}>
                                                <th style={{ textAlign: "left", padding: 12, borderBottom: "1px solid rgba(125,211,252,.18)", color: "#7dd3fc", fontSize: 11, fontWeight: 900, letterSpacing: ".08em", textTransform: "uppercase" }}>Usuario</th>
                                                <th style={{ textAlign: "left", padding: 12, borderBottom: "1px solid rgba(125,211,252,.18)", color: "#7dd3fc", fontSize: 11, fontWeight: 900, letterSpacing: ".08em", textTransform: "uppercase" }}>Tipo</th>
                                                <th style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.18)", color: "#7dd3fc", fontSize: 11, fontWeight: 900, letterSpacing: ".08em", textTransform: "uppercase" }}>Proyecto</th>
                                                <th style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.18)", color: "#7dd3fc", fontSize: 11, fontWeight: 900, letterSpacing: ".08em", textTransform: "uppercase" }}>Avances</th>
                                                <th style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.18)", color: "#7dd3fc", fontSize: 11, fontWeight: 900, letterSpacing: ".08em", textTransform: "uppercase" }}>Tasks</th>
                                                <th style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.18)", color: "#7dd3fc", fontSize: 11, fontWeight: 900, letterSpacing: ".08em", textTransform: "uppercase" }}>Edit Tasks</th>
                                                <th style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.18)", color: "#7dd3fc", fontSize: 11, fontWeight: 900, letterSpacing: ".08em", textTransform: "uppercase" }}>Docs</th>
                                                <th style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.18)", color: "#7dd3fc", fontSize: 11, fontWeight: 900, letterSpacing: ".08em", textTransform: "uppercase" }}>Upload</th>
                                                <th style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.18)", color: "#7dd3fc", fontSize: 11, fontWeight: 900, letterSpacing: ".08em", textTransform: "uppercase" }}>Scope</th>
                                                <th style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.18)", color: "#7dd3fc", fontSize: 11, fontWeight: 900, letterSpacing: ".08em", textTransform: "uppercase" }}>Budget</th>
                                                <th style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.18)", color: "#7dd3fc", fontSize: 11, fontWeight: 900, letterSpacing: ".08em", textTransform: "uppercase" }}>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {projectAccess.length ? (
                                                projectAccess.map((a) => {
                                                    const draft = accessDrafts[a.user_id] || {};
                                                    const draftType = draft.access_type || a.access_type || "limited";
                                                    const locked = draftType === "full" || draftType === "view_only";

                                                    return (
                                                        <tr key={a.user_id}>
                                                            <td style={{ padding: 12, borderBottom: "1px solid rgba(125,211,252,.12)", color: "#ffffff" }}>
                                                                <div style={{ fontWeight: 600 }}>{a.user_name || `Usuario #${a.user_id}`}</div>
                                                                <div style={{ fontSize: 11, color: "#93c5fd" }}>{a.user_email || ""}</div>
                                                            </td>
                                                            <td style={{ padding: 12, borderBottom: "1px solid rgba(125,211,252,.12)", color: "#ffffff" }}>
                                                                <select
                                                                    value={draftType}
                                                                    onChange={(e) => updateAccessDraft(a.user_id, "access_type", e.target.value)}
                                                                    style={{ padding: 8, borderRadius: 10, border: "1px solid rgba(125,211,252,.35)", minWidth: 130, background: "#06283d", color: "#fff" }}
                                                                >
                                                                    <option value="full">Total</option>
                                                                    <option value="limited">Limitado</option>
                                                                    <option value="view_only">Lectura</option>
                                                                </select>
                                                            </td>
                                                            <td style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.12)", color: "#ffffff" }}><input type="checkbox" checked={Number(draft.can_view_project ?? a.can_view_project) === 1} disabled={locked} onChange={() => toggleAccessDraft(a.user_id, "can_view_project")} /></td>
                                                            <td style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.12)", color: "#ffffff" }}><input type="checkbox" checked={Number(draft.can_view_updates ?? a.can_view_updates) === 1} disabled={locked} onChange={() => toggleAccessDraft(a.user_id, "can_view_updates")} /></td>
                                                            <td style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.12)", color: "#ffffff" }}><input type="checkbox" checked={Number(draft.can_view_tasks ?? a.can_view_tasks) === 1} disabled={locked} onChange={() => toggleAccessDraft(a.user_id, "can_view_tasks")} /></td>
                                                            <td style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.12)", color: "#ffffff" }}><input type="checkbox" checked={Number(draft.can_edit_tasks ?? a.can_edit_tasks) === 1} disabled={locked} onChange={() => toggleAccessDraft(a.user_id, "can_edit_tasks")} /></td>
                                                            <td style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.12)", color: "#ffffff" }}><input type="checkbox" checked={Number(draft.can_view_documents ?? a.can_view_documents) === 1} disabled={locked} onChange={() => toggleAccessDraft(a.user_id, "can_view_documents")} /></td>
                                                            <td style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.12)", color: "#ffffff" }}><input type="checkbox" checked={Number(draft.can_upload_documents ?? a.can_upload_documents) === 1} disabled={locked} onChange={() => toggleAccessDraft(a.user_id, "can_upload_documents")} /></td>
                                                            <td style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.12)", color: "#ffffff" }}><input type="checkbox" checked={Number(draft.can_view_scope ?? a.can_view_scope) === 1} disabled={locked} onChange={() => toggleAccessDraft(a.user_id, "can_view_scope")} /></td>
                                                            <td style={{ textAlign: "center", padding: 12, borderBottom: "1px solid rgba(125,211,252,.12)", color: "#ffffff" }}><input type="checkbox" checked={Number(draft.can_view_budget ?? a.can_view_budget) === 1} disabled={locked} onChange={() => toggleAccessDraft(a.user_id, "can_view_budget")} /></td>
                                                            <td style={{ padding: 12, borderBottom: "1px solid rgba(125,211,252,.12)", color: "#ffffff" }}>
                                                                <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
                                                                    <button type="button" onClick={() => saveAccessRow(a.user_id)} style={{ border: "1px solid rgba(125,211,252,.35)", background: "#f4b91b", color: "#06111f", borderRadius: 999, padding: "7px 12px", cursor: "pointer", fontWeight: 800 }}>Guardar</button>
                                                                    <button type="button" title="Eliminar acceso" onClick={() => removeAccess(a.user_id)} style={{ border: "1px solid #ef4444", background: "transparent", color: "#ffb4b4", borderRadius: 999, padding: "7px 12px", cursor: "pointer", fontWeight: 800 }}>🗑</button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={11} style={{ padding: 16, textAlign: "center", color: "#d7efff" }}>
                                                        No hay accesos configurados para este proyecto.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </SectionCard>
                        )}
                    </>
                )}


                <ModalShell open={showStakeholderModal} title={stakeholderMode === "view" ? "Detalle stakeholder" : "Stakeholder"} onClose={() => setShowStakeholderModal(false)} width={980}>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16 }}>
                        <Select label="Usuario vinculado" value={stakeholderForm.user_id} onChange={handleChange(setStakeholderForm)} name="user_id" disabled={stakeholderMode === "view"}>
                            <option value="">Sin vincular a usuario</option>
                            {userOptions.map((opt) => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                        </Select>
                        <Input label="Nombre" name="name" value={stakeholderForm.name} onChange={handleChange(setStakeholderForm)} disabled={stakeholderMode === "view"} />
                        <Input label="Rol" name="role" value={stakeholderForm.role} onChange={handleChange(setStakeholderForm)} disabled={stakeholderMode === "view"} />
                        <Select label="Tipo stakeholder" value={stakeholderForm.stakeholder_type} onChange={handleChange(setStakeholderForm)} name="stakeholder_type" disabled={stakeholderMode === "view"}>
                            {STAKEHOLDER_TYPES.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>
                        <Input label="Empresa / institución" name="company" value={stakeholderForm.company} onChange={handleChange(setStakeholderForm)} disabled={stakeholderMode === "view"} />
                        <Input label="Correo" name="email" value={stakeholderForm.email} onChange={handleChange(setStakeholderForm)} disabled={stakeholderMode === "view"} />
                        <Input label="Teléfono" name="phone" value={stakeholderForm.phone} onChange={handleChange(setStakeholderForm)} disabled={stakeholderMode === "view"} />
                        <Input label="WhatsApp" name="whatsapp" value={stakeholderForm.whatsapp} onChange={handleChange(setStakeholderForm)} disabled={stakeholderMode === "view"} />
                        <Select label="Influencia" value={stakeholderForm.influence_level} onChange={handleChange(setStakeholderForm)} name="influence_level" disabled={stakeholderMode === "view"}>
                            <option value="baja">baja</option><option value="media">media</option><option value="alta">alta</option>
                        </Select>
                        <Select label="Interés" value={stakeholderForm.interest_level} onChange={handleChange(setStakeholderForm)} name="interest_level" disabled={stakeholderMode === "view"}>
                            <option value="bajo">bajo</option><option value="medio">medio</option><option value="alto">alto</option>
                        </Select>
                        <Input label="Foto URL" name="photo_url" value={stakeholderForm.photo_url} onChange={handleChange(setStakeholderForm)} disabled={stakeholderMode === "view"} />
                        <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 24 }}>
                            <input type="checkbox" checked={!!stakeholderForm.is_primary_contact} onChange={(e) => setStakeholderForm((prev) => ({ ...prev, is_primary_contact: e.target.checked }))} disabled={stakeholderMode === "view"} />
                            <span style={{ fontSize: 14, color: "#ffffff" }}>Contacto principal</span>
                        </div>
                    </div>
                    <TextArea label="Notas" value={stakeholderForm.notes} onChange={handleChange(setStakeholderForm)} name="notes" disabled={stakeholderMode === "view"} />
                    <div style={{ marginTop: 16 }}>
                        {stakeholderMode !== "view" ? <ActionButton onClick={saveStakeholder} disabled={savingStakeholder}>{savingStakeholder ? "Guardando..." : "Guardar stakeholder"}</ActionButton> : null}
                        {stakeholderForm.id ? (
                            <ActionButton onClick={() => deleteItem("project_stakeholders.php", stakeholderForm.id, "stakeholder", () => setShowStakeholderModal(false))} bg="transparent" color="#ffb4b4" border="1px solid rgba(239,68,68,.70)">
                                Eliminar
                            </ActionButton>
                        ) : null}
                    </div>
                </ModalShell>

                <ModalShell open={showProjectModal} title="Editar proyecto" onClose={() => setShowProjectModal(false)} width={1100}>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16 }}>
                        <Input
                            label="Nombre"
                            value={projectForm.name}
                            onChange={handleChange(setProjectForm)}
                            name="name"
                            hint="Nombre oficial con el que se identificará el proyecto en la PMO."
                        />

                        <Input
                            label="Código"
                            value={projectForm.code}
                            onChange={handleChange(setProjectForm)}
                            name="code"
                            hint="Clave interna o identificador del proyecto."
                        />

                        <Select
                            label="Tipo de proyecto"
                            value={projectForm.project_type}
                            onChange={handleChange(setProjectForm)}
                            name="project_type"
                            hint="Clasificación general del proyecto."
                        >
                            {TIPOS_PROYECTO.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <Select
                            label="Prioridad"
                            value={projectForm.priority}
                            onChange={handleChange(setProjectForm)}
                            name="priority"
                            hint="Nivel de urgencia y relevancia del proyecto."
                        >
                            {PRIORIDADES.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <Select
                            label="Etapa"
                            value={projectForm.stage}
                            onChange={handleChange(setProjectForm)}
                            name="stage"
                            hint="Fase actual del ciclo de vida del proyecto."
                        >
                            {ETAPAS_PROYECTO.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <Select
                            label="Estatus"
                            value={projectForm.status}
                            onChange={handleChange(setProjectForm)}
                            name="status"
                            hint="Situación operativa actual del proyecto."
                        >
                            {ESTATUS_PROYECTO.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <Select
                            label="Salud del proyecto"
                            value={projectForm.health_status}
                            onChange={handleChange(setProjectForm)}
                            name="health_status"
                            hint="Semáforo ejecutivo general del proyecto."
                        >
                            {SALUD_PROYECTO.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <Input
                            label="Avance general %"
                            type="number"
                            min="0"
                            max="100"
                            value={project?.progress_percent ?? 0}
                            name="progress_percent"
                            disabled
                            hint="Este valor se calcula automáticamente con base en el avance promedio de las tareas."
                        />

                        <Select
                            label="Project Manager"
                            value={projectForm.project_manager_user_id}
                            onChange={handleChange(setProjectForm)}
                            name="project_manager_user_id"
                            hint="Responsable principal de coordinar y controlar el proyecto."
                        >
                            <option value="">Seleccionar</option>
                            {userOptions.map((u) => <option key={u.value} value={u.value}>{u.label}</option>)}
                        </Select>

                        <Select
                            label="Sponsor"
                            value={projectForm.sponsor_user_id}
                            onChange={handleChange(setProjectForm)}
                            name="sponsor_user_id"
                            hint="Patrocinador principal del proyecto tomado del catálogo de usuarios."
                        >
                            <option value="">Seleccionar</option>
                            {userOptions.map((u) => <option key={u.value} value={u.value}>{u.label}</option>)}
                        </Select>

                        <Select
                            label="Creado por"
                            value={projectForm.created_by_user_id}
                            onChange={handleChange(setProjectForm)}
                            name="created_by_user_id"
                            hint="Usuario que registró inicialmente el proyecto."
                        >
                            <option value="">Seleccionar</option>
                            {userOptions.map((u) => <option key={u.value} value={u.value}>{u.label}</option>)}
                        </Select>

                        <Input
                            label="Inicio planeado"
                            type="date"
                            value={projectForm.planned_start_date}
                            onChange={handleChange(setProjectForm)}
                            name="planned_start_date"
                            hint="Fecha base planeada de arranque."
                        />

                        <Input
                            label="Fin planeado"
                            type="date"
                            value={projectForm.planned_end_date}
                            onChange={handleChange(setProjectForm)}
                            name="planned_end_date"
                            hint="Fecha base planeada de cierre."
                        />

                        <Input
                            label="Inicio real"
                            type="date"
                            value={projectForm.actual_start_date}
                            onChange={handleChange(setProjectForm)}
                            name="actual_start_date"
                            hint="Fecha real de inicio."
                        />

                        <Input
                            label="Fin real"
                            type="date"
                            value={projectForm.actual_end_date}
                            onChange={handleChange(setProjectForm)}
                            name="actual_end_date"
                            hint="Fecha real de cierre."
                        />

                        <Input
                            label="Inicio operativo"
                            type="date"
                            value={projectForm.start_date}
                            onChange={handleChange(setProjectForm)}
                            name="start_date"
                            hint="Fecha de referencia operativa."
                        />

                        <Input
                            label="Fin operativo"
                            type="date"
                            value={projectForm.end_date}
                            onChange={handleChange(setProjectForm)}
                            name="end_date"
                            hint="Fecha de referencia operativa de cierre."
                        />

                        <Input
                            label="Enfoque ESG"
                            value={projectForm.esg_focus}
                            onChange={handleChange(setProjectForm)}
                            name="esg_focus"
                            hint="Enfoque ambiental, social y/o de gobernanza, si aplica."
                        />

                        <Select
                            label="Nivel de riesgo del proyecto"
                            value={projectForm.risk_level}
                            onChange={handleChange(setProjectForm)}
                            name="risk_level"
                            hint="Valoración global del riesgo del proyecto."
                        >
                            {RIESGO_PROYECTO.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea
                                label="Descripción"
                                value={projectForm.description}
                                onChange={handleChange(setProjectForm)}
                                name="description"
                                rows={4}
                                hint="Descripción ejecutiva del objetivo, contexto y alcance general del proyecto."
                            />
                        </div>

                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea
                                label="Impacto estratégico"
                                value={projectForm.strategic_impact}
                                onChange={handleChange(setProjectForm)}
                                name="strategic_impact"
                                rows={4}
                                hint="Cómo aporta este proyecto a la estrategia institucional o comercial."
                            />
                        </div>

                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea
                                label="Criterios de éxito"
                                value={projectForm.success_criteria}
                                onChange={handleChange(setProjectForm)}
                                name="success_criteria"
                                rows={4}
                                hint="Condiciones concretas que definen que el proyecto fue exitoso."
                            />
                        </div>

                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea
                                label="Notas"
                                value={projectForm.notes}
                                onChange={handleChange(setProjectForm)}
                                name="notes"
                                rows={4}
                                hint="Observaciones, justificaciones, contexto adicional y comentarios ejecutivos."
                            />
                        </div>
                    </div>

                    <div style={{ marginTop: 10 }}>
                        <ActionButton onClick={() => setShowProjectModal(false)} bg="#fff" color="#111827" border="1px solid #d1d5db">
                            Cancelar
                        </ActionButton>
                        <ActionButton onClick={saveProject} disabled={savingProject}>
                            {savingProject ? "Guardando..." : "Guardar proyecto"}
                        </ActionButton>
                    </div>
                </ModalShell>

                <ModalShell open={showBudgetModal} title="Editar presupuesto" onClose={() => setShowBudgetModal(false)} width={1100}>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16 }}>
                        <Input
                            label="Valor del contrato"
                            value={budgetForm.contract_value}
                            onChange={handleChange(setBudgetForm)}
                            name="contract_value"
                            hint="Monto contractual comprometido para el proyecto."
                        />

                        <Input
                            label="Presupuesto planeado"
                            value={budgetForm.budget_planned}
                            onChange={handleChange(setBudgetForm)}
                            name="budget_planned"
                            hint="Monto estimado o aprobado inicialmente."
                        />

                        <Input
                            label="Presupuesto actual"
                            value={budgetForm.budget_actual}
                            onChange={handleChange(setBudgetForm)}
                            name="budget_actual"
                            hint="Monto ejercido o actualizado del proyecto."
                        />

                        <Input
                            label="Moneda"
                            value={budgetForm.currency}
                            onChange={handleChange(setBudgetForm)}
                            name="currency"
                            hint="Clave de moneda, por ejemplo MXN, USD o EUR."
                        />

                        <Input
                            label="Impacto EBITDA estimado"
                            value={budgetForm.ebitda_impact_est}
                            onChange={handleChange(setBudgetForm)}
                            name="ebitda_impact_est"
                            hint="Estimación económica del impacto generado por el proyecto."
                        />

                        <div />

                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea
                                label="Descripción del presupuesto"
                                value={budgetForm.budget_description}
                                onChange={handleChange(setBudgetForm)}
                                name="budget_description"
                                rows={4}
                                hint="Describe la composición general del presupuesto del proyecto."
                            />
                        </div>

                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea
                                label="Justificación del presupuesto"
                                value={budgetForm.budget_justification}
                                onChange={handleChange(setBudgetForm)}
                                name="budget_justification"
                                rows={4}
                                hint="Explica por qué este presupuesto es necesario y cómo se sustenta."
                            />
                        </div>

                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea
                                label="Notas del presupuesto"
                                value={budgetForm.budget_notes}
                                onChange={handleChange(setBudgetForm)}
                                name="budget_notes"
                                rows={4}
                                hint="Observaciones, restricciones, comentarios y notas financieras."
                            />
                        </div>
                    </div>

                    <div style={{ marginTop: 10 }}>
                        <ActionButton onClick={() => setShowBudgetModal(false)} bg="#fff" color="#111827" border="1px solid #d1d5db">
                            Cancelar
                        </ActionButton>
                        <ActionButton onClick={saveBudget} disabled={savingBudget}>
                            {savingBudget ? "Guardando..." : "Guardar presupuesto"}
                        </ActionButton>
                    </div>
                </ModalShell>

                <ModalShell open={showUpdateModal} title={updateMode === "view" ? "Detalle del avance" : (updateForm.id ? "Editar avance" : "Nuevo avance")} onClose={() => setShowUpdateModal(false)} width={950}>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16 }}>
                        <Input
                            label="Fecha"
                            type="date"
                            value={updateForm.update_date}
                            onChange={handleChange(setUpdateForm)}
                            name="update_date"
                            disabled={updateMode === "view"}
                            hint="Fecha del reporte o actualización."
                        />

                        <Input
                            label="Título"
                            value={updateForm.title}
                            onChange={handleChange(setUpdateForm)}
                            name="title"
                            disabled={updateMode === "view"}
                            hint="Nombre corto del avance reportado."
                        />

                        <Input
                            label="Avance %"
                            type="number"
                            min="0"
                            max="100"
                            value={taskForm.progress_percent}
                            onChange={handleChange(setTaskForm)}
                            name="progress_percent"
                            disabled={taskMode === "view" || selectedTaskHasChildren}
                            hint={
                                selectedTaskHasChildren
                                    ? "Esta tarea es padre y su avance se calcula automáticamente con base en sus subtareas."
                                    : "Porcentaje completado de la tarea."
                            }
                        />
                        <Select
                            label="Estatus"
                            value={updateForm.status}
                            onChange={handleChange(setUpdateForm)}
                            name="status"
                            disabled={updateMode === "view"}
                            hint="Estado general del avance reportado."
                        >
                            {ESTATUS_AVANCE.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <Select
                            label="Creado por"
                            value={updateForm.created_by}
                            onChange={handleChange(setUpdateForm)}
                            name="created_by"
                            disabled={updateMode === "view"}
                            hint="Usuario que registra este avance."
                        >
                            <option value="">Seleccionar</option>
                            {userOptions.map((u) => <option key={u.value} value={u.value}>{u.label}</option>)}
                        </Select>

                        <Input
                            label="Nota de estatus"
                            value={updateForm.status_note}
                            onChange={handleChange(setUpdateForm)}
                            name="status_note"
                            disabled={updateMode === "view"}
                            hint="Comentario breve sobre la condición actual del proyecto."
                        />

                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea
                                label="Resumen"
                                value={updateForm.summary}
                                onChange={handleChange(setUpdateForm)}
                                name="summary"
                                rows={3}
                                disabled={updateMode === "view"}
                                hint="Resumen ejecutivo del avance."
                            />
                        </div>

                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea
                                label="Descripción"
                                value={updateForm.description}
                                onChange={handleChange(setUpdateForm)}
                                name="description"
                                rows={4}
                                disabled={updateMode === "view"}
                                hint="Detalle del avance, hitos, incidencias o acuerdos."
                            />
                        </div>
                    </div>

                    <div style={{ marginTop: 10 }}>
                        <ActionButton onClick={() => setShowUpdateModal(false)} bg="#fff" color="#111827" border="1px solid #d1d5db">
                            Cerrar
                        </ActionButton>

                        {updateMode === "edit" ? (
                            <>
                                {updateForm.id ? (
                                    <ActionButton
                                        onClick={() => deleteItem("project_updates.php", updateForm.id, "avance", () => setShowUpdateModal(false))}
                                        bg="transparent"
                                        color="#ffb4b4"
                                        border="1px solid rgba(239,68,68,.70)"
                                    >
                                        Eliminar
                                    </ActionButton>
                                ) : null}
                                <ActionButton onClick={saveUpdate} disabled={savingUpdate}>
                                    {savingUpdate ? "Guardando..." : "Guardar avance"}
                                </ActionButton>
                            </>
                        ) : null}
                    </div>
                </ModalShell>

                {/*onClose={() => setShowTaskModal(false)}*/}


                <ModalShell
                    open={showTaskModal}
                    title={taskMode === "view" ? "Detalle de la tarea" : (taskForm.id ? "Editar tarea" : "Nueva tarea")}
                    onClose={handleCloseTaskModal}
                    width={950}
                >
                    {taskMode === "progress" ? (
                        <div
                            style={{
                                marginBottom: 14,
                                padding: "10px 12px",
                                borderRadius: 12,
                                background: "#eff6ff",
                                color: "#1d4ed8",
                                fontWeight: 700,
                                fontSize: 13,
                            }}
                        >
                            Modo enfocado: registrar avance
                        </div>
                    ) : null}

                    {taskMode === "review" ? (
                        <div
                            style={{
                                marginBottom: 14,
                                padding: "10px 12px",
                                borderRadius: 12,
                                background: "#fff7ed",
                                color: "#9a3412",
                                fontWeight: 700,
                                fontSize: 13,
                            }}
                        >
                            Modo enfocado: revisión de avance
                        </div>
                    ) : null}
                    {taskForm.id ? (
                        <div
                            style={{
                                background: "rgba(255,255,255,.04)",
                                border: "1px solid rgba(125,211,252,.18)",
                                borderRadius: 12,
                                padding: 14,
                                marginBottom: 16,
                            }}
                        >
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, alignItems: "center" }}>
                                <div style={{ fontWeight: 700, color: "#ffffff" }}>
                                    Estado actual de la tarea
                                </div>

                                <TaskStatusBadge status={taskForm.status} />

                                {(() => {
                                    const reviewConfig = getReviewStatusBadge(taskForm.review_status);
                                    return (
                                        <Badge bg={reviewConfig.bg} color={reviewConfig.color}>
                                            {reviewConfig.label}
                                        </Badge>
                                    );
                                })()}
                            </div>

                            <div style={{ marginTop: 10, display: "flex", gap: 8, flexWrap: "wrap" }}>
                                {Number(taskForm.is_blocked || 0) === 1 ? (
                                    <Badge bg="#fef2f2" color="#991b1b">
                                        Bloqueada{taskForm.blocked_reason ? ` · ${taskForm.blocked_reason}` : ""}
                                    </Badge>
                                ) : null}

                                {taskForm.depends_on_task_id ? (() => {
                                    const dependencyTask = tasks.find(
                                        (t) => String(t.id) === String(taskForm.depends_on_task_id)
                                    );

                                    const dependencyInfo = getDependencyTypeInfo(taskForm.dependency_type || "FS");

                                    return (
                                        <div
                                            style={{
                                                display: "inline-flex",
                                                flexDirection: "column",
                                                gap: 4,
                                                padding: "8px 12px",
                                                borderRadius: 12,
                                                background: "rgba(255,255,255,.04)",
                                                border: "1px solid rgba(125,211,252,.18)",
                                                color: "#d7efff",
                                                fontSize: 12,
                                                fontWeight: 700,
                                            }}
                                        >
                                            <span>
                                                Predecesora:{" "}
                                                {dependencyTask
                                                    ? `${dependencyTask.wbs_code || dependencyTask.id} · ${dependencyTask.name || "Tarea"}`
                                                    : `ID ${taskForm.depends_on_task_id}`}
                                            </span>

                                            <span style={{ color: "#7dd3fc", fontWeight: 800 }}>
                                                Dependencia: {dependencyInfo.label}
                                            </span>

                                            <span style={{ color: "#b9e8ff", fontWeight: 700 }}>
                                                {dependencyInfo.short}
                                            </span>
                                        </div>
                                    );
                                })() : null}
                                {Number(taskForm.requires_review || 0) === 1 ? (
                                    <Badge bg="#fffbeb" color="#92400e">
                                        Requiere revisión · {getTaskReviewStatusLabel(taskForm.review_status)}
                                    </Badge>
                                ) : null}
                            </div>
                        </div>
                    ) : null}

                    {selectedTaskHasChildren ? (
                        <div
                            style={{
                                background: "rgba(244,185,27,.12)",
                                color: "#fde68a",
                                padding: 12,
                                borderRadius: 12,
                                border: "1px solid rgba(244,185,27,.42)",
                                marginBottom: 16,
                                fontSize: 13,
                            }}
                        >
                            Esta tarea es un elemento padre del WBS. Su avance se calcula automáticamente con base en el progreso de sus subtareas.
                        </div>
                    ) : null}

                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16 }}>
                        <Input
                            label="WBS"
                            value={taskForm.wbs_code}
                            onChange={handleChange(setTaskForm)}
                            name="wbs_code"
                            placeholder="Ej. 1.2.1"
                            disabled={taskMode === "view"}
                            hint="Código jerárquico de la EDT/WBS para ordenar la tarea dentro del proyecto."
                        />

                        <Input
                            label="Nombre"
                            value={taskForm.name}
                            onChange={handleChange(setTaskForm)}
                            name="name"
                            disabled={taskMode === "view"}
                            hint="Nombre breve de la tarea o paquete de trabajo."
                        />

                        <Select
                            label="Tarea padre"
                            value={taskForm.parent_task_id}
                            onChange={handleChange(setTaskForm)}
                            name="parent_task_id"
                            disabled={taskMode === "view"}
                            hint="Relaciona esta tarea con un paquete padre del WBS. Déjalo vacío si es una tarea raíz."
                        >
                            <option value="">Sin padre</option>
                            {taskParentOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </Select>

                        <Select
                            label="Tarea predecesora"
                            value={taskForm.depends_on_task_id}
                            onChange={handleChange(setTaskForm)}
                            name="depends_on_task_id"
                            disabled={taskMode === "view"}
                            hint="Tarea que debe cumplirse antes de ejecutar esta tarea."
                        >
                            <option value="">Sin predecesora</option>
                            {taskDependencyOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </Select>

                        <Select
                            label="Tipo de dependencia"
                            name="dependency_type"
                            value={taskForm.dependency_type}
                            onChange={handleChange(setTaskForm)}
                            disabled={taskMode === "view"}
                            hint={
                                taskForm.depends_on_task_id
                                    ? `${getDependencyTypeInfo(taskForm.dependency_type).short} ${getDependencyTypeInfo(taskForm.dependency_type).example}`
                                    : "Selecciona primero una tarea predecesora si esta tarea depende de otra."
                            }
                        >
                            {TASK_DEPENDENCY_TYPES.map((type) => (
                                <option key={type.value} value={type.value}>
                                    {type.label}
                                </option>
                            ))}
                        </Select>

                        <Input
                            label="Lag / desfase (días)"
                            type="number"
                            value={taskForm.lag_days}
                            onChange={handleChange(setTaskForm)}
                            name="lag_days"
                            disabled={taskMode === "view"}
                            hint="Días de desfase entre la predecesora y esta tarea."
                        />

                        <Select
                            label="Responsable"
                            value={taskForm.owner_user_id}
                            onChange={handleChange(setTaskForm)}
                            name="owner_user_id"
                            disabled={taskMode === "view"}
                            hint="Usuario responsable de ejecutar o coordinar esta tarea."
                        >
                            <option value="">Seleccionar</option>
                            {userOptions.map((u) => <option key={u.value} value={u.value}>{u.label}</option>)}
                        </Select>

                        <Select
                            label="Revisor"
                            value={taskForm.reviewer_user_id}
                            onChange={handleChange(setTaskForm)}
                            name="reviewer_user_id"
                            disabled={taskMode === "view"}
                            hint="Usuario responsable de revisar o aprobar esta tarea."
                        >
                            <option value="">Sin revisor</option>
                            {userOptions.map((u) => <option key={u.value} value={u.value}>{u.label}</option>)}
                        </Select>

                        <Select
                            label="Área"
                            value={taskForm.area_id}
                            onChange={handleChange(setTaskForm)}
                            name="area_id"
                            disabled={taskMode === "view"}
                            hint="Área responsable o relacionada con la ejecución de esta tarea."
                        >
                            <option value="">Sin área</option>
                            {taskAreaOptions.map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </Select>

                        <Select
                            label="Estatus"
                            value={getTaskStatusLabel(taskForm.status)}
                            onChange={handleChange(setTaskForm)}
                            name="status"
                            disabled={taskMode === "view" || selectedTaskHasChildren}
                            hint={
                                selectedTaskHasChildren
                                    ? "Esta tarea es padre y su seguimiento debe reflejar el estado agregado de sus subtareas."
                                    : "Situación actual de la tarea."
                            }
                        >
                            {ESTATUS_TAREA.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <Select
                            label="Prioridad"
                            value={taskForm.priority}
                            onChange={handleChange(setTaskForm)}
                            name="priority"
                            disabled={taskMode === "view"}
                            hint="Nivel de prioridad de la tarea."
                        >
                            {PRIORIDADES.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <Input
                            label="Avance %"
                            type="number"
                            min="0"
                            max="100"
                            value={taskForm.progress_percent}
                            onChange={handleChange(setTaskForm)}
                            name="progress_percent"
                            disabled={taskMode === "view" || selectedTaskHasChildren}
                            hint={
                                selectedTaskHasChildren
                                    ? "Esta tarea es padre y su avance se calcula automáticamente con base en sus subtareas."
                                    : "Porcentaje completado de la tarea."
                            }
                        />

                        <Input
                            label="Inicio"
                            type="date"
                            value={taskForm.start_date}
                            onChange={handleChange(setTaskForm)}
                            name="start_date"
                            disabled={taskMode === "view"}
                            hint="Fecha de inicio planeada o real."
                        />

                        <Input
                            label="Compromiso"
                            type="date"
                            value={taskForm.due_date}
                            onChange={handleChange(setTaskForm)}
                            name="due_date"
                            disabled={taskMode === "view"}
                            hint="Fecha compromiso o vencimiento."
                        />

                        <Input
                            label="Fin"
                            type="date"
                            value={taskForm.end_date}
                            onChange={handleChange(setTaskForm)}
                            name="end_date"
                            disabled={taskMode === "view"}
                            hint="Fecha de cierre planeada o real."
                        />

                        <div style={{ gridColumn: "1 / -1", display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 12 }}>
                            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, color: "#ffffff", fontWeight: 800 }}>
                                <input
                                    type="checkbox"
                                    checked={Number(taskForm.requires_review) === 1}
                                    disabled={taskMode === "view"}
                                    onChange={(e) => setTaskForm((prev) => ({ ...prev, requires_review: e.target.checked ? 1 : 0 }))}
                                />
                                Requiere revisión
                            </label>

                            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, color: "#ffffff", fontWeight: 800 }}>
                                <input
                                    type="checkbox"
                                    checked={Number(taskForm.evidence_required) === 1}
                                    disabled={taskMode === "view"}
                                    onChange={(e) => setTaskForm((prev) => ({ ...prev, evidence_required: e.target.checked ? 1 : 0 }))}
                                />
                                Requiere evidencia
                            </label>

                            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, color: "#ffffff", fontWeight: 800 }}>
                                <input
                                    type="checkbox"
                                    checked={Number(taskForm.geo_evidence_required) === 1}
                                    disabled={taskMode === "view"}
                                    onChange={(e) => setTaskForm((prev) => ({ ...prev, geo_evidence_required: e.target.checked ? 1 : 0 }))}
                                />
                                Requiere geoevidencia
                            </label>
                        </div>
                        <label style={{ display: "inline-flex", alignItems: "center", gap: 8, marginRight: 14, color: "#ffffff", fontSize: 14, fontWeight: 800 }}>
                            <input
                                type="checkbox"
                                checked={Number(taskForm.reviewer_evidence_required || 0) === 1}
                                onChange={(e) =>
                                    setTaskForm((prev) => ({
                                        ...prev,
                                        reviewer_evidence_required: e.target.checked ? 1 : 0,
                                    }))
                                }
                                disabled={taskMode === "view"}
                            />
                            Requiere evidencia del revisor
                        </label>

                        <label style={{ display: "inline-flex", alignItems: "center", gap: 8, marginRight: 14, color: "#ffffff", fontSize: 14, fontWeight: 800 }}>
                            <input
                                type="checkbox"
                                checked={Number(taskForm.reviewer_geo_evidence_required || 0) === 1}
                                onChange={(e) =>
                                    setTaskForm((prev) => ({
                                        ...prev,
                                        reviewer_geo_evidence_required: e.target.checked ? 1 : 0,
                                    }))
                                }
                                disabled={taskMode === "view"}
                            />
                            Requiere geoevidencia del revisor
                        </label>
                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea
                                label="Descripción"
                                value={taskForm.description}
                                onChange={handleChange(setTaskForm)}
                                name="description"
                                rows={5}
                                disabled={taskMode === "view"}
                                hint="Detalle de lo que debe realizarse, producirse o controlarse en esta tarea."
                            />
                        </div>
                    </div>
                    {/*//*/}
                    {/*// Registrar avance Bitacora*/}
                    {/*//                    //*/}

                    {taskForm.id && taskMode !== "review" ? (
                        <div
                            ref={progressSectionRef}
                            style={{
                                border: taskMode === "progress" ? "2px solid rgba(37,99,235,.75)" : "1px solid rgba(0,178,255,.24)",
                                borderRadius: 16,
                                padding: 16,
                                background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                                marginBottom: 16,
                                boxShadow: "0 12px 28px rgba(0,0,0,.18)",
                            }}
                        >
                            <h4 style={{ marginTop: 0, marginBottom: 8, color: "#ffffff", fontWeight: 900 }}>
                                Atención operativa de la tarea
                            </h4>

                            <div
                                style={{
                                    fontSize: 13,
                                    color: "#d7efff",
                                    lineHeight: 1.5,
                                    fontWeight: 600,
                                    marginBottom: 12,
                                }}
                            >
                                El avance, la evidencia, la georreferencia y el envío a revisión se registran desde
                                la pantalla operativa de <strong>Mi trabajo</strong>. Esto asegura que la tarea conserve
                                trazabilidad completa y que no se omitan requisitos obligatorios.
                            </div>

                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                                    gap: 12,
                                    marginBottom: 12,
                                }}
                            >
                                <InfoRow label="Avance actual" value={`${taskForm.progress_percent || 0}%`} />
                                <InfoRow label="Estatus" value={getTaskStatusLabel(taskForm.status)} />
                                <InfoRow label="Revisión" value={getTaskReviewStatusLabel(taskForm.review_status)} />                                <InfoRow
                                    label="Responsable"
                                    value={
                                        userOptions.find((u) => String(u.value) === String(taskForm.owner_user_id))?.label ||
                                        "—"
                                    }
                                />
                            </div>

                            <ActionButton
                                onClick={() => {
                                    const mode =
                                        isTaskInReview(taskForm)
                                            ? "review"
                                            : ["con_cambios", "rechazado"].includes(
                                                String(taskForm.review_status || "").toLowerCase()
                                            )
                                                ? "progress"
                                                : "progress";

                                    const returnPath = `/projects/${id}?tab=tasks&task_id=${taskForm.id}&mode=view`;

                                    navigate(
                                        `/my-work/task/${taskForm.id}?mode=${mode}&return_to=${encodeURIComponent(returnPath)}&return_label=${encodeURIComponent("Ficha 360")}`,
                                        {
                                            state: {
                                                openTaskId: taskForm.id,
                                                taskMode: mode,
                                                fromProjectDetail: true,
                                                returnTo: returnPath,
                                                returnLabel: "Ficha 360",
                                            },
                                        }
                                    );
                                }}
                                bg="#2563eb"
                                color="#fff"
                                border="1px solid #2563eb"
                            >
                                Atender avance en Mi trabajo
                            </ActionButton>
                        </div>
                    ) : null}


                    {taskForm.id ? (
                        <div
                            ref={reviewSectionRef}
                            style={{
                                marginTop: 20,
                                borderTop: "1px solid rgba(0,178,255,.24)",
                                paddingTop: 20,

                                // ORBIS: bloque operativo/revisión oscuro y consistente
                                border: taskMode === "review" ? "2px solid rgba(244,185,27,.52)" : "1px solid rgba(0,178,255,.24)",
                                borderRadius: 16,
                                padding: 16,
                                background: "linear-gradient(180deg, rgba(8,47,73,.94), rgba(2,25,48,.98))",
                                boxShadow:
                                    taskMode === "review"
                                        ? "0 0 0 4px rgba(244,185,27,.10)"
                                        : "0 14px 30px rgba(0,0,0,.18)",
                                transition: "all 0.2s ease",
                            }}
                        >
                            {/*// Inicio RBB bloque Tarea en Revision, debajo Historia de bitacora de la Tarea*/}
                            <div
                                style={{
                                    marginBottom: 16,
                                    padding: 16,
                                    borderRadius: 14,
                                    background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                                    border: taskMode === "review" ? "1px solid rgba(244,185,27,.42)" : "1px solid rgba(0,178,255,.24)",
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: 12,
                                        fontWeight: 800,
                                        color: taskMode === "review" ? "#fde68a" : "#7dd3fc",
                                        marginBottom: 6,
                                        letterSpacing: ".08em",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    {taskMode === "review" ? "TAREA EN REVISION" : "TAREA EN ATENCION"}
                                </div>

                                <div style={{ fontSize: 18, fontWeight: 800, color: "#ffffff", marginBottom: 6 }}>
                                    {taskForm.wbs_code || "SIN WBS"} · {taskForm.name || "Sin nombre"}
                                </div>

                                <div style={{ fontSize: 13, color: "#d7efff", marginBottom: 12, lineHeight: 1.5, fontWeight: 600 }}>
                                    {taskForm.description || "Sin descripcion registrada."}
                                </div>

                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
                                        gap: 10,
                                        marginBottom: 14,
                                    }}
                                >
                                    <InfoRow label="Avance" value={`${taskForm.progress_percent || 0}%`} />
                                    <InfoRow label="Responsable" value={taskForm.owner_user_name || "—"} />
                                    <InfoRow label="Estatus" value={getTaskStatusLabel(taskForm.status)} />
                                    <InfoRow label="Revisión" value={getTaskReviewStatusLabel(taskForm.review_status)} />                                </div>

                                {taskMode === "review" ? (
                                    <div
                                        style={{
                                            padding: 12,
                                            borderRadius: 12,
                                            background: "rgba(255,255,255,.045)",
                                            border: "1px solid rgba(125,211,252,.22)",
                                        }}
                                    >
                                        <div style={{ fontSize: 13, fontWeight: 900, color: "#7dd3fc", marginBottom: 6 }}>
                                            Ultimo envio a revision
                                        </div>

                                        {latestReviewSubmissionLog ? (
                                            <>
                                                <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 4 }}>
                                                    {latestReviewSubmissionLog.created_at || "Sin fecha"}
                                                </div>

                                                <div style={{ fontSize: 13, color: "#d7efff", marginBottom: 4 }}>
                                                    {latestReviewSubmissionLog.user_name ||
                                                        latestReviewSubmissionLog.created_by_name ||
                                                        latestReviewSubmissionLog.display_name ||
                                                        "Usuario"}
                                                </div>

                                                <div style={{ fontSize: 14, color: "#ffffff", fontWeight: 600 }}>
                                                    {getLogComment(latestReviewSubmissionLog)}
                                                </div>
                                            </>
                                        ) : (
                                            <div style={{ fontSize: 13, color: "#b9e8ff" }}>
                                                No se encontro un envio reciente en la bitacora.
                                            </div>
                                        )}
                                    </div>
                                ) : null}
                            </div>

                            {canReviewCurrentTask ? (
                                <div
                                    style={{
                                        marginBottom: 16,
                                        padding: 16,
                                        borderRadius: 14,
                                        background: "rgba(244,185,27,.12)",
                                        border: "1px solid rgba(244,185,27,.42)",
                                    }}
                                >
                                    <div style={{ fontWeight: 900, color: "#fde68a", marginBottom: 8 }}>
                                        Decisión de revisión
                                    </div>

                                    <div style={{ fontSize: 13, color: "#fef3c7", marginBottom: 12, fontWeight: 600 }}>
                                        Registra tu decisión sobre el último avance enviado por el responsable.
                                    </div>

                                    <textarea
                                        value={taskReviewForm.comment}
                                        onChange={(e) =>
                                            setTaskReviewForm((prev) => ({
                                                ...prev,
                                                comment: e.target.value,
                                            }))
                                        }
                                        rows={3}
                                        placeholder="Comentario de revisión (opcional)"
                                        style={{
                                            width: "100%",
                                            borderRadius: 10,
                                            border: "1px solid rgba(125,211,252,.35)",
                                            padding: 10,
                                            fontSize: 13,
                                            marginBottom: 10,
                                            boxSizing: "border-box",
                                            background: "#ffffff",
                                            color: "#111827",
                                            WebkitTextFillColor: "#111827",
                                        }}
                                    />

                                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                        <ActionButton
                                            onClick={() => reviewTaskProgress(null, "aprobar")}
                                            disabled={reviewingTask}
                                            bg="#16a34a"
                                            color="#fff"
                                            border="1px solid #16a34a"
                                        >
                                            Aprobar
                                        </ActionButton>

                                        <ActionButton
                                            onClick={() => reviewTaskProgress(null, "rechazar")}
                                            disabled={reviewingTask}
                                            bg="transparent"
                                            color="#ffb4b4"
                                            border="1px solid rgba(239,68,68,.70)"
                                        >
                                            Rechazar
                                        </ActionButton>

                                        <ActionButton
                                            onClick={() => reviewTaskProgress(null, "solicitar_cambios")}
                                            disabled={reviewingTask}
                                            bg="transparent"
                                            color="#fde68a"
                                            border="1px solid rgba(244,185,27,.65)"
                                        >
                                            Solicitar cambios
                                        </ActionButton>
                                    </div>
                                </div>
                            ) : null}

                            {/*// Fin RBB bloque Tarea en Revision, debajo Historia de bitacora de la Tarea*/}

                            {/*// RBB inicio bloque bitacora de la tarea*/}
                            {/*// inicio bloque ciclos compactos y bitacora de la tarea*/}
                            <h4
                                style={{
                                    marginTop: 0,
                                    marginBottom: 14,
                                    fontSize: 16,
                                    color: taskMode === "review" ? "#fde68a" : "#ffffff",
                                }}
                            >
                                Ciclos recientes de revisión
                            </h4>

                            {loadingTaskLogs ? (
                                <div style={{ color: "#b9e8ff" }}>Cargando bitácora...</div>
                            ) : taskLogs.length === 0 ? (
                                <div style={{ color: "#b9e8ff" }}>No hay movimientos registrados.</div>
                            ) : (
                                <>
                                    {compactReviewCycles.length === 0 ? (
                                        <div
                                            style={{
                                                padding: 14,
                                                borderRadius: 14,
                                                background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                                                border: "1px solid rgba(125,211,252,.18)",
                                                color: "#b9e8ff",
                                                fontSize: 13,
                                                marginBottom: 16,
                                            }}
                                        >
                                            Esta tarea todavía no tiene ciclos de revisión registrados.
                                        </div>
                                    ) : (
                                        <div style={{ display: "grid", gap: 10, marginBottom: 18 }}>
                                            {compactReviewCycles.slice(0, 5).map((cycle, index) => {
                                                const result = getCompactCycleResult(cycle);
                                                const progress = getCompactCycleProgress(cycle);

                                                const reviewLog = cycle.reviewLog;
                                                const sentLog = cycle.sentLog;

                                                const isFinal =
                                                    result.label === "Aprobado final" ||
                                                    String(reviewLog?.new_status || "").toLowerCase() === "terminada" ||
                                                    Number(reviewLog?.new_progress_percent || 0) >= 100;

                                                const responsibleEvidence = hasEvidenceItems(sentLog);
                                                const responsibleGeo = hasGeoEvidence(sentLog);
                                                const reviewerEvidence = hasEvidenceItems(reviewLog);
                                                const reviewerGeo = hasGeoEvidence(reviewLog);

                                                return (
                                                    <div
                                                        key={cycle.id || index}
                                                        style={{
                                                            border: `1px solid ${result.border}`,
                                                            borderRadius: 14,
                                                            background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                                                            overflow: "hidden",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                padding: 12,
                                                                background: result.tone === "red" ? "rgba(239,68,68,.14)" : result.tone === "green" ? "rgba(16,185,129,.14)" : "rgba(244,185,27,.12)",
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "flex-start",
                                                                gap: 10,
                                                                flexWrap: "wrap",
                                                            }}
                                                        >
                                                            <div>
                                                                <div
                                                                    style={{
                                                                        fontSize: 14,
                                                                        fontWeight: 900,
                                                                        color: "#ffffff",
                                                                    }}
                                                                >
                                                                    {isFinal
                                                                        ? `Cierre de tarea · 100%`
                                                                        : `Avance ${progress}%`}
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        fontSize: 12,
                                                                        color: "#b9e8ff",
                                                                        marginTop: 3,
                                                                    }}
                                                                >
                                                                    {formatHumanDateTime(sentLog?.created_at)} ·{" "}
                                                                    {sentLog?.user_name || "Responsable"}
                                                                </div>
                                                            </div>

                                                            <span
                                                                style={{
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    padding: "6px 11px",
                                                                    borderRadius: 999,
                                                                    background: result.label === "Aprobado final" || result.label === "Aprobado parcial"
                                                                        ? "rgba(16,185,129,.16)"
                                                                        : result.label === "Rechazado"
                                                                            ? "rgba(239,68,68,.16)"
                                                                            : "rgba(244,185,27,.18)",
                                                                    color: result.label === "Aprobado final" || result.label === "Aprobado parcial"
                                                                        ? "#bbf7d0"
                                                                        : result.label === "Rechazado"
                                                                            ? "#fecaca"
                                                                            : "#fde68a",
                                                                    border: result.label === "Aprobado final" || result.label === "Aprobado parcial"
                                                                        ? "1px solid rgba(16,185,129,.38)"
                                                                        : result.label === "Rechazado"
                                                                            ? "1px solid rgba(239,68,68,.42)"
                                                                            : "1px solid rgba(244,185,27,.42)",
                                                                    fontSize: 12,
                                                                    fontWeight: 900,
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {result.label}
                                                            </span>
                                                        </div>

                                                        <div
                                                            style={{
                                                                padding: 12,
                                                                display: "flex",
                                                                gap: 8,
                                                                flexWrap: "wrap",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            <Badge
                                                                bg={responsibleEvidence ? "#ecfdf5" : "#f3f4f6"}
                                                                color={responsibleEvidence ? "#166534" : "#6b7280"}
                                                            >
                                                                Responsable {responsibleEvidence ? "con evidencia" : "sin evidencia"}
                                                            </Badge>

                                                            <Badge
                                                                bg={responsibleGeo ? "#ecfdf5" : "#f3f4f6"}
                                                                color={responsibleGeo ? "#166534" : "#6b7280"}
                                                            >
                                                                Geo responsable {responsibleGeo ? "OK" : "—"}
                                                            </Badge>

                                                            <Badge
                                                                bg={reviewerEvidence ? "#ecfdf5" : "#f3f4f6"}
                                                                color={reviewerEvidence ? "#166534" : "#6b7280"}
                                                            >
                                                                Revisor {reviewerEvidence ? "con evidencia" : "sin evidencia"}
                                                            </Badge>

                                                            <Badge
                                                                bg={reviewerGeo ? "#ecfdf5" : "#f3f4f6"}
                                                                color={reviewerGeo ? "#166534" : "#6b7280"}
                                                            >
                                                                Geo revisor {reviewerGeo ? "OK" : "—"}
                                                            </Badge>
                                                        </div>

                                                        {sentLog?.comment || reviewLog?.comment ? (
                                                            <div
                                                                style={{
                                                                    padding: "0 12px 12px",
                                                                    fontSize: 12,
                                                                    color: "#d7efff",
                                                                    lineHeight: 1.5,
                                                                }}
                                                            >
                                                                {sentLog?.comment ? (
                                                                    <div>
                                                                        <strong>Avance:</strong> {sentLog.comment}
                                                                    </div>
                                                                ) : null}

                                                                {reviewLog?.comment ? (
                                                                    <div style={{ marginTop: sentLog?.comment ? 4 : 0 }}>
                                                                        <strong>Revisión:</strong> {reviewLog.comment}
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}

                                    <details>
                                        <summary
                                            style={{
                                                cursor: "pointer",
                                                fontSize: 13,
                                                fontWeight: 900,
                                                color: "#d7efff",
                                                marginBottom: 12,
                                            }}
                                        >
                                            Ver bitácora técnica completa
                                        </summary>

                                        <div style={{ marginTop: 14 }}>
                                            {groupedTaskLogs.map((group) => (
                                                <div key={group.label} style={{ marginBottom: 22 }}>
                                                    <div
                                                        style={{
                                                            position: "sticky",
                                                            top: 0,
                                                            zIndex: 1,
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            padding: "6px 10px",
                                                            borderRadius: 999,
                                                            background: "rgba(14,165,233,.14)",
                                                            color: "#7dd3fc",
                                                            border: "1px solid rgba(125,211,252,.24)",
                                                            fontSize: 12,
                                                            fontWeight: 900,
                                                            marginBottom: 12,
                                                        }}
                                                    >
                                                        {group.label}
                                                    </div>

                                                    <div style={{ position: "relative", paddingLeft: 24 }}>
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                left: 8,
                                                                top: 0,
                                                                bottom: 0,
                                                                width: 2,
                                                                background: "#e5e7eb",
                                                            }}
                                                        />

                                                        {group.items.map((log) => {
                                                            const dotColor = getLogDotColor(log);
                                                            const logTitle = getLogTitle(log);
                                                            const logSummary = getLogSummary(log);
                                                            const logComment = getLogComment(log);

                                                            const isReview =
                                                                log.review_status === "pendiente_revision" &&
                                                                (taskMode === "edit" || taskMode === "review");

                                                            return (
                                                                <div
                                                                    key={log.id}
                                                                    style={{
                                                                        position: "relative",
                                                                        marginBottom: 20,
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            position: "absolute",
                                                                            left: -4,
                                                                            top: 6,
                                                                            width: 12,
                                                                            height: 12,
                                                                            borderRadius: "50%",
                                                                            background: dotColor,
                                                                            border: "2px solid rgba(2,25,48,1)",
                                                                        }}
                                                                    />

                                                                    <div
                                                                        style={{
                                                                            border: "1px solid rgba(125,211,252,.18)",
                                                                            borderRadius: 14,
                                                                            padding: 14,
                                                                            background: "linear-gradient(180deg, rgba(8,47,73,.92), rgba(2,25,48,.96))",
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                display: "flex",
                                                                                justifyContent: "space-between",
                                                                                alignItems: "center",
                                                                                marginBottom: 8,
                                                                                flexWrap: "wrap",
                                                                                gap: 8,
                                                                            }}
                                                                        >
                                                                            <div style={{ fontWeight: 700, color: "#ffffff" }}>
                                                                                {logTitle}
                                                                            </div>

                                                                            <div style={{ fontSize: 12, color: "#7dd3fc", fontWeight: 800 }}>
                                                                                {formatHumanDateTime(log.created_at)}
                                                                            </div>
                                                                        </div>

                                                                        <div style={{ fontSize: 12, color: "#b9e8ff", fontWeight: 800 }}>
                                                                            <strong>{log.user_name || log.reviewed_by_user_name || "Sistema"}</strong>
                                                                        </div>

                                                                        {logSummary ? (
                                                                            <div
                                                                                style={{
                                                                                    fontSize: 12,
                                                                                    color: "#b9e8ff",
                                                                                    marginBottom: 8,
                                                                                }}
                                                                            >
                                                                                {logSummary}
                                                                            </div>
                                                                        ) : null}

                                                                        <div
                                                                            style={{
                                                                                fontSize: 13,
                                                                                color: "#d7efff",
                                                                                background: "rgba(255,255,255,.045)",
                                                                                padding: 10,
                                                                                borderRadius: 10,
                                                                                marginBottom: isReview ? 10 : 0,
                                                                            }}
                                                                        >
                                                                            {logComment}
                                                                        </div>

                                                                        <CompactTaskEvidenceList items={log.evidence_items} />
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </details>
                                </>
                            )}
                            {/*// fin bloque ciclos compactos y bitacora de la tarea*/}
                            {/*// RBB fin bloque bitacora de la tarea*/}

                        </div>
                    ) : null}


                    <div
                        className="orbis-task-modal-footer"
                        style={{
                            position: "sticky",
                            bottom: 0,
                            zIndex: 50,
                            marginTop: 20,
                            marginLeft: -22,
                            marginRight: -22,
                            marginBottom: -22,
                            padding: "14px 22px",
                            background: "#041c2c",
                            backgroundImage: "linear-gradient(180deg, rgba(8,47,73,.98), rgba(2,25,48,1))",
                            borderTop: "1px solid rgba(0,178,255,.35)",
                            display: "flex",
                            gap: 10,
                            flexWrap: "wrap",
                            justifyContent: "flex-end",
                            boxShadow: "0 -14px 30px rgba(0,0,0,.28)",
                        }}
                    >
                        <ActionButton
                            onClick={handleCloseTaskModal}
                            bg="#fff"
                            color="#06111f"
                            border="1px solid #dbeafe"
                        >
                            Cerrar
                        </ActionButton>

                        {taskForm.id && !cameFromMyTaskDetail ? (
                            <ActionButton
                                onClick={() => {
                                    const mode =
                                        isTaskInReview(taskForm)
                                            ? "review"
                                            : ["con_cambios", "rechazado"].includes(
                                                String(taskForm.review_status || "").toLowerCase()
                                            )
                                                ? "progress"
                                                : "view";

                                    const returnPath = `/projects/${id}?tab=tasks&task_id=${taskForm.id}&mode=view`;

                                    navigate(
                                        `/my-work/task/${taskForm.id}?mode=${mode}&return_to=${encodeURIComponent(returnPath)}&return_label=${encodeURIComponent("Ficha 360")}`,
                                        {
                                            state: {
                                                openTaskId: taskForm.id,
                                                taskMode: mode,
                                                fromProjectDetail: true,
                                                returnTo: returnPath,
                                                returnLabel: "Ficha 360",
                                            },
                                        }
                                    );
                                }}
                                bg="#06111f"
                                color="#fff"
                                border="1px solid rgba(125,211,252,.35)"
                            >
                                Atender en Mi trabajo
                            </ActionButton>
                        ) : null}
                        {taskMode === "edit" ? (
                            <>
                                {taskForm.id ? (
                                    <ActionButton
                                        onClick={() =>
                                            deleteItem("project_tasks.php", taskForm.id, "tarea", handleCloseTaskModal)
                                        }
                                        bg="transparent"
                                        color="#ffb4b4"
                                        border="1px solid rgba(239,68,68,.70)"
                                    >
                                        Eliminar
                                    </ActionButton>
                                ) : null}

                                <ActionButton onClick={saveTask} disabled={savingTask}>
                                    {savingTask ? "Guardando..." : "Guardar tarea"}
                                </ActionButton>
                            </>
                        ) : null}
                    </div>                </ModalShell>
                {/*//*/}
                {/*//              aqui termina task modal RBB*/}
                {/*//                //*/}


                <ModalShell
                    open={showMilestoneModal}
                    title={milestoneForm.id ? "Editar milestone" : "Nuevo milestone"}
                    onClose={() => setShowMilestoneModal(false)}
                    width={960}
                >
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 16 }}>
                        <Input label="Título del hito" name="title" value={milestoneForm.title} onChange={handleChange(setMilestoneForm)} placeholder="Ej. Permisos técnicos liberados" />

                        <Select label="Tipo de milestone" name="milestone_type" value={milestoneForm.milestone_type} onChange={handleChange(setMilestoneForm)}>
                            <option value="control">Control</option>
                            <option value="decision">Decisión</option>
                            <option value="entrega">Entrega</option>
                            <option value="validacion">Validación</option>
                            <option value="fase">Fase</option>
                            <option value="cierre">Cierre</option>
                        </Select>

                        <Select label="Estatus" name="status" value={milestoneForm.status} onChange={handleChange(setMilestoneForm)}>
                            <option value="pendiente">Pendiente</option>
                            <option value="en_proceso">En proceso</option>
                            <option value="en_riesgo">En riesgo</option>
                            <option value="cumplido">Cumplido</option>
                            <option value="retrasado">Retrasado</option>
                            <option value="cancelado">Cancelado</option>
                        </Select>

                        <Select label="Salud" name="health_status" value={milestoneForm.health_status} onChange={handleChange(setMilestoneForm)}>
                            <option value="verde">Verde</option>
                            <option value="amarillo">Amarillo</option>
                            <option value="rojo">Rojo</option>
                        </Select>

                        <Input label="Fecha objetivo" type="date" name="target_date" value={milestoneForm.target_date} onChange={handleChange(setMilestoneForm)} />
                        <Input label="Fecha real" type="date" name="actual_date" value={milestoneForm.actual_date} onChange={handleChange(setMilestoneForm)} />

                        <Select label="Responsable" name="owner_user_id" value={milestoneForm.owner_user_id} onChange={handleChange(setMilestoneForm)}>
                            <option value="">Sin responsable</option>
                            {usersCatalog.map((u) => (
                                <option key={u.id} value={u.id}>{u.display_name || u.name || u.email}</option>
                            ))}
                        </Select>

                        <Select label="Tarea WBS vinculada" name="related_task_id" value={milestoneForm.related_task_id} onChange={handleChange(setMilestoneForm)}>
                            <option value="">Sin tarea vinculada</option>
                            {tasks.map((t) => (
                                <option key={t.id} value={t.id}>{t.wbs_code ? `${t.wbs_code} · ` : ""}{t.name}</option>
                            ))}
                        </Select>

                        <Select label="Entregable vinculado" name="related_deliverable_id" value={milestoneForm.related_deliverable_id} onChange={handleChange(setMilestoneForm)}>
                            <option value="">Sin entregable vinculado</option>
                            {deliverables.map((d) => (
                                <option key={d.id} value={d.id}>{d.name}</option>
                            ))}
                        </Select>

                        <div style={{ marginBottom: 14 }}>
                            <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 6 }}>Decision gate</div>
                            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#ffffff", fontWeight: 700 }}>
                                <input type="checkbox" checked={Number(milestoneForm.decision_gate || 0) === 1} onChange={(e) => setMilestoneForm((prev) => ({ ...prev, decision_gate: e.target.checked ? 1 : 0 }))} />
                                Este hito requiere decisión ejecutiva para avanzar
                            </label>
                        </div>
                    </div>

                    <TextArea label="Descripción" name="description" value={milestoneForm.description} onChange={handleChange(setMilestoneForm)} rows={3} placeholder="Describe qué debe ocurrir para considerar este hito relevante." />
                    <TextArea label="Impacto ejecutivo" name="executive_impact" value={milestoneForm.executive_impact} onChange={handleChange(setMilestoneForm)} rows={3} placeholder="Explica qué pasa si este hito no se cumple." />
                    <TextArea label="Criterio de cumplimiento" name="success_criteria" value={milestoneForm.success_criteria} onChange={handleChange(setMilestoneForm)} rows={3} placeholder="Define cómo sabremos que el hito fue cumplido." />
                    <TextArea label="Notas" name="notes" value={milestoneForm.notes} onChange={handleChange(setMilestoneForm)} rows={3} />

                    <div style={{ marginTop: 12, display: "flex", justifyContent: "flex-end", gap: 8 }}>
                        <ActionButton bg="#fff" color="#111827" border="1px solid #d1d5db" onClick={() => setShowMilestoneModal(false)} disabled={savingMilestone}>Cancelar</ActionButton>
                        <ActionButton onClick={saveMilestone} disabled={savingMilestone}>{savingMilestone ? "Guardando..." : "Guardar milestone"}</ActionButton>
                    </div>
                </ModalShell>

                <ModalShell open={showRiskModal} title={riskMode === "view" ? "Detalle del riesgo" : (riskForm.id ? "Editar riesgo" : "Nuevo riesgo")} onClose={() => setShowRiskModal(false)} width={950}>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16 }}>
                        <Input
                            label="Riesgo"
                            value={riskForm.risk_title}
                            onChange={handleChange(setRiskForm)}
                            name="risk_title"
                            disabled={riskMode === "view"}
                            hint="Nombre breve del evento incierto que puede afectar el proyecto."
                        />

                        <Select
                            label="Responsable"
                            value={riskForm.owner_user_id}
                            onChange={handleChange(setRiskForm)}
                            name="owner_user_id"
                            disabled={riskMode === "view"}
                            hint="Usuario responsable de monitorear y tratar el riesgo."
                        >
                            <option value="">Seleccionar</option>
                            {userOptions.map((u) => <option key={u.value} value={u.value}>{u.label}</option>)}
                        </Select>

                        <Select
                            label="Probabilidad"
                            value={riskForm.probability}
                            onChange={handleChange(setRiskForm)}
                            name="probability"
                            disabled={riskMode === "view"}
                            hint="Posibilidad estimada de que el riesgo ocurra."
                        >
                            {PROBABILIDAD_RIESGO.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <Select
                            label="Impacto"
                            value={riskForm.impact}
                            onChange={handleChange(setRiskForm)}
                            name="impact"
                            disabled={riskMode === "view"}
                            hint="Grado de afectación potencial si el riesgo ocurre."
                        >
                            {IMPACTO_RIESGO.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <Select
                            label="Estatus"
                            value={riskForm.status}
                            onChange={handleChange(setRiskForm)}
                            name="status"
                            disabled={riskMode === "view"}
                            hint="Situación actual del riesgo en el proceso de gestión."
                        >
                            {ESTATUS_RIESGO.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <Select
                            label="Estrategia de respuesta"
                            value={riskForm.response_strategy}
                            onChange={handleChange(setRiskForm)}
                            name="response_strategy"
                            disabled={riskMode === "view"}
                            hint="Acción principal definida para tratar el riesgo."
                        >
                            <option value="">Seleccionar</option>
                            {ESTRATEGIAS_RIESGO.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea
                                label="Descripción"
                                value={riskForm.description}
                                onChange={handleChange(setRiskForm)}
                                name="description"
                                rows={5}
                                disabled={riskMode === "view"}
                                hint="Describe la causa, condición o consecuencia esperada del riesgo."
                            />
                        </div>
                    </div>

                    <div style={{ marginTop: 10 }}>
                        <ActionButton onClick={() => setShowRiskModal(false)} bg="#fff" color="#111827" border="1px solid #d1d5db">
                            Cerrar
                        </ActionButton>

                        {riskMode === "edit" ? (
                            <>
                                {riskForm.id ? (
                                    <ActionButton
                                        onClick={() => deleteItem("project_risks.php", riskForm.id, "riesgo", () => setShowRiskModal(false))}
                                        bg="transparent"
                                        color="#ffb4b4"
                                        border="1px solid rgba(239,68,68,.70)"
                                    >
                                        Eliminar
                                    </ActionButton>
                                ) : null}
                                <ActionButton onClick={saveRisk} disabled={savingRisk}>
                                    {savingRisk ? "Guardando..." : "Guardar riesgo"}
                                </ActionButton>
                            </>
                        ) : null}
                    </div>
                </ModalShell>

                <ModalShell open={showDeliverableModal} title={deliverableMode === "view" ? "Detalle del entregable" : (deliverableForm.id ? "Editar entregable" : "Nuevo entregable")} onClose={() => setShowDeliverableModal(false)} width={950}>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16 }}>
                        <Input
                            label="Nombre"
                            value={deliverableForm.name}
                            onChange={handleChange(setDeliverableForm)}
                            name="name"
                            disabled={deliverableMode === "view"}
                            hint="Nombre del entregable o resultado esperado."
                        />

                        <Select
                            label="Tipo"
                            value={deliverableForm.deliverable_type}
                            onChange={handleChange(setDeliverableForm)}
                            name="deliverable_type"
                            disabled={deliverableMode === "view"}
                            hint="Clasificación del tipo de entregable."
                        >
                            {TIPOS_ENTREGABLE.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <Input
                            label="Fecha planeada"
                            type="date"
                            value={deliverableForm.planned_date}
                            onChange={handleChange(setDeliverableForm)}
                            name="planned_date"
                            disabled={deliverableMode === "view"}
                            hint="Fecha comprometida de entrega."
                        />

                        <Input
                            label="Fecha real"
                            type="date"
                            value={deliverableForm.actual_date}
                            onChange={handleChange(setDeliverableForm)}
                            name="actual_date"
                            disabled={deliverableMode === "view"}
                            hint="Fecha real de liberación o entrega."
                        />

                        <Select
                            label="Responsable"
                            value={deliverableForm.owner_user_id}
                            onChange={handleChange(setDeliverableForm)}
                            name="owner_user_id"
                            disabled={deliverableMode === "view"}
                            hint="Usuario responsable del entregable."
                        >
                            <option value="">Seleccionar</option>
                            {userOptions.map((u) => <option key={u.value} value={u.value}>{u.label}</option>)}
                        </Select>

                        <Select
                            label="Estatus"
                            value={deliverableForm.status}
                            onChange={handleChange(setDeliverableForm)}
                            name="status"
                            disabled={deliverableMode === "view"}
                            hint="Estado actual del entregable dentro del flujo de aprobación."
                        >
                            {ESTATUS_ENTREGABLE.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
                        </Select>

                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea
                                label="Descripción"
                                value={deliverableForm.description}
                                onChange={handleChange(setDeliverableForm)}
                                name="description"
                                rows={5}
                                disabled={deliverableMode === "view"}
                                hint="Detalle del contenido, alcance o criterio de aceptación del entregable."
                            />
                        </div>
                    </div>

                    <div style={{ marginTop: 10 }}>
                        <ActionButton onClick={() => setShowDeliverableModal(false)} bg="#fff" color="#111827" border="1px solid #d1d5db">
                            Cerrar
                        </ActionButton>

                        {deliverableMode === "edit" ? (
                            <>
                                {deliverableForm.id ? (
                                    <ActionButton
                                        onClick={() => deleteItem("project_deliverables.php", deliverableForm.id, "entregable", () => setShowDeliverableModal(false))}
                                        bg="transparent"
                                        color="#ffb4b4"
                                        border="1px solid rgba(239,68,68,.70)"
                                    >
                                        Eliminar
                                    </ActionButton>
                                ) : null}
                                <ActionButton onClick={saveDeliverable} disabled={savingDeliverable}>
                                    {savingDeliverable ? "Guardando..." : "Guardar entregable"}
                                </ActionButton>
                            </>
                        ) : null}
                    </div>
                </ModalShell>

                <ModalShell open={showDocumentModal} title={documentMode === "view" ? "Detalle del documento" : (documentForm.id ? "Editar documento" : "Subir documento")} onClose={() => setShowDocumentModal(false)} width={980}>
                    <div
                        style={{
                            background: "#8b5cf6",
                            color: "#ffffff",
                            padding: 12,
                            borderRadius: 10,
                            border: "1px solid rgba(0,178,255,.24)",
                            marginBottom: 16,
                            fontSize: 13,
                        }}
                    >
                        Carga documentos, imágenes o evidencias del proyecto. El tipo se detecta al seleccionar el archivo y ya no necesitas capturar rutas o URLs manuales.
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16 }}>
                        <Select
                            label="Sección PMO"
                            hint="Ubica el documento dentro del proyecto."
                            value={documentForm.section_type}
                            onChange={(e) => setDocumentForm((prev) => ({ ...prev, section_type: e.target.value, section_id: "" }))}
                            name="section_type"
                            disabled={documentMode === "view"}
                        >
                            {DOCUMENT_SECTION_OPTIONS.map((opt) => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                        </Select>

                        <Select
                            label="Registro relacionado"
                            hint="Solo aplica cuando la sección tiene elementos específicos."
                            value={documentForm.section_id}
                            onChange={handleChange(setDocumentForm)}
                            name="section_id"
                            disabled={documentMode === "view" || !documentSectionOptions[documentForm.section_type]?.length}
                        >
                            <option value="">General de la sección</option>
                            {(documentSectionOptions[documentForm.section_type] || []).map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </Select>

                        <Select
                            label="Categoría"
                            hint="Clasifica el archivo para la matriz documental."
                            value={documentForm.document_category}
                            onChange={handleChange(setDocumentForm)}
                            name="document_category"
                            disabled={documentMode === "view"}
                        >
                            {DOCUMENT_CATEGORY_OPTIONS.map((item) => <option key={item} value={item}>{item}</option>)}
                        </Select>

                        <Select
                            label="Subido por"
                            value={documentForm.uploaded_by_user_id}
                            onChange={handleChange(setDocumentForm)}
                            name="uploaded_by_user_id"
                            disabled={documentMode === "view"}
                            hint="Usuario que registra el documento."
                        >
                            <option value="">Seleccionar</option>
                            {userOptions.map((u) => <option key={u.value} value={u.value}>{u.label}</option>)}
                        </Select>

                        <Input
                            label="Título"
                            value={documentForm.title}
                            onChange={handleChange(setDocumentForm)}
                            name="title"
                            disabled={documentMode === "view"}
                            hint="Nombre visible del documento."
                        />

                        <Input
                            label="Tipo de archivo"
                            value={documentForm.file_type}
                            onChange={handleChange(setDocumentForm)}
                            name="file_type"
                            disabled={true}
                            hint="Se detecta automáticamente cuando seleccionas el archivo."
                        />

                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea
                                label="Descripción"
                                value={documentForm.description}
                                onChange={handleChange(setDocumentForm)}
                                name="description"
                                disabled={documentMode === "view"}
                                hint="Breve contexto del documento, imagen o evidencia."
                                rows={3}
                            />
                        </div>

                        <div style={{ gridColumn: "1 / -1" }}>
                            {documentMode === "view" ? (
                                <>
                                    <Input
                                        label="Archivo"
                                        value={documentForm.file_name || documentForm.file_path || ""}
                                        onChange={() => { }}
                                        disabled={true}
                                        hint="Archivo actual del documento."
                                    />
                                    {(documentForm.file_url || documentForm.file_path) ? (
                                        <a href={documentForm.file_url || documentForm.file_path} target="_blank" rel="noreferrer" style={{ color: "#2563eb", fontWeight: 700 }}>
                                            Abrir archivo actual
                                        </a>
                                    ) : null}
                                </>
                            ) : (
                                <div style={{ marginBottom: 14 }}>
                                    <div style={{ fontSize: 12, color: "#b9e8ff", marginBottom: 6 }}>Archivo o imagen</div>
                                    {!documentForm.id ? (
                                        <>
                                            <input
                                                type="file"
                                                accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,image/jpeg,image/png,image/webp"
                                                onChange={(e) => {
                                                    const file = e.target.files?.[0] || null;
                                                    setDocumentUploadFile(file);
                                                    if (file) {
                                                        setDocumentForm((prev) => ({
                                                            ...prev,
                                                            title: prev.title || file.name,
                                                            file_name: file.name,
                                                            file_type: file.type || prev.file_type,
                                                            document_category: file.type?.startsWith("image/") ? "imagen" : prev.document_category,
                                                        }));
                                                    }
                                                }}
                                                style={{ width: "100%" }}
                                            />
                                            <div style={{ fontSize: 11, color: "#b9e8ff", marginTop: 5 }}>
                                                PDF, Word, Excel, PowerPoint, JPG, PNG o WEBP.
                                            </div>
                                            {documentUploadFile ? (
                                                <div style={{ fontSize: 12, color: "#ffffff", marginTop: 6 }}>
                                                    Archivo seleccionado: <strong>{documentUploadFile.name}</strong>
                                                </div>
                                            ) : null}
                                        </>
                                    ) : (
                                        <>
                                            <Input
                                                label="Archivo actual"
                                                value={documentForm.file_name || documentForm.file_path || ""}
                                                onChange={() => { }}
                                                disabled={true}
                                                hint="En edición conservas el archivo actual. Si quieres reemplazo físico, lo hacemos en la siguiente iteración."
                                            />
                                            {(documentForm.file_url || documentForm.file_path) ? (
                                                <a href={documentForm.file_url || documentForm.file_path} target="_blank" rel="noreferrer" style={{ color: "#2563eb", fontWeight: 700 }}>
                                                    Abrir archivo actual
                                                </a>
                                            ) : null}
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    <div style={{ marginTop: 10 }}>
                        <ActionButton onClick={() => setShowDocumentModal(false)} bg="#fff" color="#111827" border="1px solid #d1d5db">
                            Cerrar
                        </ActionButton>

                        {documentMode === "edit" ? (
                            <>
                                {documentForm.id ? (
                                    <ActionButton
                                        onClick={() => deleteItem("project_documents.php", documentForm.id, "documento", () => setShowDocumentModal(false))}
                                        bg="transparent"
                                        color="#ffb4b4"
                                        border="1px solid rgba(239,68,68,.70)"
                                    >
                                        Eliminar
                                    </ActionButton>
                                ) : null}

                                <ActionButton onClick={saveDocument} disabled={savingDocument}>
                                    {savingDocument ? "Guardando..." : "Guardar documento"}
                                </ActionButton>
                            </>
                        ) : null}
                    </div>
                </ModalShell>

                <ModalShell open={showAreaModal} title="Área del proyecto" onClose={() => setShowAreaModal(false)} width={980}>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 16 }}>
                        <Input label="Nombre del área" hint="Ejemplo: TI, Legal, Operaciones, Finanzas." name="name" value={areaForm.name} onChange={handleChange(setAreaForm)} disabled={areaMode === "view"} />
                        <Select label="Nivel" hint="Nivel organizacional del área dentro del proyecto." value={areaForm.level} onChange={handleChange(setAreaForm)} name="level" disabled={areaMode === "view"}>
                            {AREA_LEVELS.map((item) => <option key={item} value={item}>{item}</option>)}
                        </Select>
                        <Select label="Área padre" hint="Opcional. Sirve para subáreas." value={areaForm.parent_area_id} onChange={handleChange(setAreaForm)} name="parent_area_id" disabled={areaMode === "view"}>
                            <option value="">Sin área padre</option>
                            {areas.filter((a) => String(a.id) !== String(areaForm.id || "")).map((a) => (
                                <option key={a.id} value={a.id}>{a.name}</option>
                            ))}
                        </Select>
                        <Select label="Responsable" hint="Usuario dueño del área." value={areaForm.owner_user_id} onChange={handleChange(setAreaForm)} name="owner_user_id" disabled={areaMode === "view"}>
                            <option value="">Selecciona un responsable</option>
                            {userOptions.map((u) => <option key={u.value} value={u.value}>{u.label}</option>)}
                        </Select>
                        <Select label="Prioridad" value={areaForm.priority} onChange={handleChange(setAreaForm)} name="priority" disabled={areaMode === "view"}>
                            {AREA_PRIORITIES.map((item) => <option key={item} value={item}>{item}</option>)}
                        </Select>
                        <Select label="Salud" value={areaForm.health_status} onChange={handleChange(setAreaForm)} name="health_status" disabled={areaMode === "view"}>
                            {SALUD_PROYECTO.map((item) => <option key={item} value={item}>{item}</option>)}
                        </Select>
                        <Input label="Avance %" hint="Porcentaje de avance global del área." type="number" min="0" max="100" name="progress_percent" value={areaForm.progress_percent} onChange={handleChange(setAreaForm)} disabled={areaMode === "view"} />
                        <div />
                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea label="Descripción" hint="Alcance o propósito del área." name="description" value={areaForm.description} onChange={handleChange(setAreaForm)} disabled={areaMode === "view"} rows={4} />
                        </div>
                        <div style={{ gridColumn: "1 / -1" }}>
                            <TextArea label="Notas" hint="Observaciones, temas críticos o próximos pasos del área." name="notes" value={areaForm.notes} onChange={handleChange(setAreaForm)} disabled={areaMode === "view"} rows={4} />
                        </div>
                    </div>

                    <div style={{ marginTop: 12 }}>
                        {areaMode !== "view" ? (
                            <ActionButton onClick={saveArea} disabled={savingArea}>
                                {savingArea ? "Guardando..." : "Guardar área"}
                            </ActionButton>
                        ) : null}
                        {areaForm.id ? (
                            <ActionButton
                                onClick={() => deleteItem("project_areas.php", areaForm.id, "el área", () => setShowAreaModal(false))}
                                bg="transparent"
                                color="#ffb4b4"
                                border="1px solid rgba(239,68,68,.70)"
                            >
                                Eliminar área
                            </ActionButton>
                        ) : null}
                    </div>
                </ModalShell>

                <ModalShell open={showScopeModal} title="Editar alcance del proyecto" onClose={() => setShowScopeModal(false)} width={1100}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 16 }}>
                        <Select
                            label="Creado por"
                            value={scopeForm.created_by_user_id}
                            onChange={handleChange(setScopeForm)}
                            name="created_by_user_id"
                            hint="Usuario que registra o edita este alcance."
                        >
                            <option value="">Seleccionar</option>
                            {userOptions.map((u) => <option key={u.value} value={u.value}>{u.label}</option>)}
                        </Select>

                        <TextArea
                            label="Objetivo del proyecto"
                            value={scopeForm.project_objective}
                            onChange={handleChange(setScopeForm)}
                            name="project_objective"
                            rows={4}
                            hint="Resultado principal que el proyecto busca lograr."
                        />

                        <TextArea
                            label="Alcance del producto"
                            value={scopeForm.product_scope}
                            onChange={handleChange(setScopeForm)}
                            name="product_scope"
                            rows={5}
                            hint="Define qué incluye funcionalmente el producto, servicio o resultado."
                        />

                        <TextArea
                            label="Entregables"
                            value={scopeForm.deliverables}
                            onChange={handleChange(setScopeForm)}
                            name="deliverables"
                            rows={5}
                            hint="Lista de productos, resultados o componentes a entregar."
                        />

                        <TextArea
                            label="Criterios de aceptación"
                            value={scopeForm.acceptance_criteria}
                            onChange={handleChange(setScopeForm)}
                            name="acceptance_criteria"
                            rows={5}
                            hint="Condiciones que deben cumplirse para aprobar el alcance o entregable."
                        />

                        <TextArea
                            label="Exclusiones"
                            value={scopeForm.exclusions}
                            onChange={handleChange(setScopeForm)}
                            name="exclusions"
                            rows={5}
                            hint="Elementos, actividades o resultados que explícitamente no están incluidos."
                        />
                    </div>

                    <div style={{ marginTop: 10 }}>
                        <ActionButton onClick={() => setShowScopeModal(false)} bg="#fff" color="#111827" border="1px solid #d1d5db">
                            Cancelar
                        </ActionButton>
                        <ActionButton onClick={saveScope} disabled={savingScope}>
                            {savingScope ? "Guardando..." : "Guardar alcance"}
                        </ActionButton>
                    </div>
                </ModalShell>

                {toast ? (
                    <div
                        style={{
                            position: "fixed",
                            right: 16,
                            bottom: 16,
                            zIndex: 12000,
                            minWidth: 320,
                            maxWidth: 540,
                            background: toast.type === "error" ? "#fee2e2" : "#dcfce7",
                            color: toast.type === "error" ? "#991b1b" : "#166534",
                            border: `1px solid ${toast.type === "error" ? "#fecaca" : "#bbf7d0"}`,
                            borderRadius: 12,
                            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                            padding: 14,
                        }}
                    >
                        <div style={{ fontWeight: 700, marginBottom: 4 }}>
                            {toast.type === "error" ? "Error" : "Correcto"}
                        </div>
                        <div>{toast.msg}</div>
                    </div>
                ) : null}
            </div>
        </MainLayout>
    );
}

export default ProjectDetailPage;
